{
	"dialog.ok": "ตกลง",
	"dialog.cancel": "ยกเลิก",
	"dialog.confirm": "ยืนยัน",
	"dialog.close": "ปิด",
	"dialog.import": "นำเข้า",
	"dialog.save": "บันทึก",
	"dialog.discard": "ละทิ้ง",
	"dialog.dontshowagain": "ไม่ต้องแสดงอีก",
	"data.cube": "คิวบ์",
	"data.group": "กลุ่ม",
	"data.texture": "เทกซ์เจอร์",
	"data.plugin": "ปลั๊กอิน",
	"data.preview": "ตัวอย่าง",
	"data.toolbar": "แถบเครื่องมือ",
	"data.image": "รูปภาพ",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Delete",
	"keys.space": "Space",
	"keys.leftclick": "คลิกซ้าย",
	"keys.middleclick": "เมาส์กลาง",
	"keys.rightclick": "คลิกขวา",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Numpad %0",
	"keys.caps": "Capslock",
	"keys.menu": "Menu",
	"keys.left": "Left",
	"keys.up": "Up",
	"keys.right": "Right",
	"keys.down": "Down",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Comma",
	"keys.point": "Point",
	"keys.minus": "Minus",
	"keys.cross": "Cross",
	"keys.end": "End",
	"keys.pos1": "Home",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pause",
	"message.rotation_limit.title": "ขีดจำกัดการหมุน",
	"message.rotation_limit.message": "Minecraft จำกัดให้แต่ละชิ้นงานหมุนได้เพียงแกนเดียว เมื่อหมุนแกนใหม่ ค่าการหมุนของแกนอื่นจะถูกล้าง หากต้องการหมุนอย่างอิสระเพื่อใช้งานอื่น ให้แปลงโปรเจกต์เป็น 'โมเดลทั่วไป'",
	"message.file_not_found.title": "ไม่พบไฟล์",
	"message.file_not_found.message": "Blockbench ไม่พบไฟล์ที่ต้องการเปิด ตรวจสอบว่าไฟล์อยู่ในเครื่องและไม่ได้เก็บไว้เฉพาะบนคลาวด์",
	"message.screenshot.title": "ภาพหน้าจอ",
	"message.screenshot.clipboard": "คลิปบอร์ด",
	"message.screenshot.right_click": "คลิกขวาหรือกดค้างที่ภาพหน้าจอเพื่อคัดลอก",
	"message.invalid_file.title": "ไฟล์ไม่ถูกต้อง",
	"message.invalid_file.message": "ไม่สามารถเปิดไฟล์ json: %0",
	"message.invalid_model.title": "ไฟล์โมเดลไม่ถูกต้อง",
	"message.invalid_model.message": "ไฟล์นี้ไม่มีข้อมูลโมเดลที่ถูกต้อง",
	"message.child_model_only.title": "ไม่มีรูปทรงในโมเดลลูก",
	"message.child_model_only.message": "ไฟล์นี้อ้างอิงโมเดลแม่ %0 และไม่มีรูปทรงของตัวเอง",
	"message.unsaved_textures.title": "เทกซ์เจอร์ที่ยังไม่ได้บันทึก",
	"message.unsaved_textures.message": "โมเดลนี้มีเทกซ์เจอร์ที่ยังไม่ได้บันทึก โปรดบันทึกเทกซ์เจอร์ลงในโฟลเดอร์ที่ถูกต้องของแพ็คทรัพยากร",
	"message.model_clipping.title": "โมเดลใหญ่เกินไป",
	"message.model_clipping.message": "โมเดลนี้มีคิวบ์ %0 ชิ้นที่ใหญ่เกินขนาดบล็อกที่ Minecraft รองรับ จึงไม่สามารถใช้โมเดลนี้ในเกมได้",
	"message.loose_texture.title": "นำเข้าเทกซ์เจอร์",
	"message.loose_texture.message": "เทกซ์เจอร์ที่นำเข้าอยู่นอกแพ็คทรัพยากร Minecraft โหลดเทกซ์เจอร์ได้เฉพาะจากโฟลเดอร์ textures ในแพ็คทรัพยากรที่ใช้งานอยู่",
	"message.loose_texture.change": "เปลี่ยนเส้นทาง",
	"message.update_res.title": "ความละเอียดเทกซ์เจอร์",
	"message.update_res.message": "ต้องการปรับความละเอียดของโปรเจกต์ให้ตรงกับเทกซ์เจอร์นี้หรือไม่? หากตั้งใจใช้เทกซ์เจอร์ความละเอียดสูง ให้คลิก 'ยกเลิก'",
	"message.update_res.update": "อัปเดต",
	"message.bedrock_overwrite_error.message": "Blockbench ไม่สามารถรวมโมเดลนี้กับไฟล์เก่าได้",
	"message.bedrock_overwrite_error.backup_overwrite": "สำรองไฟล์แล้วเขียนทับ",
	"message.bedrock_overwrite_error.overwrite": "เขียนทับ",
	"message.close_warning.message": "คุณต้องการบันทึกโมเดลหรือไม่?",
	"message.close_warning.web": "งานที่ยังไม่ได้บันทึกจะหายไป ต้องการออกหรือไม่?",
	"message.default_textures.title": "เทกซ์เจอร์เริ่มต้น",
	"message.default_textures.message": "เลือกโฟลเดอร์ 'textures' ของแพ็คทรัพยากรเริ่มต้น",
	"message.default_textures.detail": "แตกไฟล์แพ็คทรัพยากรเริ่มต้นจากไฟล์ Minecraft jar หรือดาวน์โหลดแพ็คมา จากนั้นเปิดโฟลเดอร์ 'textures' ของแพ็ค Blockbench จะจำโฟลเดอร์นี้ไว้ค้นหาเทกซ์เจอร์ที่หาไม่พบในแพ็คทรัพยากรปัจจุบัน",
	"message.default_textures.select": "เลือกโฟลเดอร์ 'textures' เริ่มต้น",
	"message.image_editor.title": "เลือกโปรแกรมแต่งภาพ",
	"message.image_editor.file": "เลือกไฟล์...",
	"message.image_editor.exe": "เลือกไฟล์โปรแกรมแต่งภาพ",
	"message.display_skin.title": "สกิน Minecraft",
	"message.display_skin.message": "เลือกไฟล์สกินจากคอมพิวเตอร์ของคุณหรือป้อนชื่อผู้เล่น",
	"message.display_skin.upload": "เลือกไฟล์",
	"message.display_skin.reset": "รีเซ็ต",
	"message.invalid_plugin": "ไฟล์ปลั๊กอินไม่ถูกต้อง ดูรายละเอียดในคอนโซล",
	"message.load_plugin_app": "ต้องการอนุญาตให้ปลั๊กอินนี้เปลี่ยนแปลงข้อมูลในคอมพิวเตอร์หรือไม่? โหลดเฉพาะปลั๊กอินจากผู้สร้างที่คุณเชื่อถือ",
	"message.load_plugin_web": "คุณต้องการโหลดปลั๊กอินนี้หรือไม่? โหลดปลั๊กอินจากผู้สร้างที่คุณเชื่อถือเท่านั้น",
	"message.preset_no_info": "พรีเซ็ตไม่มีข้อมูลสำหรับช่องนี้",
	"message.restart_to_update": "รีสตาร์ท Blockbench เพื่อใช้การเปลี่ยนแปลง",
	"message.save_file": "บันทึกเป็น %0 แล้ว",
	"dialog.project.title": "โปรเจกต์",
	"dialog.project.name": "ชื่อไฟล์",
	"dialog.project.parent": "โมเดลแม่",
	"dialog.project.geoname": "ตัวระบุโมเดล",
	"dialog.project.ao": "เงาตามซอก (Ambient Occlusion)",
	"dialog.texture.title": "เทกซ์เจอร์",
	"dialog.texture.variable": "ตัวแปร",
	"dialog.texture.namespace": "เนมสเปซ",
	"dialog.texture.folder": "โฟลเดอร์",
	"dialog.extrude.title": "สร้างรูปทรงจากภาพ",
	"dialog.extrude.mode": "โหมดสแกน",
	"dialog.extrude.mode.areas": "พื้นที่",
	"dialog.extrude.mode.lines": "เส้น",
	"dialog.extrude.mode.columns": "คอลัมน์",
	"dialog.extrude.mode.pixels": "พิกเซล",
	"dialog.extrude.opacity": "ความทึบต่ำสุด",
	"dialog.extrude.scan": "สแกนและนำเข้า",
	"dialog.display_preset.title": "สร้างพรีเซ็ต",
	"dialog.display_preset.message": "เลือกช่องที่คุณต้องการบันทึก",
	"dialog.display_preset.create": "สร้าง",
	"dialog.select.title": "เลือก",
	"dialog.select.group": "ในกลุ่มที่เลือก",
	"dialog.select.name": "ชื่อมีข้อความ",
	"dialog.select.random": "โอกาสในการสุ่มเลือก (%)",
	"dialog.select.select": "เลือก",
	"dialog.scale.title": "ปรับขนาดโมเดล",
	"dialog.scale.axis": "แกน",
	"dialog.scale.clipping": "โมเดลใหญ่เกินพื้นที่ที่รองรับ บางส่วนอาจถูกตัดออก",
	"dialog.scale.confirm": "ปรับขนาด",
	"dialog.plugins.title": "ปลั๊กอิน",
	"dialog.plugins.installed": "ติดตั้งแล้ว",
	"dialog.plugins.available": "พร้อมใช้งาน",
	"dialog.plugins.install": "ติดตั้ง",
	"dialog.plugins.uninstall": "ถอนการติดตั้ง",
	"dialog.plugins.reload": "โหลดใหม่",
	"dialog.plugins.none_installed": "ยังไม่ได้ติดตั้งปลั๊กอิน",
	"dialog.plugins.none_available": "ไม่มีปลั๊กอินให้ติดตั้ง",
	"dialog.plugins.web_only": "สำหรับเว็บแอปเท่านั้น",
	"dialog.plugins.app_only": "สำหรับแอปเดสก์ท็อปเท่านั้น",
	"dialog.plugins.author": "โดย %0",
	"dialog.create_texture.folder": "โฟลเดอร์",
	"dialog.create_texture.resolution": "ความละเอียด",
	"dialog.input.title": "ป้อนข้อมูล",
	"dialog.settings.settings": "การตั้งค่า",
	"dialog.settings.keybinds": "แป้นพิมพ์ลัด",
	"dialog.settings.about": "เกี่ยวกับ",
	"layout.color.back": "พื้นหลัง",
	"layout.color.back.desc": "พื้นหลังและช่องป้อนข้อมูล",
	"layout.color.dark": "มืด",
	"layout.color.dark.desc": "พื้นหลังแคนวาส",
	"layout.color.ui": "หน้าตาโปรแกรม",
	"layout.color.ui.desc": "สีหน้าตาโปรแกรมหลัก",
	"layout.color.bright_ui": "ส่วนสว่างของหน้าตาโปรแกรม",
	"layout.color.bright_ui.desc": "เมนูคลิกขวาและข้อความแนะนำเครื่องมือ",
	"layout.color.button": "ปุ่ม",
	"layout.color.button.desc": "ปุ่มและสวิตช์",
	"layout.color.selected": "รายการที่เลือก",
	"layout.color.selected.desc": "แท็บและวัตถุที่ถูกเลือก",
	"layout.color.border": "ขอบ",
	"layout.color.border.desc": "ขอบของปุ่มและช่องป้อนข้อมูล",
	"layout.color.accent": "สีเน้น",
	"layout.color.accent.desc": "ปุ่มเลื่อนบนแถบปรับค่าและรายละเอียดอื่น ๆ",
	"layout.color.grid": "กริด",
	"layout.color.grid.desc": "กริดในมุมมอง 3D",
	"layout.color.text": "ข้อความ",
	"layout.color.text.desc": "ข้อความปกติ",
	"layout.color.light": "สว่าง",
	"layout.color.light.desc": "ข้อความที่ไฮไลต์",
	"layout.color.accent_text": "ข้อความสีเน้น",
	"layout.color.accent_text.desc": "ข้อความบนพื้นหลังสีเน้น",
	"layout.font.main": "ฟอนต์หลัก",
	"layout.font.headline": "ฟอนต์หัวข้อ",
	"about.version": "เวอร์ชัน:",
	"settings.category.general": "ทั่วไป",
	"settings.category.preview": "ตัวอย่าง",
	"settings.category.grid": "กริด",
	"settings.category.edit": "แก้ไข",
	"settings.category.snapping": "สแนปตำแหน่ง",
	"settings.category.defaults": "ค่าเริ่มต้น",
	"settings.category.dialogs": "กล่องโต้ตอบ",
	"settings.category.export": "ส่งออก",
	"settings.language": "ภาษา",
	"settings.language.desc": "ภาษาที่ใช้ในโปรแกรม",
	"settings.backup_interval": "ความถี่ในการสำรองข้อมูล",
	"settings.backup_interval.desc": "สำรองข้อมูลอัตโนมัติทุกกี่นาที",
	"settings.origin_size": "ขนาดเครื่องหมายจุดหมุน",
	"settings.origin_size.desc": "ขนาดของเครื่องหมายจุดหมุน",
	"settings.control_size": "ขนาดตัวควบคุมบนโมเดล",
	"settings.control_size.desc": "ขนาดลูกศร แกนหมุน และตัวควบคุมที่ใช้ปรับโมเดล",
	"settings.display_skin": "สกิน Minecraft",
	"settings.display_skin.desc": "สกินที่ใช้กับโมเดลผู้เล่นอ้างอิง",
	"settings.shading": "แรเงา",
	"settings.shading.desc": "เปิดใช้งานการแรเงาในมุมมองตัวอย่าง",
	"settings.base_grid": "กริดเล็ก",
	"settings.base_grid.desc": "แสดงกริดเล็กและแกน",
	"settings.large_grid": "กริดบล็อก",
	"settings.large_grid.desc": "แสดงกริดที่แต่ละช่องมีขนาดเท่าหนึ่งบล็อก (ปกติ 16×16 หน่วย)",
	"settings.full_grid": "กริดบล็อกแบบละเอียด",
	"settings.full_grid.desc": "แสดงกริดบล็อกที่แบ่งช่องละเอียดถึงระดับพิกเซล",
	"settings.large_box": "กรอบแสดงขนาดสูงสุด",
	"settings.large_box.desc": "แสดงกรอบขนาดสูงสุดที่โมเดลใช้ได้",
	"settings.display_grid": "กริดโหมดแสดงผล",
	"settings.display_grid.desc": "แสดงกริดในโหมดแสดงผล",
	"settings.undo_limit": "ขีดจำกัดการเลิกทำ",
	"settings.undo_limit.desc": "จำนวนสูงสุดของขั้นตอนที่สามารถเลิกทำได้",
	"settings.local_move": "ย้ายตามแกนของชิ้นงาน",
	"settings.local_move.desc": "เมื่อทำได้ ให้ย้ายชิ้นงานที่หมุนแล้วตามแนวแกนของชิ้นงานเอง",
	"settings.canvas_unselect": "ยกเลิกการเลือกเมื่อคลิกพื้นหลัง",
	"settings.canvas_unselect.desc": "ยกเลิกการเลือกชิ้นงานทั้งหมดเมื่อคลิกบนพื้นหลังด้านหลังโมเดลหรือในไทม์ไลน์",
	"settings.paint_side_restrict": "ระบายสีเฉพาะด้านปัจจุบัน",
	"settings.paint_side_restrict.desc": "ให้แปรงระบายสีได้เฉพาะด้านที่กำลังทำงานอยู่",
	"settings.autouv": "UV อัตโนมัติ",
	"settings.autouv.desc": "เปิดใช้ UV อัตโนมัติโดยค่าเริ่มต้น",
	"settings.create_rename": "เปลี่ยนชื่อชิ้นงานใหม่",
	"settings.create_rename.desc": "เลือกช่องชื่อให้พร้อมพิมพ์เมื่อสร้างชิ้นงานหรือกลุ่มใหม่",
	"settings.edit_size": "ความละเอียดกริด",
	"settings.edit_size.desc": "ความละเอียดของกริดที่ใช้กำหนดระยะการขยับชิ้นงาน",
	"settings.shift_size": "ความละเอียดกริดเมื่อกด Shift",
	"settings.shift_size.desc": "ความละเอียดของกริดขณะกด Shift",
	"settings.ctrl_size": "ความละเอียดกริดเมื่อกด Ctrl",
	"settings.ctrl_size.desc": "ความละเอียดของกริดขณะกด Ctrl",
	"settings.negative_size": "อนุญาตขนาดติดลบ",
	"settings.negative_size.desc": "ให้เครื่องมือปรับขนาดกำหนดขนาดเป็นค่าติดลบได้",
	"settings.minifiedout": "ส่งออกแบบย่อ",
	"settings.minifiedout.desc": "เขียนไฟล์ JSON ในหนึ่งบรรทัด",
	"settings.export_groups": "ส่งออกกลุ่มในโมเดลบล็อก/ไอเทม Java",
	"settings.export_groups.desc": "บันทึกกลุ่มในไฟล์ JSON โมเดลบล็อกหรือไอเทม Java",
	"settings.credit": "เครดิตผู้สร้าง",
	"settings.credit.desc": "เพิ่มเครดิตผู้สร้างเป็นคอมเมนต์ในไฟล์ที่ส่งออก",
	"settings.default_path": "เส้นทางเทกซ์เจอร์ Minecraft เริ่มต้น",
	"settings.default_path.desc": "โฟลเดอร์ที่ Blockbench โหลดเทกซ์เจอร์เริ่มต้น",
	"settings.image_editor": "โปรแกรมแต่งภาพ",
	"settings.image_editor.desc": "โปรแกรมแต่งภาพที่ใช้เปิดแก้ไขเทกซ์เจอร์เป็นค่าเริ่มต้น",
	"category.navigate": "การนำทาง",
	"category.tools": "เครื่องมือ",
	"category.file": "ไฟล์",
	"category.blockbench": "Blockbench",
	"category.edit": "แก้ไข",
	"category.transform": "ย้าย / หมุน / ปรับขนาด",
	"category.view": "มุมมอง",
	"category.display": "ตั้งค่าการแสดงผล",
	"category.textures": "เทกซ์เจอร์",
	"category.misc": "อื่น ๆ",
	"keybind.preview_select": "เลือก",
	"keybind.preview_rotate": "หมุนมุมมอง",
	"keybind.preview_drag": "ลากมุมมอง",
	"keybind.confirm": "ยืนยัน",
	"keybind.cancel": "ยกเลิก",
	"action.slider_inflate": "ขยายผิว",
	"action.slider_inflate.desc": "ขยายผิวคิวบ์ออกทุกด้านโดยไม่เปลี่ยน UV",
	"action.slider_brush_size": "ขนาดแปรง",
	"action.slider_brush_size.desc": "รัศมีของแปรงเป็นพิกเซล",
	"action.slider_brush_opacity": "ความทึบ",
	"action.slider_brush_opacity.desc": "ความทึบของแปรงตั้งแต่ 0 ถึง 255",
	"action.slider_brush_softness": "ความนุ่ม",
	"action.slider_brush_softness.desc": "ความนุ่มของแปรงเป็นเปอร์เซ็นต์",
	"action.uv_slider_pos_x": "ย้ายแนวนอน",
	"action.uv_slider_pos_x.desc": "ย้ายหน้า UV ที่เลือกทั้งหมดแนวนอน",
	"action.uv_slider_pos_y": "ย้ายแนวตั้ง",
	"action.uv_slider_pos_y.desc": "ย้ายหน้า UV ที่เลือกทั้งหมดแนวตั้ง",
	"action.uv_slider_size_x": "ขนาดแนวนอน",
	"action.uv_slider_size_x.desc": "ปรับขนาดหน้า UV ที่เลือกทั้งหมดแนวนอน",
	"action.uv_slider_size_y": "ขนาดแนวตั้ง",
	"action.uv_slider_size_y.desc": "ปรับขนาดหน้า UV ที่เลือกทั้งหมดแนวตั้ง",
	"action.vertex_snap_mode": "วิธีสแนปจุดยอด",
	"action.vertex_snap_mode.desc": "เลือกว่าจะย้าย ปรับขนาด หรือหมุนชิ้นงาน เพื่อให้จุดยอดตรงกับตำแหน่งที่เลือก",
	"action.move_tool": "เครื่องมือย้าย",
	"action.move_tool.desc": "เลือกและย้ายชิ้นงาน",
	"action.resize_tool": "เครื่องมือปรับขนาด",
	"action.resize_tool.desc": "เลือกและปรับขนาดชิ้นงาน",
	"action.brush_tool": "เครื่องมือแปรง",
	"action.brush_tool.desc": "ใช้แปรงระบายสีบนเทกซ์เจอร์",
	"action.vertex_snap_tool": "สแนปจุดยอด",
	"action.vertex_snap_tool.desc": "จัดจุดยอดให้ตรงกับจุดยอดอื่น",
	"action.swap_tools": "สลับเครื่องมือ",
	"action.swap_tools.desc": "สลับเครื่องมือคู่กัน เช่น ย้ายกับปรับขนาด หรือแปรงกับหลอดดูดสี",
	"action.project_window": "โปรเจกต์...",
	"action.project_window.desc": "เปิดหน้าต่างสำหรับแก้ไขชื่อและรายละเอียดของโมเดล",
	"action.open_model": "เปิดโมเดล",
	"action.open_model.desc": "เปิดไฟล์โมเดลจากคอมพิวเตอร์ของคุณ",
	"action.extrude_texture": "สร้างรูปทรงจากเทกซ์เจอร์",
	"action.extrude_texture.desc": "สร้างโมเดลโดยเพิ่มความหนาให้รูปภาพเทกซ์เจอร์",
	"action.export_blockmodel": "ส่งออกโมเดลบล็อก/ไอเทม",
	"action.export_blockmodel.desc": "ส่งออกโมเดลบล็อกหรือไอเทม Minecraft Java Edition",
	"action.export_optifine_part": "ส่งออกส่วน OptiFine",
	"action.export_optifine_part.desc": "ส่งออกส่วนเดียวสำหรับโมเดลเอนทิตี OptiFine",
	"action.export_optifine_full": "ส่งออก OptiFine JEM",
	"action.export_optifine_full.desc": "ส่งออกโมเดลเอนทิตี OptiFine แบบเต็ม",
	"action.export_obj": "ส่งออกโมเดล OBJ",
	"action.export_obj.desc": "ส่งออกโมเดล Wavefront OBJ สำหรับเรนเดอร์",
	"action.settings_window": "การตั้งค่า...",
	"action.settings_window.desc": "เปิดกล่องโต้ตอบการตั้งค่า Blockbench",
	"action.plugins_window": "ปลั๊กอิน...",
	"action.plugins_window.desc": "เปิดหน้าต่างร้านปลั๊กอิน",
	"action.reset_layout": "รีเซ็ตเลย์เอาต์",
	"action.reset_layout.desc": "รีเซ็ตเลย์เอาต์เป็นค่าเริ่มต้นของ Blockbench",
	"action.load_plugin": "โหลดปลั๊กอินจากไฟล์",
	"action.load_plugin.desc": "โหลดปลั๊กอินจากไฟล์โค้ด",
	"action.reload_plugins": "โหลดปลั๊กอินใหม่",
	"action.reload_plugins.desc": "โหลดปลั๊กอินที่กำลังพัฒนาทั้งหมดใหม่",
	"action.undo": "เลิกทำ",
	"action.undo.desc": "ย้อนกลับการเปลี่ยนแปลงล่าสุด",
	"action.redo": "ทำซ้ำ",
	"action.redo.desc": "นำการเปลี่ยนแปลงที่เพิ่งเลิกทำกลับมา",
	"action.copy": "คัดลอก",
	"action.copy.desc": "คัดลอกส่วนที่เลือก ข้อมูลหน้า หรือค่าการแสดงผล",
	"action.paste": "วาง",
	"action.paste.desc": "วางส่วนที่เลือก ข้อมูลหน้า หรือค่าการแสดงผลจากคลิปบอร์ด",
	"action.cut": "ตัด",
	"action.cut.desc": "ตัดส่วนที่เลือก ข้อมูลหน้า หรือค่าการแสดงผลไปยังคลิปบอร์ด",
	"action.add_cube": "เพิ่มคิวบ์",
	"action.add_cube.desc": "เพิ่มคิวบ์ใหม่",
	"action.add_group": "เพิ่มกลุ่ม",
	"action.add_group.desc": "เพิ่มกลุ่มหรือกระดูกใหม่",
	"action.outliner_toggle": "แสดง/ซ่อนตัวเลือกเพิ่มเติม",
	"action.outliner_toggle.desc": "แสดงหรือซ่อนปุ่มตัวเลือกเพิ่มเติมในรายการชิ้นงาน",
	"action.duplicate": "ทำสำเนา",
	"action.delete": "ลบ",
	"action.sort_outliner": "เรียงรายการชิ้นงาน",
	"action.sort_outliner.desc": "เรียงรายการชิ้นงานตามตัวอักษร",
	"action.select_window": "เลือก...",
	"action.select_window.desc": "ค้นหาและเลือกชิ้นงานตามคุณสมบัติ",
	"action.invert_selection": "กลับการเลือก",
	"action.invert_selection.desc": "สลับรายการที่เลือกกับรายการที่ไม่ได้เลือก",
	"action.select_all": "เลือกทั้งหมด",
	"action.collapse_groups": "พับกลุ่มทั้งหมด",
	"action.collapse_groups.desc": "พับทุกกลุ่มและชิ้นงานที่มีรายการย่อยในรายการชิ้นงาน",
	"action.scale": "ปรับขนาด...",
	"action.scale.desc": "ปรับขนาดชิ้นงานที่เลือก",
	"action.toggle_visibility": "แสดง/ซ่อน",
	"action.toggle_visibility.desc": "แสดงหรือซ่อนชิ้นงานที่เลือก",
	"action.toggle_export": "เปิด/ปิดการส่งออก",
	"action.toggle_export.desc": "กำหนดว่าจะรวมชิ้นงานที่เลือกไว้ในไฟล์ที่ส่งออกหรือไม่",
	"action.toggle_autouv": "เปิด/ปิด UV อัตโนมัติ",
	"action.toggle_autouv.desc": "สลับการตั้งค่า UV อัตโนมัติของชิ้นงานที่เลือก",
	"action.toggle_shade": "เปิด/ปิดการแรเงา",
	"action.toggle_shade.desc": "เปิดหรือปิดการแรเงาของคิวบ์ที่เลือก",
	"action.rename": "เปลี่ยนชื่อ",
	"action.rename.desc": "เปลี่ยนชื่อชิ้นงานหรือกลุ่มที่เลือก",
	"action.add_display_preset": "พรีเซ็ตใหม่",
	"action.add_display_preset.desc": "เพิ่มพรีเซ็ตการตั้งค่าการแสดงผลใหม่",
	"action.fullscreen": "เต็มจอ",
	"action.fullscreen.desc": "สลับโหมดเต็มจอ",
	"action.zoom_in": "ขยายหน้าตาโปรแกรม",
	"action.zoom_in.desc": "ขยายเมนู ปุ่ม และข้อความในโปรแกรม",
	"action.zoom_out": "ย่อหน้าตาโปรแกรม",
	"action.zoom_out.desc": "ย่อเมนู ปุ่ม และข้อความในโปรแกรม",
	"action.zoom_reset": "คืนขนาดหน้าตาโปรแกรม",
	"action.zoom_reset.desc": "คืนค่าการซูมเป็นค่าเริ่มต้น 100%",
	"action.reset_interface": "รีเซ็ตหน้าตาโปรแกรม",
	"action.reset_interface.desc": "รีเซ็ตขนาดและตำแหน่งของหน้าตาโปรแกรม",
	"action.screenshot_model": "ถ่ายภาพโมเดล",
	"action.screenshot_model.desc": "ถ่ายภาพโมเดลจากมุมปัจจุบัน โดยตัดพื้นที่ว่างรอบภาพออก",
	"action.screenshot_app": "ถ่ายภาพหน้าจอโปรแกรม",
	"action.screenshot_app.desc": "ถ่ายภาพหน้าจอทั้งโปรแกรม",
	"action.import_texture": "นำเข้าเทกซ์เจอร์",
	"action.import_texture.desc": "นำเข้าเทกซ์เจอร์จากไฟล์",
	"action.create_texture": "สร้างเทกซ์เจอร์",
	"action.create_texture.desc": "สร้างเทกซ์เจอร์เปล่าหรือเทกซ์เจอร์จากเทมเพลต",
	"action.save_textures": "บันทึกเทกซ์เจอร์",
	"action.save_textures.desc": "บันทึกเทกซ์เจอร์ที่ยังไม่ได้บันทึกทั้งหมด",
	"action.animated_textures": "เล่นเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.animated_textures.desc": "เล่นหรือหยุดตัวอย่างเทกซ์เจอร์เคลื่อนไหวชั่วคราว",
	"action.origin_to_geometry": "จัดกึ่งกลางจุดหมุน",
	"action.origin_to_geometry.desc": "ตั้งจุดหมุนไปยังศูนย์กลางของส่วนที่เลือก",
	"action.bone_reset_toggle": "รีเซ็ตกระดูก",
	"action.bone_reset_toggle.desc": "ซ่อนคิวบ์จากโมเดลแม่ที่อยู่บนกระดูกนี้",
	"action.reload": "โหลด Blockbench ใหม่",
	"action.reload.desc": "โหลด Blockbench ใหม่ งานที่ยังไม่ได้บันทึกจะหายไป",
	"menu.file": "ไฟล์",
	"menu.edit": "แก้ไข",
	"menu.transform": "ปรับรูปทรง",
	"menu.display": "แสดงผล",
	"menu.view": "มุมมอง",
	"menu.file.new": "ใหม่",
	"menu.file.recent": "ไฟล์ล่าสุด",
	"menu.file.import": "นำเข้า",
	"menu.file.export": "ส่งออก",
	"menu.transform.rotate": "หมุน",
	"menu.transform.flip": "พลิก",
	"menu.transform.center": "จัดกึ่งกลาง",
	"menu.transform.properties": "คุณสมบัติ",
	"menu.display.preset": "ใช้พรีเซ็ต",
	"menu.display.preset_all": "ใช้พรีเซ็ตกับทุกช่อง",
	"menu.display.remove_preset": "ลบพรีเซ็ต",
	"menu.view.zoom": "ซูม",
	"menu.view.background": "พื้นหลัง",
	"menu.view.screenshot": "ภาพหน้าจอ",
	"menu.cube.color": "สีเครื่องหมาย",
	"menu.cube.texture": "เทกซ์เจอร์",
	"menu.cube.texture.transparent": "โปร่งใส",
	"menu.cube.texture.blank": "ว่างเปล่า",
	"menu.group.sort": "เรียงลำดับ",
	"menu.texture.face": "ใช้กับหน้า",
	"menu.texture.file": "ไฟล์",
	"menu.texture.refresh": "รีเฟรช",
	"menu.texture.change": "เปลี่ยนไฟล์",
	"menu.texture.folder": "แสดงในตัวสำรวจไฟล์",
	"menu.texture.edit": "แก้ไข",
	"menu.texture.export": "บันทึกเป็น",
	"menu.texture.save": "บันทึก",
	"menu.texture.properties": "คุณสมบัติ...",
	"menu.preview.background": "พื้นหลัง",
	"menu.preview.background.load": "โหลด",
	"menu.preview.background.position": "ตำแหน่ง",
	"menu.preview.background.lock": "ล็อกกับกล้อง",
	"menu.preview.screenshot": "ภาพหน้าจอ",
	"menu.preview.perspective": "มุมมองตามสายตา (Perspective)",
	"menu.preview.perspective.normal": "ปกติ",
	"menu.preview.quadview": "มุมมอง 4 ส่วน",
	"menu.preview.stop_drag": "หยุดปรับตำแหน่งพื้นหลัง",
	"menu.uv.mapping.rotation": "การหมุน",
	"menu.uv.texture": "เทกซ์เจอร์",
	"cube.color.light_blue": "ฟ้าอ่อน",
	"cube.color.yellow": "เหลือง",
	"cube.color.orange": "ส้ม",
	"cube.color.red": "แดง",
	"cube.color.purple": "ม่วง",
	"cube.color.blue": "น้ำเงิน",
	"cube.color.green": "เขียว",
	"cube.color.lime": "เขียวมะนาว",
	"switches.visibility": "แสดง/ซ่อน",
	"switches.export": "ส่งออก",
	"switches.autouv": "UV อัตโนมัติ",
	"panel.uv": "UV",
	"panel.display": "แสดงผล",
	"panel.textures": "เทกซ์เจอร์",
	"panel.outliner": "รายการชิ้นงาน",
	"uv_editor.title": "หน้าต่าง UV",
	"uv_editor.all_faces": "ทั้งหมด",
	"uv_editor.no_faces": "ไม่มี",
	"face.north": "เหนือ",
	"face.south": "ใต้",
	"face.west": "ตะวันตก",
	"face.east": "ตะวันออก",
	"face.up": "บน",
	"face.down": "ล่าง",
	"direction.north": "เหนือ",
	"direction.south": "ใต้",
	"direction.west": "ตะวันตก",
	"direction.east": "ตะวันออก",
	"direction.top": "บน",
	"direction.bottom": "ล่าง",
	"display.slot.third_right": "มือขวา — มุมมองบุคคลที่สาม",
	"display.slot.third_left": "มือซ้าย — มุมมองบุคคลที่สาม",
	"display.slot.first_right": "มือขวา — มุมมองบุคคลที่หนึ่ง",
	"display.slot.first_left": "มือซ้าย — มุมมองบุคคลที่หนึ่ง",
	"display.slot.head": "หัว",
	"display.slot.ground": "วางบนพื้น",
	"display.slot.frame": "กรอบไอเทม",
	"display.slot.gui": "ช่องไอเทมในเมนู",
	"display.rotation": "การหมุน",
	"display.translation": "ตำแหน่ง",
	"display.scale": "ขนาด",
	"display.slot": "ช่อง",
	"display.reference": "โมเดลอ้างอิง",
	"display.reference.player": "ผู้เล่น",
	"display.reference.zombie": "ซอมบี้",
	"display.reference.armor_stand": "แท่นเกราะ",
	"display.reference.baby_zombie": "ซอมบี้เด็ก",
	"display.reference.armor_stand_small": "แท่นเกราะเล็ก",
	"display.reference.monitor": "ปกติ",
	"display.reference.bow": "ธนูที่ง้างแล้ว",
	"display.reference.block": "บล็อก",
	"display.reference.frame": "กรอบไอเทม",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "ช่องเก็บของ",
	"display.reference.hud": "แถบไอเทมบนหน้าจอ (HUD)",
	"display.preset.blank_name": "กรุณาใส่ชื่อ",
	"display.preset.item": "ไอเทมเริ่มต้น",
	"display.preset.block": "บล็อกเริ่มต้น",
	"display.preset.handheld": "อาวุธเริ่มต้น",
	"display.preset.rod": "เบ็ดเริ่มต้น",
	"dialog.continue": "ดำเนินการต่อ",
	"message.square_textures": "เทกซ์เจอร์ต้องเป็นรูปสี่เหลี่ยมจัตุรัส",
	"message.unsaved_texture.title": "เทกซ์เจอร์ที่ยังไม่ได้บันทึก",
	"message.unsaved_texture.message": "การแก้ไขเทกซ์เจอร์ที่ยังไม่ได้บันทึกจะหายไป ต้องการทำต่อหรือไม่?",
	"action.vertex_snap_mode.move": "ย้าย",
	"action.vertex_snap_mode.scale": "ปรับขนาด",
	"action.open_model_folder": "เปิดโฟลเดอร์โมเดล",
	"action.open_model_folder.desc": "เปิดโฟลเดอร์ที่เก็บโมเดล",
	"action.change_textures_folder": "เปลี่ยนตำแหน่งเทกซ์เจอร์",
	"action.change_textures_folder.desc": "เปลี่ยนโฟลเดอร์ที่บันทึกเทกซ์เจอร์ทั้งหมด",
	"menu.texture.particle": "ใช้สำหรับอนุภาค",
	"message.update_notification.title": "ไม่สามารถติดตั้งอัปเดต",
	"message.update_notification.message": "มี Blockbench เวอร์ชันใหม่แล้ว เปิดการอัปเดตอัตโนมัติในการตั้งค่าเพื่ออัปเดตโปรแกรม",
	"message.untextured": "พื้นผิวนี้ไม่มีเทกซ์เจอร์",
	"dialog.toolbar_edit.title": "ปรับแต่งแถบเครื่องมือ",
	"keybindings.reset": "รีเซ็ต",
	"keybindings.clear": "ยกเลิกการตั้งค่า",
	"action.cube_counter": "สถิติโมเดล",
	"action.uv_rotation": "การหมุน UV",
	"action.uv_rotation.desc": "การหมุนของหน้า UV",
	"action.uv_grid": "กริด UV",
	"action.uv_grid.desc": "ความละเอียดของกริดที่ใช้จัดตำแหน่ง UV",
	"action.uv_grid.auto": "อัตโนมัติ",
	"action.uv_maximize": "ขยาย UV เต็มภาพ",
	"action.uv_maximize.desc": "ขยาย UV ของหน้านี้ให้เต็มภาพเทกซ์เจอร์",
	"action.uv_auto": "UV อัตโนมัติ",
	"action.uv_auto.desc": "ปรับขนาด UV ให้ตรงกับขนาดจริงของหน้านี้",
	"action.uv_rel_auto": "จัด UV ตามตำแหน่งหน้า",
	"action.uv_rel_auto.desc": "ปรับตำแหน่งและขนาด UV ให้ตรงกับตำแหน่งและขนาดจริงของหน้านี้",
	"action.uv_mirror_x": "สะท้อน UV X",
	"action.uv_mirror_x.desc": "สะท้อน UV ของหน้านี้บนแกน X",
	"action.uv_mirror_y": "สะท้อน UV Y",
	"action.uv_mirror_y.desc": "สะท้อน UV ของหน้านี้บนแกน Y",
	"action.uv_transparent": "ลบหน้า",
	"action.uv_transparent.desc": "ลบหน้าปัจจุบัน",
	"action.uv_reset": "รีเซ็ตหน้า",
	"action.uv_reset.desc": "รีเซ็ตหน้าปัจจุบัน",
	"action.cullface": "ซ่อนหน้าที่ถูกบัง",
	"action.cullface.desc": "ไม่แสดงหน้านี้เมื่อมีบล็อกบังอยู่ในทิศทางที่เลือก",
	"action.auto_cullface": "เปิดใช้การซ่อนหน้าที่ถูกบัง",
	"action.auto_cullface.desc": "ตั้งทิศทางการซ่อนของหน้านี้ให้ตรงกับทิศทางที่หน้าหันอยู่",
	"action.face_tint": "ย้อมสี",
	"action.face_tint.desc": "เปิดการย้อมสีให้หน้าปัจจุบัน",
	"menu.toolbar.edit": "ปรับแต่งแถบเครื่องมือ",
	"menu.toolbar.reset": "รีเซ็ตแถบเครื่องมือ",
	"uv_editor.rotated": "หมุนแล้ว",
	"uv_editor.auto_cull": "ใช้ทิศทางของหน้านี้",
	"uv_editor.copied": "คัดลอกหน้าแล้ว",
	"uv_editor.pasted": "วางหน้าแล้ว",
	"uv_editor.copied_x": "คัดลอก %0 หน้าแล้ว",
	"uv_editor.reset": "รีเซ็ตหน้า",
	"uv_editor.maximized": "ขยายเต็ม",
	"uv_editor.autouv": "ขนาดอัตโนมัติ",
	"uv_editor.mirrored": "สะท้อนแล้ว",
	"uv_editor.to_all": "นำไปใช้กับทุกหน้าแล้ว",
	"uv_editor.transparent": "ทำให้โปร่งใสแล้ว",
	"uv_editor.cullface_on": "เปิดการซ่อนหน้าที่ถูกบัง",
	"uv_editor.cullface_off": "ปิดการซ่อนหน้าที่ถูกบัง",
	"uv_editor.tint_on": "เปิดการย้อมสี",
	"uv_editor.tint_off": "ปิดการย้อมสี",
	"action.uv_apply_all": "ใช้กับหน้าทั้งหมด",
	"action.uv_apply_all.desc": "ใช้การตั้งค่าของหน้าปัจจุบันกับหน้าทั้งหมด",
	"message.image_editor_missing.title": "โปรแกรมแต่งภาพเริ่มต้น",
	"message.image_editor_missing.message": "เลือกไฟล์โปรแกรมแต่งภาพที่ต้องการใช้",
	"message.image_editor_missing.detail": "Blockbench ไม่พบโปรแกรมแต่งภาพในเครื่อง โปรดเลือกไฟล์โปรแกรมที่ต้องการใช้",
	"action.update_autouv": "อัปเดต UV อัตโนมัติ",
	"action.update_autouv.desc": "อัปเดตการแมป UV อัตโนมัติของคิวบ์ที่เลือก",
	"category.uv": "UV",
	"status_bar.saved": "บันทึกโมเดลแล้ว",
	"status_bar.unsaved": "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
	"action.move_up": "ย้ายขึ้น",
	"action.move_up.desc": "ย้ายชิ้นงานที่เลือกขึ้นตามมุมกล้องปัจจุบัน",
	"action.move_down": "ย้ายลง",
	"action.move_down.desc": "ย้ายชิ้นงานที่เลือกลงตามมุมกล้องปัจจุบัน",
	"action.move_left": "ย้ายซ้าย",
	"action.move_left.desc": "ย้ายชิ้นงานที่เลือกซ้ายตามมุมกล้องปัจจุบัน",
	"action.move_right": "ย้ายขวา",
	"action.move_right.desc": "ย้ายชิ้นงานที่เลือกขวาตามมุมกล้องปัจจุบัน",
	"action.move_forth": "ย้ายไปข้างหน้า",
	"action.move_forth.desc": "ย้ายชิ้นงานที่เลือกไปข้างหน้าตามมุมกล้องปัจจุบัน",
	"action.move_back": "ย้ายไปข้างหลัง",
	"action.move_back.desc": "ย้ายชิ้นงานที่เลือกไปข้างหลังตามมุมกล้องปัจจุบัน",
	"layout.color.wireframe": "โครงลวด",
	"layout.color.wireframe.desc": "เส้นมุมมองโครงลวด",
	"action.add_animation": "เพิ่มแอนิเมชัน",
	"action.add_animation.desc": "เพิ่มแอนิเมชันใหม่",
	"action.load_animation_file": "นำเข้าแอนิเมชัน",
	"action.load_animation_file.desc": "นำเข้าไฟล์แอนิเมชัน",
	"action.play_animation": "เล่นแอนิเมชัน",
	"action.play_animation.desc": "เล่นหรือหยุดแอนิเมชันชั่วคราว",
	"action.slider_keyframe_time": "เวลาของคีย์เฟรม",
	"action.slider_keyframe_time.desc": "เปลี่ยนเวลาของคีย์เฟรมที่เลือก",
	"timeline.rotation": "การหมุน",
	"timeline.position": "ตำแหน่ง",
	"timeline.scale": "ขนาด",
	"menu.keyframe.quaternion": "การหมุนแบบ Quaternion",
	"panel.animations": "แอนิเมชัน",
	"panel.keyframe": "คีย์เฟรม",
	"panel.keyframe.type": "คีย์เฟรม (%0)",
	"generic.delete": "ลบ",
	"generic.rename": "เปลี่ยนชื่อ",
	"message.no_animation_selected": "คุณต้องเลือกแอนิเมชันก่อนจึงจะทำได้",
	"message.no_bone_selected": "คุณต้องเลือกกระดูกก่อนจึงจะทำได้",
	"message.duplicate_groups.title": "ชื่อกระดูกซ้ำ",
	"message.duplicate_groups.message": "มีกระดูกหลายชิ้นใช้ชื่อนี้ซ้ำกัน ซึ่งอาจทำให้เกิดปัญหาได้",
	"action.delete_keyframes": "ลบคีย์เฟรม",
	"action.delete_keyframes.desc": "ลบคีย์เฟรมที่เลือกทั้งหมด",
	"menu.animation": "แอนิเมชัน",
	"menu.animation.loop": "โหมดวนซ้ำ",
	"menu.animation.override": "แทนค่าจากแอนิเมชันก่อนหน้า",
	"menu.animation.anim_time_update": "สูตรกำหนดเวลาแอนิเมชัน",
	"message.display_skin_model.title": "โมเดลสกิน",
	"message.display_skin_model.message": "เลือกประเภทโมเดลของสกินของคุณ",
	"message.display_skin_model.classic": "แขนกว้าง (Classic)",
	"message.display_skin_model.slim": "แขนเล็ก (Slim)",
	"message.bone_material": "เปลี่ยนวัสดุกระดูก",
	"action.slider_animation_length": "ความยาวแอนิเมชัน",
	"action.slider_animation_length.desc": "เปลี่ยนความยาวของแอนิเมชันที่เลือก",
	"panel.variable_placeholders": "ค่าตัวแปรสำหรับดูตัวอย่าง",
	"status_bar.vertex_distance": "ระยะทาง: %0",
	"dialog.create_gif.title": "บันทึก GIF",
	"dialog.create_gif.length": "ความยาว",
	"dialog.create_gif.fps": "เฟรมต่อวินาที",
	"dialog.create_gif.play": "เล่นแอนิเมชัน",
	"category.animation": "แอนิเมชัน",
	"action.record_model_gif": "บันทึก GIF...",
	"action.record_model_gif.desc": "บันทึกภาพเคลื่อนไหวของโมเดลจากมุมปัจจุบันเป็น GIF",
	"display.mirror": "สะท้อน",
	"data.separator": "ตัวคั่น",
	"menu.preview.background.set_position": "ตั้งตำแหน่ง",
	"dialog.toolbar_edit.hidden": "ซ่อน",
	"action.export_class_entity": "ส่งออกเอนทิตี Java",
	"action.export_class_entity.desc": "ส่งออกโมเดลเอนทิตีเป็นคลาส Java",
	"settings.seethrough_outline": "เส้นขอบแบบเอกซเรย์",
	"settings.seethrough_outline.desc": "แสดงเส้นขอบทะลุวัตถุ",
	"mode.edit": "แก้ไข",
	"mode.paint": "ระบายสี",
	"mode.display": "การแสดงผล",
	"mode.animate": "แอนิเมชัน",
	"status_bar.recording_gif": "กำลังบันทึก",
	"status_bar.processing_gif": "กำลังประมวลผล",
	"settings.backup_retain": "ระยะเวลาเก็บไฟล์สำรอง",
	"settings.backup_retain.desc": "จำนวนวันที่ Blockbench จะเก็บไฟล์สำรองไว้",
	"action.rotate_tool": "เครื่องมือหมุน",
	"action.rotate_tool.desc": "เลือกและหมุนชิ้นงาน",
	"action.fill_tool": "เครื่องมือเติมสี",
	"action.fill_tool.desc": "เติมสีในพื้นที่",
	"action.eraser": "ยางลบ",
	"action.eraser.desc": "ลบสีบนเทกซ์เจอร์ให้โปร่งใส",
	"action.color_picker": "หลอดดูดสี",
	"action.color_picker.desc": "ดูดสีจากพิกเซลบนเทกซ์เจอร์",
	"switches.mirror": "สะท้อน UV",
	"language_name": "ภาษาไทย",
	"message.plugin_reload": "โหลดปลั๊กอินในเครื่อง %0 ตัวใหม่แล้ว",
	"settings.brightness": "ความสว่าง",
	"settings.brightness.desc": "ความสว่างในมุมมองตัวอย่าง ค่าเริ่มต้นคือ 50",
	"menu.preview.perspective.reset": "รีเซ็ตกล้อง",
	"action.fill_mode": "โหมดเติมสี",
	"action.fill_mode.face": "ทั้งหน้า",
	"action.fill_mode.color": "ทุกพิกเซลที่มีสีเดียวกัน",
	"action.toggle_mirror_uv": "สะท้อน UV",
	"action.toggle_mirror_uv.desc": "สลับการสะท้อน UV บนแกน X ของคิวบ์ที่เลือก",
	"menu.texture.blank": "ใช้กับหน้าที่ไม่มีเทกซ์เจอร์",
	"dialog.scale.select_overflow": "เลือกส่วนที่เกินขอบเขต",
	"action.action_control": "ค้นหาคำสั่ง",
	"action.action_control.desc": "ค้นหาและเรียกใช้คำสั่งในโปรแกรม",
	"keybindings.recording": "กำลังบันทึกแป้นพิมพ์ลัด",
	"keybindings.press": "กดปุ่มหรือชุดปุ่มที่ต้องการ หรือคลิกบนหน้าจอ เพื่อกำหนดปุ่มลัด",
	"action.pivot_tool": "เครื่องมือจุดหมุน",
	"action.pivot_tool.desc": "ย้ายจุดหมุนของชิ้นงานและกระดูก",
	"action.slider_animation_speed": "ความเร็วเล่นตัวอย่าง",
	"action.slider_animation_speed.desc": "ปรับความเร็วเล่นไทม์ไลน์เป็นเปอร์เซ็นต์",
	"action.previous_keyframe": "คีย์เฟรมก่อนหน้า",
	"action.previous_keyframe.desc": "ไปยังคีย์เฟรมก่อนหน้า",
	"action.next_keyframe": "คีย์เฟรมถัดไป",
	"action.next_keyframe.desc": "ไปยังคีย์เฟรมถัดไป",
	"message.outdated_client.title": "เวอร์ชันเก่า",
	"message.outdated_client.message": "กรุณาอัปเดตเป็นเวอร์ชันล่าสุดของ Blockbench เพื่อดำเนินการ",
	"action.export_asset_archive": "ดาวน์โหลดไฟล์รวม",
	"action.export_asset_archive.desc": "ดาวน์โหลดไฟล์บีบอัดที่รวมโมเดลและเทกซ์เจอร์ทั้งหมด",
	"action.upload_sketchfab": "อัปโหลดไป Sketchfab...",
	"message.sketchfab.name_or_token": "กรุณาป้อนโทเคน Sketchfab และชื่อ",
	"dialog.sketchfab_uploader.title": "อัปโหลดโมเดลไปยัง Sketchfab",
	"dialog.sketchfab_uploader.token": "โทเคน API",
	"dialog.sketchfab_uploader.about_token": "ใช้โทเคนเชื่อมต่อ Blockbench กับบัญชี Sketchfab ของคุณ หาโทเคนได้ที่ %0",
	"dialog.sketchfab_uploader.name": "ชื่อโมเดล",
	"dialog.sketchfab_uploader.description": "คำอธิบาย",
	"dialog.sketchfab_uploader.tags": "แท็ก",
	"settings.sketchfab_token": "โทเคน Sketchfab",
	"settings.sketchfab_token.desc": "โทเคนเพื่ออนุญาตให้ Blockbench อัปโหลดไปยังบัญชี Sketchfab ของคุณ",
	"panel.color": "สี",
	"data.origin": "จุดหมุน",
	"message.sketchfab.success": "อัปโหลดโมเดลสำเร็จ",
	"message.sketchfab.error": "อัปโหลดโมเดลไปยัง Sketchfab ล้มเหลว",
	"settings.outliner_colors": "สีในรายการชิ้นงาน",
	"settings.outliner_colors.desc": "แสดงสีของชิ้นงานและกลุ่มในรายการชิ้นงาน",
	"action.upload_sketchfab.desc": "อัปโหลดโมเดลของคุณไป Sketchfab",
	"action.element_colors": "สีชิ้นงาน",
	"action.element_colors.desc": "แสดงสีของชิ้นงานในรายการชิ้นงาน",
	"texture.error.file": "ไม่พบไฟล์",
	"texture.error.parent": "ใช้ไฟล์เทกซ์เจอร์จากโมเดลแม่",
	"message.recover_backup.title": "กู้คืนโมเดล",
	"message.recover_backup.message": "Blockbench ถูกปิดโดยไม่ได้บันทึก คุณต้องการกู้คืนโมเดลหรือไม่?",
	"message.invalid_session.title": "โทเคนเซสชันไม่ถูกต้อง",
	"message.invalid_session.message": "เซสชันที่คุณพยายามเข้าร่วมหมดอายุแล้วหรือโทเคนที่ให้มาไม่ถูกต้อง",
	"dialog.create_texture.power": "ขนาดเป็นกำลังของ 2",
	"dialog.create_gif.turn": "ความเร็วหมุนรอบโมเดล",
	"action.edit_session": "ทำงานร่วมกัน",
	"action.edit_session.desc": "เปิดหน้าต่างสำหรับแก้ไขโมเดลร่วมกับคนอื่น",
	"action.reset_keyframe": "รีเซ็ตคีย์เฟรม",
	"action.reset_keyframe.desc": "รีเซ็ตค่าทั้งหมดของคีย์เฟรมที่เลือก",
	"dialog.edit_session.title": "ทำงานร่วมกัน",
	"edit_session.username": "ชื่อผู้ใช้",
	"edit_session.token": "โทเคน",
	"edit_session.about": "แก้ไขโมเดลร่วมกับคนอื่นผ่านอินเทอร์เน็ตได้ โดยสร้างเซสชันแล้วส่งโทเคนให้เพื่อนใช้เข้าร่วม",
	"edit_session.join": "เข้าร่วมเซสชัน",
	"edit_session.create": "สร้างเซสชัน",
	"edit_session.quit": "ออกจากเซสชัน",
	"edit_session.joined": "%0 เข้าร่วมเซสชันแล้ว",
	"edit_session.left": "%0 ออกจากเซสชันแล้ว",
	"edit_session.quit_session": "ออกจากเซสชันปัจจุบันแล้ว",
	"edit_session.status": "สถานะ",
	"edit_session.hosting": "กำลังเป็นเจ้าของเซสชัน",
	"edit_session.connected": "เชื่อมต่อกับเซสชันแล้ว",
	"dialog.sketchfab_uploader.private": "ส่วนตัว (Pro)",
	"dialog.sketchfab_uploader.password": "รหัสผ่าน (Pro)",
	"action.uv_select_all": "เลือกทั้งหมด",
	"action.uv_select_all.desc": "เลือกหน้าทั้งหมดในกล่องโต้ตอบ UV",
	"panel.chat": "แชท",
	"edit_session.welcome": "ยินดีต้อนรับสู่เซสชันของ %0",
	"dialog.yes": "ใช่",
	"dialog.no": "ไม่",
	"generic.remove": "ลบออก",
	"generic.download": "ดาวน์โหลด",
	"generic.search": "ค้นหา",
	"dates.today": "วันนี้",
	"dates.yesterday": "เมื่อวาน",
	"dates.this_week": "สัปดาห์นี้",
	"dates.weeks_ago": "%0 สัปดาห์ที่แล้ว",
	"mode.start.new": "สร้างใหม่",
	"mode.start.recent": "ไฟล์ล่าสุด",
	"format.free": "โมเดลทั่วไป",
	"format.free.desc": "โมเดลที่ไม่มีข้อจำกัดด้านรูปทรง ใช้กับเอนจินเกม งานเรนเดอร์ และงานอื่น ๆ",
	"format.java_block": "บล็อก/ไอเทม Java",
	"format.java_block.desc": "โมเดลบล็อกหรือไอเทมสำหรับ Minecraft Java Edition",
	"format.bedrock": "เอนทิตี Bedrock",
	"format.bedrock.desc": "โมเดลสำหรับเอนทิตีและไอเทมสวมใส่ใน Minecraft Bedrock Edition",
	"format.bedrock_old": "Bedrock รุ่นเก่า",
	"format.bedrock_old.desc": "โมเดลเอนทิตี Minecraft Bedrock Edition ก่อนเวอร์ชัน 1.12",
	"format.modded_entity": "เอนทิตีสำหรับม็อด",
	"format.modded_entity.desc": "โมเดลเอนทิตีสำหรับม็อด Minecraft สามารถส่งออกเป็นไฟล์คลาส .java ได้",
	"format.optifine_entity": "เอนทิตี OptiFine",
	"format.optifine_entity.desc": "โมเดลเอนทิตีกำหนดเองสำหรับม็อด OptiFine",
	"keys.mouse": "ปุ่มเมาส์ %0",
	"message.cleared_blank_faces.title": "หน้าว่างเปล่า",
	"message.cleared_blank_faces.message": "Blockbench พบคิวบ์ %0 ชิ้นที่ไม่มีเทกซ์เจอร์ ต้องการลบคิวบ์เหล่านี้หรือไม่?",
	"message.wireframe.enabled": "เปิดมุมมองโครงลวดแล้ว",
	"message.wireframe.disabled": "ปิดมุมมองโครงลวดแล้ว",
	"dialog.convert_project.title": "แปลงโปรเจกต์",
	"dialog.create_texture.double_use": "คงพื้นที่ UV ที่ใช้ร่วมกัน",
	"dialog.model_stats.title": "สถิติโมเดล",
	"dialog.model_stats.cubes": "คิวบ์",
	"dialog.model_stats.locators": "จุดอ้างอิง",
	"dialog.model_stats.groups": "กลุ่ม",
	"dialog.model_stats.vertices": "จุดยอด",
	"dialog.model_stats.faces": "หน้า",
	"settings.username": "ชื่อผู้ใช้",
	"settings.username.desc": "ชื่อที่แสดงเมื่อทำงานร่วมกับคนอื่น",
	"settings.painting_grid": "กริดสำหรับระบายสี",
	"settings.painting_grid.desc": "แสดงกริดบนชิ้นงานที่มีเทกซ์เจอร์ในโหมดระบายสี",
	"action.convert_project": "แปลงโปรเจกต์",
	"action.convert_project.desc": "แปลงโปรเจกต์ปัจจุบันเป็นรูปแบบอื่น",
	"action.close_project": "ปิดโปรเจกต์",
	"action.close_project.desc": "ปิดโปรเจกต์ที่เปิดอยู่",
	"action.export_bedrock": "ส่งออกโมเดล Bedrock",
	"action.export_bedrock.desc": "ส่งออกโมเดลเป็นไฟล์ geometry ของ Bedrock Edition",
	"action.save_project": "บันทึกโปรเจกต์",
	"action.save_project.desc": "บันทึกโมเดลปัจจุบันเป็นไฟล์โปรเจกต์",
	"action.save_project_as": "บันทึกโปรเจกต์เป็น",
	"action.save_project_as.desc": "บันทึกโมเดลปัจจุบันเป็นไฟล์โปรเจกต์ที่ตำแหน่งใหม่",
	"action.export_over": "บันทึกโมเดล",
	"action.export_over.desc": "บันทึกโมเดล เทกซ์เจอร์ และแอนิเมชันโดยเขียนทับไฟล์",
	"action.add_locator": "เพิ่มจุดอ้างอิง",
	"action.add_locator.desc": "เพิ่มจุดอ้างอิงสำหรับกำหนดตำแหน่งอนุภาค สายจูง และสิ่งอื่น ๆ บนโมเดล",
	"action.uv_turn_mapping": "หมุนการวาง UV",
	"action.uv_turn_mapping.desc": "หมุนการวาง UV 90 องศา",
	"action.remove_blank_faces": "ลบหน้าว่าง",
	"action.remove_blank_faces.desc": "ลบหน้าที่ไม่มีเทกซ์เจอร์ทั้งหมดของส่วนที่เลือก",
	"web.download_app": "ดาวน์โหลดแอป",
	"uv_editor.turned": "หมุนการวาง UV แล้ว",
	"display.reference.crossbow": "หน้าไม้ที่บรรจุแล้ว",
	"dialog.settings.search_results": "ผลการค้นหา",
	"settings.animation_snap": "ความละเอียดการวางคีย์เฟรม",
	"settings.animation_snap.desc": "จำนวนจังหวะต่อวินาทีที่ใช้วางคีย์เฟรมบนไทม์ไลน์ ค่าเริ่มต้นคือ 24 และปรับแยกสำหรับแต่ละแอนิเมชันได้",
	"action.import_optifine_part": "นำเข้าส่วน OptiFine",
	"action.import_optifine_part.desc": "นำเข้าโมเดลส่วนเอนทิตีสำหรับ OptiFine",
	"data.locator": "จุดอ้างอิง (Locator)",
	"mode.start.no_recents": "ยังไม่มีโมเดลที่เปิดล่าสุด",
	"panel.element": "ชิ้นงาน",
	"panel.element.position": "ตำแหน่ง",
	"panel.element.size": "ขนาด",
	"panel.element.origin": "จุดหมุน",
	"panel.element.rotation": "การหมุน",
	"message.canvas_limit_error.title": "โมเดลเกินขอบเขตที่รองรับ",
	"message.canvas_limit_error.message": "ทำรายการนี้ได้ไม่สมบูรณ์ เพราะรูปแบบโมเดลจำกัดพื้นที่ไว้ที่ 48 หน่วย ลองย้ายจุดหมุนเพื่อแก้ปัญหา",
	"data.effect": "เอฟเฟกต์",
	"generic.name": "ชื่อ",
	"settings.recent_projects": "จำนวนโมเดลล่าสุด",
	"settings.recent_projects.desc": "จำนวนโมเดลสูงสุดที่จะแสดงในรายการไฟล์ล่าสุด",
	"settings.volume": "ระดับเสียง",
	"settings.volume.desc": "ควบคุมระดับเสียงสำหรับเอฟเฟกต์เสียงในแอนิเมชัน",
	"action.clear_timeline": "ล้างไทม์ไลน์",
	"action.clear_timeline.desc": "ซ่อนกระดูกที่ไม่ได้เลือกทั้งหมดจากไทม์ไลน์",
	"action.select_effect_animator": "ทำแอนิเมชันเอฟเฟกต์",
	"action.select_effect_animator.desc": "เปิดไทม์ไลน์เพื่อเพิ่มเอฟเฟกต์เสียงและอนุภาค",
	"action.timeline_focus": "กรองช่อง",
	"action.timeline_focus.desc": "เลือกช่องแอนิเมชันที่จะแสดงในไทม์ไลน์",
	"timeline.particle": "อนุภาค",
	"timeline.sound": "เสียง",
	"timeline.effects": "เอฟเฟกต์",
	"data.format": "รูปแบบ",
	"format.optifine_part": "ส่วนโมเดล OptiFine",
	"format.optifine_part.desc": "ส่วน JPM สำหรับโมเดลเอนทิตี OptiFine",
	"action.reverse_keyframes": "กลับลำดับคีย์เฟรม",
	"action.reverse_keyframes.desc": "กลับลำดับคีย์เฟรมที่เลือก",
	"generic.help": "ช่วยเหลือ",
	"message.removed_faces": "ลบ %0 หน้าแล้ว",
	"dialog.sketchfab_uploader.draft": "ร่าง",
	"action.slider_pos": "ตำแหน่ง %0",
	"action.slider_pos.desc": "ย้ายชิ้นงานตามแกน %0",
	"action.slider_size": "ขนาด %0",
	"action.slider_size.desc": "ปรับขนาดชิ้นงานตามแกน %0",
	"action.slider_rotation": "การหมุน %0",
	"action.slider_rotation.desc": "หมุนชิ้นงานตามแกน %0",
	"action.slider_origin": "จุดหมุน %0",
	"action.slider_origin.desc": "ย้ายจุดหมุนตามแกน %0",
	"action.rotate_cw": "หมุน %0 +90",
	"action.rotate_cw.desc": "หมุนชิ้นงานที่เลือก 90° บนแกน %0",
	"action.rotate_ccw": "หมุน %0 -90",
	"action.rotate_ccw.desc": "หมุนชิ้นงานที่เลือก -90° บนแกน %0",
	"action.flip": "พลิก %0",
	"action.flip.desc": "พลิกชิ้นงานที่เลือกตามแกน %0",
	"action.center": "จัดกึ่งกลาง %0",
	"action.center.desc": "จัดชิ้นงานที่เลือกให้อยู่กึ่งกลางตามแกน %0",
	"action.bring_up_all_animations": "แสดงแทร็กที่มีแอนิเมชันทั้งหมด",
	"panel.bone": "กระดูก",
	"data.color": "สี",
	"generic.export": "ส่งออก",
	"generic.none": "ไม่มี",
	"status_bar.recording": "กำลังบันทึกไทม์แลปส์",
	"message.add_to_palette": "เพิ่มในชุดสีแล้ว",
	"message.size_modifiers": "กด Ctrl หรือ Shift ค้างไว้เพื่อปรับค่าให้ละเอียดขึ้น",
	"message.timelapse_start": "เริ่มไทม์แลปส์แล้ว",
	"message.timelapse_stop": "หยุดไทม์แลปส์แล้ว",
	"message.import_palette.replace_palette": "แทนที่ชุดสีเดิม",
	"message.import_palette.threshold": "เกณฑ์การรวมสีใกล้เคียง",
	"dialog.timelapse.interval": "ถ่ายภาพทุก (วินาที)",
	"dialog.timelapse.source": "แหล่งที่มา",
	"dialog.timelapse.source.interface": "หน้าจอโปรแกรม",
	"dialog.timelapse.source.locked": "มุมกล้องคงที่",
	"dialog.timelapse.destination": "โฟลเดอร์ปลายทาง",
	"layout.color.checkerboard": "ตารางหมากรุก",
	"layout.color.checkerboard.desc": "พื้นหลังของแคนวาสและหน้าต่าง UV",
	"layout.font.code": "ฟอนต์โค้ด",
	"layout.css": "CSS กำหนดเอง",
	"settings.category.paint": "ระบายสี",
	"settings.deactivate_size_limit": "ปิดใช้ขีดจำกัดขนาด",
	"settings.deactivate_size_limit.desc": "ยกเลิกขนาดสูงสุดที่รูปแบบโมเดลกำหนดไว้ คำเตือน: โมเดลที่ได้อาจใช้กับรูปแบบนั้นไม่ได้",
	"settings.brush_opacity_modifier": "ควบคุมความทึบด้วยปากกา",
	"settings.brush_opacity_modifier.desc": "เลือกวิธีใช้ปากกาปรับความทึบของแปรง",
	"settings.brush_size_modifier": "ควบคุมขนาดแปรงด้วยปากกา",
	"settings.brush_size_modifier.desc": "เลือกวิธีใช้ปากกาปรับขนาดแปรง",
	"settings.brush_modifier.pressure": "แรงกด",
	"settings.brush_modifier.tilt": "การเอียง",
	"category.color": "สี",
	"action.import_theme": "นำเข้าธีม",
	"action.export_theme": "ส่งออกธีม",
	"action.export_theme.desc": "สร้างไฟล์ธีมจากการตั้งค่าปัจจุบัน",
	"action.slider_color_h": "เฉดสี",
	"action.slider_color_s": "ความสดของสี",
	"action.slider_color_v": "ความสว่าง",
	"action.add_to_palette": "เพิ่มในชุดสี",
	"action.add_to_palette.desc": "เพิ่มสีที่เลือกในชุดสี",
	"action.import_palette": "นำเข้าชุดสี",
	"action.import_palette.desc": "นำเข้าไฟล์ชุดสี",
	"action.export_palette": "ส่งออกชุดสี",
	"action.export_palette.desc": "ส่งออกชุดสีเป็นไฟล์ .GPL",
	"action.generate_palette": "สร้างชุดสี...",
	"action.generate_palette.desc": "สร้างชุดสีจากเทกซ์เจอร์",
	"action.sort_palette": "เรียงชุดสี",
	"action.sort_palette.desc": "เรียงสีทั้งหมดในชุดสีตามสีและความสว่าง",
	"action.timelapse": "บันทึกไทม์แลปส์...",
	"action.timelapse.desc": "บันทึกขั้นตอนการสร้างโมเดลเป็นภาพต่อเนื่องสำหรับทำวิดีโอเร่งเวลา",
	"action.add_keyframe": "เพิ่มคีย์เฟรม",
	"action.add_keyframe.desc": "เพิ่มคีย์เฟรมให้แทร็กแอนิเมชันที่เลือก",
	"action.bring_up_all_animations.desc": "แสดงแทร็กทั้งหมดที่มีการแก้ไขแอนิเมชันในไทม์ไลน์",
	"timeline.timeline": "คำสั่ง",
	"menu.palette.load.default": "ค่าเริ่มต้น",
	"generic.import": "นำเข้า",
	"settings.brush_modifier.none": "ไม่มี",
	"action.export_entity": "ส่งออกเอนทิตี Bedrock",
	"action.export_entity.desc": "ส่งออกโมเดลเป็นโมเดลเอนทิตีสำหรับ Minecraft Bedrock Edition",
	"settings.highlight_cubes": "ไฮไลต์ชิ้นงาน",
	"settings.highlight_cubes.desc": "ไฮไลต์ชิ้นงานเมื่อชี้เมาส์หรือเลือก",
	"action.add_marker": "ตั้งเครื่องหมาย",
	"action.add_marker.desc": "ตั้งเครื่องหมายบนไทม์ไลน์",
	"timeline.pre_effect_script": "สคริปต์",
	"format.skin": "สกิน Minecraft",
	"format.skin.desc": "แก้ไขสกินผู้เล่นและเอนทิตี",
	"message.sketchfab.setup_guide": "ต้องการเรียนรู้วิธีตั้งค่าโมเดลใน Sketchfab หรือไม่? อ่าน %0",
	"dialog.skin.title": "สร้างสกิน Minecraft",
	"dialog.skin.model": "โมเดล",
	"action.toggle_skin_layer": "แสดง/ซ่อนสกินชั้นนอก",
	"action.toggle_skin_layer.desc": "แสดงหรือซ่อนชั้นหมวกและเสื้อผ้าของโมเดลสกิน",
	"action.gui_light": "แสงในช่องไอเทม",
	"action.gui_light.desc": "เลือกทิศทางแสงที่ส่องไอเทมในช่องเก็บของ",
	"action.gui_light.side": "แสงด้านข้าง",
	"action.gui_light.front": "แสงด้านหน้า",
	"action.move_keyframe_back": "เลื่อนคีย์เฟรมไปก่อนหน้า",
	"action.move_keyframe_forth": "เลื่อนคีย์เฟรมไปข้างหน้า",
	"menu.help": "ช่วยเหลือ",
	"menu.help.discord": "Discord",
	"menu.help.report_issue": "รายงานปัญหา",
	"menu.help.plugin_documentation": "เอกสาร API สำหรับปลั๊กอิน",
	"menu.help.search_action": "ค้นหาและเรียกใช้คำสั่ง",
	"menu.help.donate": "บริจาค",
	"menu.help.about": "เกี่ยวกับ",
	"menu.preview.background.clipboard": "โหลดจากคลิปบอร์ด",
	"dialog.ignore": "ข้าม",
	"generic.unset": "ยกเลิกการตั้งค่า",
	"message.invalid_builtin_parent.title": "โมเดลแม่ในตัวไม่ถูกต้อง",
	"message.invalid_builtin_parent.message": "นำการอ้างอิงโมเดลแม่ '%0' ที่ไม่ถูกต้องออกแล้ว เพื่อให้ส่งออกโมเดลได้",
	"dialog.resize_texture.fill": "เติมพื้นที่ด้วย",
	"dialog.resize_texture.fill.transparent": "โปร่งใส",
	"dialog.resize_texture.fill.color": "สี",
	"dialog.resize_texture.fill.repeat": "ทำซ้ำ",
	"dialog.scale.element_pivot": "จุดหมุนชิ้นงาน",
	"dialog.scale.selection_center": "จุดกึ่งกลางของส่วนที่เลือก",
	"dialog.create_gif.length_mode": "กำหนดความยาวจาก",
	"dialog.create_gif.length_mode.seconds": "วินาที",
	"dialog.create_gif.length_mode.frames": "เฟรม",
	"dialog.create_gif.length_mode.animation": "ความยาวแอนิเมชัน",
	"dialog.create_gif.length_mode.turntable": "การหมุนรอบโมเดล",
	"dialog.save_angle.projection": "รูปแบบมุมมอง",
	"dialog.save_angle.projection.perspective": "ตามสายตา (Perspective)",
	"dialog.save_angle.projection.orthographic": "เส้นขนาน (Orthographic)",
	"dialog.sketchfab_uploader.animations": "แอนิเมชัน",
	"dialog.settings.theme": "ธีม",
	"settings.category.interface": "หน้าตาโปรแกรม",
	"settings.preview_checkerboard": "พื้นหลังตารางหมากรุกในมุมมองโมเดล",
	"settings.preview_checkerboard.desc": "แสดงหรือซ่อนพื้นหลังตารางหมากรุกในมุมมองโมเดล",
	"settings.uv_checkerboard": "พื้นหลังตารางหมากรุกใน UV",
	"settings.uv_checkerboard.desc": "แสดงหรือซ่อนพื้นหลังตารางหมากรุกในหน้าต่าง UV",
	"category.paint": "ระบายสี",
	"action.fill_mode.color_connected": "พื้นที่สีเดียวกันที่ติดกัน",
	"action.draw_shape_type": "ประเภทรูปทรง",
	"action.draw_shape_type.rectangle": "สี่เหลี่ยมผืนผ้า",
	"action.draw_shape_type.rectangle_h": "สี่เหลี่ยมผืนผ้า (เฉพาะขอบ)",
	"action.draw_shape_type.ellipse": "วงรี",
	"action.draw_shape_type.ellipse_h": "วงรี (เฉพาะขอบ)",
	"action.draw_shape_type.line": "เส้น",
	"action.mirror_painting": "ระบายสีแบบสะท้อน",
	"action.mirror_painting.description": "สะท้อนสีที่ระบายไปยังอีกด้านของโมเดล",
	"action.lock_alpha": "ล็อกความโปร่งใส",
	"action.lock_alpha.description": "ระบายสีโดยไม่เปลี่ยนความโปร่งใสเดิมของพิกเซล",
	"action.draw_shape_tool": "วาดรูปทรง",
	"action.draw_shape_tool.desc": "เครื่องมือวาดรูปทรงง่ายๆ บนเทกซ์เจอร์",
	"action.export_gltf": "ส่งออกโมเดล glTF",
	"action.export_gltf.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ glTF สำหรับแชร์และเรนเดอร์",
	"action.transform_space": "แกนที่ใช้ปรับชิ้นงาน",
	"action.transform_space.desc": "เลือกระบบแกนที่ใช้ย้ายหรือปรับชิ้นงานและกระดูก",
	"action.transform_space.global": "แกนของฉาก (Global)",
	"action.transform_space.local": "แกนของชิ้นงาน (Local)",
	"action.toggle_camera_projection": "สลับรูปแบบมุมมองกล้อง",
	"action.toggle_camera_projection.desc": "สลับระหว่างมุมมองตามสายตา (Perspective) กับมุมมองเส้นขนาน (Orthographic)",
	"action.load_camera_angle": "มุมกล้อง: %0",
	"action.load_camera_angle.desc": "โหลดมุมกล้อง '%0'",
	"action.slider_face_tint": "หมายเลขการย้อมสี",
	"action.slider_face_tint.desc": "ตั้งหมายเลขการย้อมสีของหน้านี้ ใช้ -1 เพื่อไม่กำหนดค่า",
	"menu.help.quickstart": "ตัวช่วยเริ่มต้นด่วน",
	"menu.help.developer": "นักพัฒนา",
	"menu.help.developer.dev_tools": "เปิดเครื่องมือนักพัฒนา",
	"menu.help.developer.reset_storage": "คืนค่าเริ่มต้นทั้งหมด",
	"menu.help.developer.reset_storage.confirm": "คุณแน่ใจหรือไม่ว่าต้องการรีเซ็ต Blockbench เป็นค่าจากโรงงาน? การดำเนินการนี้จะลบการตั้งค่า แป้นพิมพ์ลัด และปลั๊กอินที่ติดตั้งทั้งหมด",
	"menu.help.developer.cache_reload": "โหลดแคชใหม่",
	"menu.preview.orthographic": "มุมมองเส้นขนาน (Orthographic)",
	"menu.preview.save_angle": "บันทึกมุม...",
	"menu.preview.angle": "มุม",
	"menu.preview.angle.initial": "มุมเริ่มต้น",
	"menu.preview.maximize": "ขยายใหญ่สุด",
	"uv_editor.copy_selection": "คัดลอกส่วนที่เลือก",
	"uv_editor.paste_selection": "วางส่วนที่เลือก",
	"uv_editor.copy_paste_tool.place": "วาง",
	"uv_editor.copy_paste_tool.mirror_x": "สะท้อน X",
	"uv_editor.copy_paste_tool.mirror_y": "สะท้อน Y",
	"uv_editor.copy_paste_tool.rotate": "หมุน 90 องศา",
	"dialog.project.modded_entity_version": "เวอร์ชันที่ใช้ส่งออก",
	"dialog.save_angle.position": "ตำแหน่งกล้อง",
	"dialog.save_angle.target": "จุดโฟกัส",
	"dialog.skin.pose": "ท่าทาง",
	"layout.color.frame": "กรอบหน้าต่าง",
	"layout.color.frame.desc": "ขอบและแถบชื่อของหน้าต่าง",
	"settings.large_grid_size": "ขนาดกริดบล็อก",
	"settings.large_grid_size.desc": "ขนาดของกริดบล็อก",
	"action.load_plugin_from_url": "โหลดปลั๊กอินจาก URL",
	"action.load_plugin_from_url.desc": "โหลดปลั๊กอินจากเซิร์ฟเวอร์โดยระบุ URL",
	"action.cube_counter.desc": "แสดงจำนวนชิ้นงานปัจจุบันและสถิติอื่น ๆ",
	"action.unlock_everything": "ปลดล็อกทั้งหมด",
	"action.unlock_everything.desc": "ปลดล็อกทุกกลุ่มและชิ้นงานในรายการชิ้นงาน",
	"action.load_palette": "โหลดชุดสี",
	"action.load_palette.desc": "โหลดชุดสีเริ่มต้นหรือชุดสีที่บันทึกไว้",
	"action.toggle_locked": "ล็อก/ปลดล็อก",
	"action.toggle_locked.desc": "ล็อกหรือปลดล็อกชิ้นงานที่เลือก",
	"action.apply_display_preset": "ใช้พรีเซ็ต",
	"action.apply_display_preset.desc": "ใช้พรีเซ็ตการตั้งค่าการแสดงผลเริ่มต้นหรือกำหนดเอง",
	"action.apply_display_preset.here": "ใช้กับช่องนี้",
	"action.apply_display_preset.everywhere": "ใช้กับทุกช่อง",
	"action.resolve_keyframe_expressions": "แปลงสูตรคีย์เฟรมเป็นตัวเลข",
	"action.resolve_keyframe_expressions.desc": "คำนวณสูตรของคีย์เฟรมที่เลือก แล้วแทนสูตรด้วยค่าตัวเลขที่ได้",
	"action.fold_all_animations": "พับแทร็กแอนิเมชันทั้งหมด",
	"menu.palette.load.empty": "ชุดสีว่าง",
	"switches.lock": "ล็อก",
	"settings.render_sides": "ด้านที่แสดง",
	"settings.render_sides.desc": "เลือกให้แสดงด้านนอกหรือทั้งสองด้านของแต่ละหน้า",
	"settings.render_sides.auto": "อัตโนมัติ",
	"settings.render_sides.front": "ด้านนอก",
	"settings.render_sides.double": "ด้านในและด้านนอก",
	"generic.enable": "เปิดใช้งาน",
	"generic.disable": "ปิดใช้งาน",
	"generic.redacted": "ถูกปกปิด",
	"dialog.select_texture.import_all": "นำเข้าทั้งหมด",
	"dialog.skin.layer_template": "สร้างเทมเพลตให้สกินชั้นนอกด้วย",
	"about.version.up_to_date": "เป็นเวอร์ชันล่าสุด",
	"about.version.update_available": "เวอร์ชัน %0 พร้อมใช้งาน",
	"settings.category.application": "แอปพลิเคชัน",
	"settings.streamer_mode": "โหมดสตรีมเมอร์",
	"settings.streamer_mode.desc": "ซ่อนข้อมูลส่วนตัว เช่น รายการโมเดลที่เปิดล่าสุด",
	"settings.automatic_updates": "อัปเดตอัตโนมัติ",
	"settings.automatic_updates.desc": "ดาวน์โหลด Blockbench เวอร์ชันใหม่โดยอัตโนมัติ",
	"action.rotation_space": "แกนที่ใช้หมุน",
	"action.focus_on_selection": "โฟกัสส่วนที่เลือก",
	"action.focus_on_selection.desc": "จัดกล้องให้โฟกัสที่ชิ้นงานที่เลือก",
	"action.jump_to_timeline_start": "ไปต้นแอนิเมชัน",
	"action.jump_to_timeline_end": "ไปท้ายแอนิเมชัน",
	"menu.help.updating": "กำลังอัปเดต (%0%)",
	"menu.help.update_failed": "อัปเดตล้มเหลว",
	"menu.animation.loop.once": "เล่นครั้งเดียว",
	"menu.animation.loop.hold": "หยุดที่เฟรมสุดท้าย",
	"menu.animation.loop.loop": "วนซ้ำ",
	"interface.streamer_mode_on": "เปิดโหมดสตรีมเมอร์แล้ว",
	"generic.reset": "รีเซ็ต",
	"generic.restore": "กู้คืน",
	"keys.mousewheel": "ล้อเลื่อนเมาส์",
	"message.delete_animation.title": "ลบแอนิเมชัน",
	"message.delete_animation.message": "แอนิเมชันถูกลบออกจาก Blockbench แล้ว คุณต้องการลบแอนิเมชันจากไฟล์ที่บันทึกไว้ด้วยหรือไม่?",
	"message.no_animation_to_import": "ไม่มีแอนิเมชันที่จะนำเข้า",
	"dialog.material_instances.title": "ชื่ออ้างอิงวัสดุ",
	"dialog.animation_import.title": "เลือกแอนิเมชันที่จะนำเข้า",
	"dialog.create_texture.padding": "ระยะห่าง",
	"settings.fov": "มุมกว้างของกล้อง (FOV)",
	"settings.fov.desc": "กำหนดว่ากล้องมองเห็นมุมกว้างแค่ไหน ค่าเริ่มต้นคือ 45 องศา",
	"settings.minify_bbmodel": "ไฟล์โปรเจกต์แบบย่อ",
	"settings.minify_bbmodel.desc": "เขียนไฟล์ .bbmodel แบบย่อในหนึ่งบรรทัด",
	"action.edit_material_instances": "แก้ไขชื่ออ้างอิงวัสดุ",
	"action.edit_material_instances.desc": "แก้ไขชื่อที่ใช้อ้างอิงวัสดุของแต่ละหน้าในโมเดลบล็อก Bedrock",
	"action.save_all_animations": "บันทึกแอนิเมชันทั้งหมด",
	"action.save_all_animations.desc": "บันทึกแอนิเมชันที่โหลดอยู่ทั้งหมด",
	"action.keyframe_interpolation": "การเปลี่ยนค่าระหว่างคีย์เฟรม",
	"action.keyframe_interpolation.desc": "เลือกวิธีเปลี่ยนค่าจากคีย์เฟรมหนึ่งไปยังอีกคีย์เฟรม",
	"action.keyframe_interpolation.linear": "สม่ำเสมอ (Linear)",
	"action.keyframe_interpolation.catmullrom": "นุ่มนวล (Smooth)",
	"action.timeline_focus.hide_empty": "ซ่อนช่องที่ไม่มีคีย์เฟรม",
	"menu.file.preferences": "การตั้งค่า",
	"menu.animation.blend_weight": "สัดส่วนการผสมแอนิเมชัน",
	"menu.animation.save": "บันทึก",
	"menu.animation.properties": "คุณสมบัติ...",
	"menu.animation.file": "ไฟล์",
	"menu.animation.snapping": "ความละเอียดการวางคีย์เฟรม",
	"menu.animation.open_location": "แสดงในตัวสำรวจไฟล์",
	"panel.keyframe.add_data_point": "เพิ่มจุดข้อมูลคีย์เฟรม",
	"panel.keyframe.remove_data_point": "ลบจุดข้อมูล",
	"panel.keyframe.pre": "ก่อน",
	"panel.keyframe.post": "หลัง",
	"generic.all": "ทั้งหมด",
	"message.small_face_dimensions.title": "หน้าบางด้านมีขนาดเล็กเกินไป",
	"message.small_face_dimensions.message": "ส่วนที่เลือกมีหน้าที่กว้างหรือสูงไม่ถึง 1 หน่วย UV แบบกล่องจะนับด้านที่เล็กกว่านี้เป็น 0 พิกเซล จึงอาจทำให้เทกซ์เจอร์แสดงไม่ถูกต้อง",
	"message.small_face_dimensions.face_uv": "รูปแบบนี้รองรับ UV ต่อหน้า ซึ่งใช้กับหน้าเล็ก ๆ ได้ คลิกขวาที่คิวบ์ที่มีปัญหา แล้วเปลี่ยน 'โหมด UV' เป็น 'UV ต่อหน้า'",
	"dialog.plugins.outdated_client": "ต้องใช้ Blockbench เวอร์ชันใหม่กว่า",
	"dialog.plugins.outdated_plugin": "ปลั๊กอินล้าสมัยและไม่ทำงานกับ Blockbench เวอร์ชันนี้",
	"settings.motion_trails": "เส้นทางการเคลื่อนไหว",
	"settings.motion_trails.desc": "แสดงเส้นทางที่ชิ้นงานเคลื่อนที่ในโหมดแอนิเมชัน",
	"settings.antialiasing": "เกลี่ยขอบหยัก",
	"settings.antialiasing.desc": "เปิดหรือปิดการเกลี่ยขอบหยักในมุมมองโมเดล",
	"action.timeline_frame_back": "ถอยหลัง 1 เฟรม",
	"action.timeline_frame_forth": "ไปข้างหน้า 1 เฟรม",
	"panel.bone.ik": "ควบคุมกระดูกด้วย IK (ทดลอง)",
	"settings.particle_tick_rate": "ความถี่อัปเดตอนุภาค",
	"settings.particle_tick_rate.desc": "จำนวนครั้งต่อวินาทีที่อัปเดตเอฟเฟกต์อนุภาค ค่าเริ่มต้นคือ 30",
	"action.lock_motion_trail": "ล็อกเส้นทางการเคลื่อนไหว",
	"action.lock_motion_trail.desc": "ให้เส้นทางการเคลื่อนไหวแสดงของกลุ่มที่เลือกไว้เสมอ",
	"menu.animation_file.unload": "นำไฟล์ออกจากโปรเจกต์",
	"data.null_object": "ออบเจกต์เปล่า",
	"status_bar.toggle_sidebar": "แสดง/ซ่อนแถบด้านข้าง",
	"message.load_plugin_failed.title": "โหลดปลั๊กอินล้มเหลว",
	"message.load_plugin_failed.message": "ตรวจสอบว่าชื่อไฟล์ปลั๊กอินที่ไม่รวมนามสกุลตรงกับ ID `%0` ที่ระบุใน Plugin.register()",
	"dialog.project.uv_mode": "โหมด UV",
	"dialog.project.uv_mode.box_uv": "UV แบบกล่อง",
	"dialog.project.uv_mode.face_uv": "UV ต่อหน้า",
	"dialog.project.texture_size": "ขนาดเทกซ์เจอร์",
	"dialog.animation_export.title": "เลือกแอนิเมชันที่จะส่งออก",
	"dialog.create_texture.rearrange_uv": "จัดเรียง UV ใหม่",
	"layout.color.subtle_text": "ข้อความจาง",
	"layout.color.subtle_text.desc": "สีข้อความรองที่มีคอนทราสต์น้อยกว่า",
	"settings.interface_scale": "ขนาดหน้าตาโปรแกรม",
	"settings.interface_scale.desc": "ปรับขนาดเมนู ปุ่ม และข้อความในโปรแกรม",
	"settings.background_rendering": "เรนเดอร์เมื่อใช้หน้าต่างอื่น",
	"settings.background_rendering.desc": "อัปเดตมุมมองโมเดลต่อแม้กำลังใช้งานหน้าต่างอื่นอยู่",
	"settings.ctrl_shift_size": "ความละเอียดกริดเมื่อกด Ctrl + Shift",
	"settings.ctrl_shift_size.desc": "ความละเอียดของกริดขณะกด Ctrl และ Shift",
	"settings.hardware_acceleration": "การเร่งด้วยฮาร์ดแวร์",
	"settings.hardware_acceleration.desc": "มอบหมายงานเรนเดอร์ให้การ์ดจอ",
	"action.explode_skin_model": "แสดงสกินแบบแยกชิ้นส่วน",
	"action.explode_skin_model.desc": "สลับมุมมองแบบแยกชิ้นส่วน เพื่อให้แก้ไขหน้าที่ถูกบังอยู่ได้",
	"action.export_minecraft_skin": "ส่งออกสกิน Minecraft",
	"action.export_minecraft_skin.desc": "ส่งออกสกิน Minecraft เป็นเทกซ์เจอร์ PNG",
	"action.add_null_object": "เพิ่มออบเจกต์เปล่า",
	"action.add_null_object.desc": "เพิ่มออบเจกต์ที่ไม่มีรูปทรง สำหรับใช้เป็นจุดควบคุม เช่น ตัวควบคุมการเคลื่อนไหวแบบ IK",
	"action.animated_texture_frame": "เฟรมเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.animated_texture_frame.desc": "ตั้งเฟรมปัจจุบันของเทกซ์เจอร์แบบเคลื่อนไหว",
	"action.export_animation_file": "ส่งออกแอนิเมชัน...",
	"action.export_animation_file.desc": "ส่งออกแอนิเมชันที่เลือกเป็นไฟล์ใหม่",
	"action.timeline_graph_editor": "สลับหน้าต่างกราฟ",
	"action.timeline_graph_editor.desc": "สลับไทม์ไลน์ระหว่างมุมมองหน้าต่างกราฟและมุมมองคีย์เฟรม",
	"menu.file.recent.clear": "ล้างรายการไฟล์ล่าสุด",
	"switches.shade": "แรเงา",
	"generic.share": "แชร์",
	"dates.minute": "%0 นาที",
	"dates.minutes": "%0 นาที",
	"dates.hour": "%0 ชั่วโมง",
	"dates.hours": "%0 ชั่วโมง",
	"dates.day": "%0 วัน",
	"dates.days": "%0 วัน",
	"dates.week": "%0 สัปดาห์",
	"dates.weeks": "%0 สัปดาห์",
	"dates.year": "%0 ปี",
	"dates.years": "%0 ปี",
	"message.installed_plugin": "ติดตั้งปลั๊กอิน %0 สำเร็จ",
	"message.installed_plugin_fail": "ติดตั้งปลั๊กอิน %0 ล้มเหลว",
	"dialog.share_model.title": "แชร์โมเดล",
	"dialog.share_model.expire_time": "เวลาหมดอายุ",
	"dialog.share_model.failed": "อัปโหลดโมเดลล้มเหลว",
	"action.import_java_block_model": "เพิ่มโมเดลบล็อก/ไอเทม Java",
	"action.import_java_block_model.desc": "เพิ่มโมเดลบล็อก/ไอเทม Minecraft Java จากไฟล์ json ในโมเดลปัจจุบัน",
	"action.share_model": "แชร์...",
	"action.share_model.desc": "สร้างลิงก์สั้นเพื่อแชร์โมเดลของคุณ",
	"action.import_project": "นำเข้าโปรเจกต์",
	"action.import_project.desc": "นำเข้าโปรเจกต์อื่นจากไฟล์ .bbmodel ในโปรเจกต์ปัจจุบัน",
	"dialog.toolbar_edit.hidden_tools": "เครื่องมือบางอย่างอาจถูกซ่อนเนื่องจากไม่พร้อมใช้งานในโหมด รูปแบบ หรือสถานการณ์ปัจจุบัน",
	"settings.camera_near_plane": "ระยะใกล้สุดที่กล้องแสดงได้",
	"settings.camera_near_plane.desc": "ระยะใกล้สุดจากกล้องที่ยังแสดงวัตถุ ค่าที่สูงขึ้นช่วยลดภาพกะพริบเมื่อพื้นผิวอยู่ใกล้กันมาก ค่าเริ่มต้นคือ 1",
	"mode.start.keymap_preference.desc": "ถ้าคุ้นกับโปรแกรม 3D อื่นอยู่แล้ว เลือกชุดปุ่มลัดที่ถนัดเพื่อเริ่มใช้ Blockbench ได้ง่ายขึ้น คุณเปลี่ยนชุดปุ่มลัดหรือปรับแต่ละปุ่มภายหลังได้ในการตั้งค่า",
	"message.load_keymap": "คุณแน่ใจหรือไม่ว่าต้องการโหลดแป้นพิมพ์ลัดนี้? การดำเนินการนี้จะเขียนทับแป้นพิมพ์ลัดปัจจุบันของคุณ",
	"message.keymap_loaded": "โหลดแป้นพิมพ์ลัดแล้ว",
	"dialog.convert_project.current_format": "รูปแบบปัจจุบัน",
	"dialog.create_texture.rearrange_uv.desc": "จัด UV ใหม่ให้แต่ละหน้ามีพื้นที่ของตัวเองบนเทกซ์เจอร์",
	"dialog.create_texture.power.desc": "กำหนดขนาดเทกซ์เจอร์ให้เป็นกำลังของ 2 โดยอัตโนมัติ เช่น 64 หรือ 128 ซึ่งจำเป็นสำหรับระบบเรนเดอร์บางตัว",
	"dialog.create_texture.double_use.desc": "หากชิ้นงานสองชิ้นใช้พื้นที่ UV เดียวกันอยู่แล้ว ให้ใช้พื้นที่ร่วมกันต่อหลังจัด UV ใหม่",
	"dialog.create_texture.padding.desc": "เว้นระยะห่างเล็กน้อยระหว่างส่วนต่าง ๆ ของเทมเพลต",
	"dialog.create_texture.resolution.desc": "ขนาดของเทกซ์เจอร์ในพิกเซล",
	"dialog.create_gif.color": "สีพื้นหลัง",
	"dialog.save_angle.zoom": "ซูม",
	"dialog.skin.variant": "รูปแบบย่อย",
	"dialog.flip_animation.info": "จับคู่กระดูกด้านซ้ายและขวาจากคำว่า 'left' และ 'right' ในชื่อ",
	"dialog.export_private_settings.title": "การตั้งค่าส่วนตัว",
	"dialog.export_private_settings.message": "ไฟล์นี้มีข้อมูลส่วนตัว: **%0** หากจะแชร์ไฟล์กับคนอื่น ควรนำข้อมูลเหล่านี้ออกก่อน",
	"dialog.export_private_settings.keep": "คงไว้",
	"settings.timecode_frame_number": "แสดงเศษวินาทีเป็นเลขเฟรม",
	"settings.timecode_frame_number.desc": "แสดงส่วนย่อยของเวลาในไทม์ไลน์เป็นเลขเฟรม แทนหน่วยหนึ่งในร้อยวินาที",
	"settings.animation_sample_rate": "ความถี่เก็บค่าแอนิเมชัน",
	"settings.animation_sample_rate.desc": "จำนวนครั้งต่อวินาทีที่เก็บค่าจากเส้นโค้งแอนิเมชัน เมื่อรูปแบบปลายทางไม่รองรับเส้นโค้งนั้นโดยตรง",
	"keybind.preview_zoom": "ลากเพื่อซูม",
	"action.gradient_tool": "เครื่องมือไล่ระดับสี",
	"action.gradient_tool.desc": "วาดไล่ระดับสีบนเทกซ์เจอร์",
	"action.import_settings": "นำเข้าการตั้งค่า",
	"action.import_settings.desc": "นำเข้าไฟล์ .bbsettings",
	"action.export_settings": "ส่งออกการตั้งค่า",
	"action.export_settings.desc": "ส่งออกการตั้งค่า Blockbench เป็นไฟล์ .bbsettings",
	"action.load_keymap": "โหลดแป้นพิมพ์ลัด",
	"action.load_keymap.default": "ค่าเริ่มต้น (แทร็คแพด/เมาส์)",
	"action.load_keymap.mouse": "ค่าเริ่มต้น (เมาส์)",
	"action.load_keymap.default.desc": "ชุดปุ่มลัดเริ่มต้นของ Blockbench ที่ควบคุมมุมมองได้สะดวกด้วยแทร็คแพด",
	"action.load_keymap.mouse.desc": "ชุดปุ่มลัดเริ่มต้นของ Blockbench ที่ใช้ปุ่มเมาส์กลางควบคุมมุมมอง",
	"action.load_keymap.blender.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Blender",
	"action.load_keymap.cinema4d.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Cinema 4D",
	"action.load_keymap.maya.desc": "แป้นพิมพ์ลัดสำหรับผู้ใช้ที่คุ้นเคยกับการควบคุมของ Autodesk Maya",
	"action.import_keymap": "นำเข้าแป้นพิมพ์ลัด",
	"action.import_keymap.desc": "นำเข้าแป้นพิมพ์ลัดจากไฟล์ .bbkeymap",
	"action.export_keymap": "ส่งออกแป้นพิมพ์ลัด",
	"action.export_keymap.desc": "ส่งออกแป้นพิมพ์ลัดปัจจุบันเป็นไฟล์ .bbkeymap",
	"action.edit_history": "ประวัติการแก้ไข...",
	"action.edit_history.desc": "ดูประวัติการแก้ไขและเลิกทำหรือทำซ้ำขั้นตอน",
	"action.group_elements": "จัดกลุ่มชิ้นงาน",
	"action.group_elements.desc": "นำชิ้นงานที่เลือกมาใส่ในกลุ่มใหม่",
	"action.unfold_groups": "กางกลุ่มทั้งหมด",
	"action.unfold_groups.desc": "กางทุกกลุ่มและชิ้นงานที่มีรายการย่อยในรายการชิ้นงาน",
	"action.edit_bedrock_binding": "เปลี่ยนกระดูกที่ผูกกับโมเดล...",
	"action.edit_bedrock_binding.desc": "กำหนดกระดูกที่โมเดลจะผูกและขยับตาม โดยระบุชื่อกระดูกหรือสูตร Molang",
	"action.pick_screen_color": "ดูดสีจากหน้าจอ",
	"action.pick_screen_color.desc": "ดูดสีจากจุดใดก็ได้บนหน้าจอ",
	"action.view_mode": "โหมดมุมมอง",
	"action.view_mode.desc": "เปลี่ยนโหมดมุมมองโมเดล",
	"action.view_mode.textured": "มีเทกซ์เจอร์",
	"action.view_mode.solid": "ทึบ",
	"action.view_mode.wireframe": "โครงลวด",
	"action.toggle_sidebars": "แสดง/ซ่อนแถบด้านข้าง",
	"action.toggle_sidebars.desc": "เปิดหรือปิดแถบข้าง",
	"action.set_animation_end": "ตั้งจุดสิ้นสุดแอนิเมชัน",
	"action.set_animation_end.desc": "ตั้งจุดสิ้นสุดของแอนิเมชันที่เลือกให้ตรงกับเวลาปัจจุบันบนไทม์ไลน์",
	"action.flip_animation": "พลิกแอนิเมชัน",
	"action.flip_animation.desc": "คัดลอกคีย์เฟรมที่เลือกไปยังอีกด้านของโมเดล",
	"action.graph_editor_zero_line": "แสดงเส้นค่าศูนย์เสมอ",
	"action.graph_editor_zero_line.desc": "กำหนดให้มุมมองของหน้าต่างกราฟแสดงเส้นค่าศูนย์เสมอหรือไม่",
	"menu.texture.render_mode": "โหมดเรนเดอร์",
	"menu.texture.render_mode.emissive": "เรืองแสง",
	"menu.texture.render_mode.layered": "แบบเลเยอร์",
	"menu.preview.angle.edit": "แก้ไขมุม...",
	"menu.animation.start_delay": "หน่วงเวลาเริ่มต้น",
	"menu.animation.loop_delay": "หน่วงเวลาวนซ้ำ",
	"menu.animation.flip_keyframes": "พลิกคีย์เฟรม",
	"menu.mobile_keyboard.disable_all": "ปิดทั้งหมด",
	"panel.keyframe.toggle_uniform_scale": "ปรับขนาดทุกแกนเท่ากัน",
	"camera_angle.common_isometric_right": "ไอโซเมตริกขวา (2:1)",
	"camera_angle.common_isometric_left": "ไอโซเมตริกซ้าย (2:1)",
	"camera_angle.true_isometric_right": "ไอโซเมตริกขวาแท้ (30°)",
	"camera_angle.true_isometric_left": "ไอโซเมตริกซ้ายแท้ (30°)",
	"menu.help.wiki": "วิกิ Blockbench",
	"settings.update_to_prereleases": "อัปเดตเป็นรุ่นทดสอบ",
	"settings.update_to_prereleases.desc": "อัปเดตเป็น Blockbench รุ่นเบต้าโดยอัตโนมัติเพื่อลองฟีเจอร์ใหม่ รุ่นทดสอบอาจยังมีปัญหา จึงไม่ควรเปิดหากใช้ทำงานหรือโปรเจกต์สำคัญ",
	"data.separator.spacer": "ตัวเว้นวรรค",
	"data.separator.linebreak": "ตัวแบ่งบรรทัด",
	"data.setting": "การตั้งค่า",
	"generic.select_all": "เลือกทั้งหมด",
	"generic.select_none": "ไม่เลือก",
	"projects.new_tab": "แท็บใหม่",
	"projects.close_tab": "ปิดแท็บ",
	"message.invalid_format.title": "รูปแบบไม่ถูกต้อง",
	"message.invalid_format.message": "Blockbench ของคุณยังไม่รองรับรูปแบบ '%0' ที่ใช้สร้างโมเดลนี้ อาจต้องติดตั้งปลั๊กอินสำหรับรูปแบบนี้ก่อน",
	"message.invalid_link": "ลิงก์โมเดลไม่ถูกต้องหรือหมดอายุ",
	"message.default_textures.current": "เส้นทางปัจจุบัน",
	"message.update_after_restart": "โปรแกรมจะติดตั้งอัปเดตเมื่อเปิดใหม่ครั้งถัดไป",
	"message.copy_paste_tool_viewport": "เครื่องมือนี้สามารถใช้ได้ในพื้นที่ทำงาน 2D เท่านั้น",
	"dialog.project.shadow_size": "ขนาดเงา",
	"dialog.find_replace.target": "เป้าหมาย",
	"dialog.find_replace.target.element_names": "ชื่อชิ้นงาน",
	"dialog.find_replace.target.group_names": "ชื่อกลุ่ม",
	"dialog.find_replace.target.animation_names": "ชื่อแอนิเมชัน",
	"dialog.find_replace.target.keyframe_values": "ค่าคีย์เฟรม",
	"dialog.find_replace.find": "ค้นหา",
	"dialog.find_replace.replace": "แทนที่",
	"dialog.find_replace.regex": "ใช้รูปแบบค้นหา Regex",
	"dialog.add_primitive.shape": "รูปทรง",
	"dialog.add_primitive.shape.circle": "วงกลม",
	"dialog.add_primitive.shape.tube": "ท่อ",
	"dialog.add_primitive.shape.cone": "ทรงกรวย",
	"dialog.add_primitive.shape.cylinder": "ทรงกระบอก",
	"dialog.add_primitive.shape.sphere": "ทรงกลม",
	"dialog.add_primitive.shape.torus": "วงแหวน",
	"dialog.add_primitive.shape.cube": "ทรงกล่อง",
	"dialog.add_primitive.shape.pyramid": "พีระมิด",
	"dialog.add_primitive.diameter": "เส้นผ่านศูนย์กลาง",
	"dialog.add_primitive.height": "ความสูง",
	"dialog.add_primitive.sides": "จำนวนด้าน",
	"dialog.add_primitive.minor_diameter": "ความหนา",
	"dialog.add_primitive.minor_sides": "จำนวนด้านของหน้าตัด",
	"dialog.create_texture.combine_polys": "รวมกลุ่มหน้า UV",
	"dialog.create_texture.combine_polys.desc": "เชื่อมหน้าที่อยู่ติดกันให้เป็นกลุ่มเดียวบน UV",
	"dialog.model_stats.meshes": "เมช",
	"dialog.export_private_settings.omit": "ไม่รวม",
	"layout.select": "เลือก",
	"layout.options": "ตัวเลือก",
	"layout.color": "ชุดสี",
	"layout.documentation": "เอกสารประกอบ",
	"layout.color.bright_ui_text": "ข้อความบนส่วนสว่าง",
	"layout.color.bright_ui_text.desc": "ข้อความบนพื้นหลังสว่าง",
	"layout.name": "ชื่อ",
	"layout.author": "ผู้สร้าง",
	"settings.dialog.desc": "แสดงกล่องโต้ตอบ '%0'",
	"settings.export_empty_groups": "ส่งออกกลุ่มว่าง",
	"settings.export_empty_groups.desc": "รวมกลุ่มที่ไม่มีเนื้อหาในไฟล์ที่ส่งออก",
	"category.separators": "ตัวคั่น",
	"keybind.preview_area_select": "ลากกรอบเลือก",
	"action.color_erase_mode": "โหมดลบ",
	"action.color_erase_mode.desc": "ให้เครื่องมือเติมสีและวาดรูปทรงลบสีออก แทนการเติมสี",
	"action.open_from_link": "เปิดโมเดลจากลิงก์...",
	"action.open_from_link.desc": "เปิดโมเดลจาก URL blckbn.ch",
	"action.import_obj": "นำเข้าโมเดล OBJ",
	"action.import_obj.desc": "นำเข้าออบเจกต์จากโมเดล OBJ เป็นเมช",
	"action.add_plugin": "ติดตั้งปลั๊กอิน",
	"action.add_plugin.desc": "ติดตั้งปลั๊กอินผ่านช่องค้นหาคำสั่ง",
	"action.remove_plugin": "ถอนการติดตั้งปลั๊กอิน",
	"action.remove_plugin.desc": "ถอนการติดตั้งปลั๊กอินผ่านช่องค้นหาคำสั่ง",
	"action.add_mesh": "เพิ่มเมช",
	"action.add_mesh.desc": "เพิ่มเมชใหม่",
	"action.add_texture_mesh": "เพิ่มเมชเทกซ์เจอร์",
	"action.add_texture_mesh.desc": "เพิ่มเมชเทกซ์เจอร์ใหม่",
	"action.find_replace": "ค้นหาและแทนที่...",
	"action.find_replace.desc": "ค้นหาและแทนที่ข้อความบางส่วนในชื่อ",
	"action.hide_everything_except_selection": "ซ่อนทั้งหมดยกเว้นที่เลือก",
	"action.hide_everything_except_selection.desc": "แสดงหรือซ่อนชิ้นงานทั้งหมดที่ไม่ได้เลือก",
	"action.transform_space.normal": "ตั้งฉากกับผิว (Normal)",
	"action.selection_mode": "โหมดการเลือก",
	"action.selection_mode.desc": "เปลี่ยนวิธีเลือกชิ้นงานในมุมมองโมเดล",
	"action.selection_mode.object": "ทั้งชิ้นงาน",
	"action.selection_mode.face": "หน้า",
	"action.selection_mode.vertex": "จุดยอด",
	"action.create_face": "สร้างหน้าหรือขอบ",
	"action.create_face.desc": "สร้างหน้าหรือขอบใหม่ระหว่างจุดยอดที่เลือก",
	"action.convert_to_mesh": "แปลงเป็นเมช",
	"action.convert_to_mesh.desc": "แปลงชิ้นงานที่เลือกเป็นเมช",
	"action.invert_face": "กลับด้านหน้า",
	"action.invert_face.desc": "กลับด้านหน้าที่เลือกให้หันไปทิศทางตรงข้าม",
	"action.extrude_mesh_selection": "ดึงส่วนที่เลือกต่อ (Extrude)",
	"action.extrude_mesh_selection.desc": "ดึงส่วนที่เลือกของเมชออกเพื่อสร้างรูปทรงต่อเนื่อง",
	"action.loop_cut": "ตัดขอบเป็นวง (Loop Cut)",
	"action.loop_cut.desc": "เพิ่มแนวตัดต่อเนื่องรอบเมช โดยตัดผ่านขอบที่เลือก",
	"action.merge_meshes": "รวมเมช",
	"action.merge_meshes.desc": "รวมเมชหลายชิ้นเป็นชิ้นเดียว",
	"action.keyframe_uniform": "ปรับขนาดทุกแกนเท่ากัน",
	"action.keyframe_uniform.desc": "ให้คีย์เฟรมที่เลือกปรับขนาดทุกแกนด้วยค่าเดียวกัน",
	"menu.locator.ignore_inherited_scale": "ไม่ปรับขนาดตามชิ้นงานแม่",
	"menu.texture.elements": "ใช้กับชิ้นงาน",
	"uv_editor.transparent_face": "หน้าโปร่งใส",
	"display.pose_angle": "มุมท่าทาง (สำหรับตัวอย่างเท่านั้น)",
	"data.mesh": "เมช",
	"dialog.create_texture.type": "ประเภท",
	"dialog.create_texture.type.blank": "เปล่า",
	"dialog.create_texture.type.template": "เทมเพลตเทกซ์เจอร์",
	"dialog.create_texture.type.color_map": "เทมเพลตสีทึบ",
	"dialog.sketchfab_uploader.suggested_tags": "แท็กแนะนำ",
	"dialog.sketchfab_uploader.category": "หมวดหมู่",
	"dialog.sketchfab_uploader.category2": "หมวดหมู่ 2",
	"layout.restore_backup": "ธีมที่คุณปรับแต่ง \"%0\" ถูกเขียนทับ คลิกที่นี่เพื่อกู้คืน",
	"layout.borders": "ขอบ",
	"action.fill_mode.element": "ทั้งชิ้นงาน",
	"action.inset_mesh_selection": "ย่อหน้าเข้าด้านใน (Inset)",
	"action.inset_mesh_selection.desc": "สร้างหน้าเล็กลงด้านในของหน้าที่เลือก พร้อมขอบล้อมรอบ",
	"action.dissolve_edges": "ลบขอบโดยคงผิวไว้ (Dissolve)",
	"action.dissolve_edges.desc": "ลบขอบที่เลือกแล้วรวมหน้าที่ขอบนั้นแบ่งอยู่ โดยไม่ทำให้ผิวเป็นรู",
	"action.split_mesh": "แยกเมช",
	"action.split_mesh.desc": "แยกส่วนที่เลือกออกเป็นเมชอีกชิ้น",
	"action.merge_vertices": "รวมจุดยอด",
	"action.merge_vertices.desc": "รวมจุดยอดที่เลือกไปยังตำแหน่งของจุดที่เลือกเป็นจุดแรก",
	"action.view_mode.normal": "การวางแนวหน้า",
	"action.snap_uv_to_pixels": "จัด UV ให้ตรงพิกเซล",
	"action.snap_uv_to_pixels.desc": "จัดจุดยอด UV ที่เลือกให้ตรงกับกริดพิกเซล",
	"menu.file.import.import_open_project": "นำเข้าโปรเจกต์ที่เปิดอยู่",
	"menu.help.unlock_projects": "ปลดล็อกโปรเจกต์ทั้งหมด",
	"status_bar.selection.faces": "%0 หน้า",
	"status_bar.selection.vertices": "%0 จุดยอด",
	"message.merged_vertices": "รวมจุดยอด %0 จุดใน %1 ตำแหน่งแล้ว",
	"settings.vertex_merge_distance": "ระยะรวมจุดยอด",
	"settings.vertex_merge_distance.desc": "ระยะห่างสูงสุดที่จะรวมจุดยอดเข้าด้วยกัน เมื่อใช้คำสั่งรวมตามระยะ",
	"settings.show_only_selected_uv": "แสดงเฉพาะ UV ที่เลือก",
	"settings.show_only_selected_uv.desc": "แสดงเฉพาะหน้า UV ที่เลือกในหน้าต่าง UV โดยค่าเริ่มต้น",
	"action.merge_vertices.merge_all": "รวมทั้งหมด",
	"action.merge_vertices.merge_all_in_center": "รวมทั้งหมดที่จุดกึ่งกลาง",
	"action.merge_vertices.merge_by_distance": "รวมตามระยะ",
	"action.merge_vertices.merge_by_distance_in_center": "รวมตามระยะที่จุดกึ่งกลาง",
	"action.uv_rotate_left": "หมุน UV ซ้าย",
	"action.uv_rotate_left.desc": "หมุนหน้า UV ที่เลือกทวนเข็มนาฬิกา",
	"action.uv_rotate_right": "หมุน UV ขวา",
	"action.uv_rotate_right.desc": "หมุนหน้า UV ที่เลือกตามเข็มนาฬิกา",
	"menu.uv.display_uv": "แสดง UV",
	"menu.uv.display_uv.selected_faces": "หน้าที่เลือก",
	"menu.uv.display_uv.selected_elements": "ทุกหน้า",
	"menu.uv.display_uv.all_elements": "ทุกหน้าบนทุกชิ้นงาน",
	"menu.paste.face": "หน้า UV",
	"menu.paste.mesh_selection": "ส่วนของเมชที่เลือก",
	"menu.paste.outliner": "ชิ้นงาน",
	"uv_editor.show_all_faces": "แสดงทุกหน้า",
	"uv_editor.show_selected_faces": "แสดงหน้าที่เลือก",
	"status_bar.selection.edges": "%0 ขอบ",
	"action.selection_mode.edge": "ขอบ",
	"message.cannot_re_import.title": "ไฟล์ที่ส่งออกนำกลับมาแก้ไขไม่ได้",
	"message.cannot_re_import.message": "Blockbench เปิดรูปแบบไฟล์ที่ส่งออกนี้กลับมาไม่ได้ โปรดบันทึกเป็นไฟล์โปรเจกต์ไว้ด้วยเพื่อแก้ไขภายหลัง",
	"generic.default": "ค่าเริ่มต้น",
	"units.pixels_per_meter": "%0 พิกเซลต่อเมตร",
	"mode.pose": "จัดท่า",
	"modifier_actions.resize_both_sides": "ปรับขนาดทั้งสองทิศทาง",
	"modifier_actions.resize_one_side": "ปรับขนาดทิศทางเดียว",
	"modifier_actions.draw_line": "วาดเส้น",
	"modifier_actions.drag_without_snapping": "ลากอิสระโดยไม่สแนป",
	"modifier_actions.stretch_keyframes": "ยืดคีย์เฟรม",
	"modifier_actions.resize_background": "ปรับขนาดพื้นหลัง",
	"modifier_actions.select_multiple": "เลือกหลายรายการ",
	"modifier_actions.select_range": "เลือกช่วง",
	"modifier_actions.drag_to_duplicate": "ลากเพื่อทำสำเนา",
	"modifier_actions.uniform_scaling": "ปรับขนาดทุกแกนเท่ากัน",
	"modifier_actions.snap_direction": "ล็อกแนวที่ลาก",
	"message.no_valid_elements": "ยังไม่ได้เลือกชิ้นงานที่ใช้กับคำสั่งนี้ได้...",
	"dialog.add_primitive.shape.plane": "แผ่นเรียบ",
	"dialog.save_angle.rotation_mode": "โหมดการหมุน",
	"dialog.save_angle.rotation": "การหมุน",
	"dialog.save_angle.fov": "มุมกว้างของกล้อง (FOV)",
	"settings.hide_tab_bar": "ซ่อนแถบแท็บอัตโนมัติ",
	"settings.hide_tab_bar.desc": "ซ่อนแถบแท็บเมื่อเปิดแท็บเดียว",
	"settings.status_bar_modifier_keys": "แสดงปุ่มเสริมในแถบสถานะ",
	"settings.status_bar_modifier_keys.desc": "แนะนำปุ่มที่กดร่วมกับเครื่องมือปัจจุบันได้ในแถบสถานะ",
	"settings.ground_plane": "พื้นใต้โมเดล",
	"settings.ground_plane.desc": "แสดงพื้นด้านล่างโมเดล",
	"settings.preview_paste_behavior": "วิธีวางข้อมูลในมุมมองโมเดล",
	"settings.preview_paste_behavior.desc": "เลือกวิธีวางข้อมูลในมุมมองโมเดลเมื่ออยู่ในโหมดแก้ไข และข้อมูลนั้นวางได้หลายแบบ",
	"settings.preview_paste_behavior.always_ask": "ถามทุกครั้ง",
	"action.new_window": "หน้าต่างใหม่",
	"action.new_window.desc": "เปิดหน้าต่าง Blockbench ใหม่",
	"action.export_collada": "ส่งออกโมเดล Collada (dae)",
	"action.export_collada.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ dae เพื่อใช้ในแอป 3D อื่น",
	"action.paint_mode_uv_overlay": "แสดง UV ทับบนภาพ",
	"action.paint_mode_uv_overlay.desc": "แสดงเส้น UV ทับบนเทกซ์เจอร์ในโหมดระบายสี",
	"action.bake_animation_into_model": "ใช้ท่าปัจจุบันกับโมเดล",
	"action.bake_animation_into_model.desc": "นำตำแหน่งและการหมุนจากเฟรมที่แสดงอยู่ไปใช้กับโมเดล โดยไม่รวมการปรับขนาด",
	"action.keyframe_interpolation.step": "เปลี่ยนค่าทันที (Step)",
	"action.set_ik_target": "เลือกปลายทางที่ IK ควบคุม",
	"action.set_ik_target.desc": "เลือกกระดูกหรือจุดอ้างอิงที่ปลายชุดกระดูกให้ขยับตามออบเจกต์เปล่านี้ ด้วย IK (Inverse Kinematics) เมื่อย้ายตัวควบคุม กระดูกในชุดจะปรับท่าเพื่อให้ปลายทางตามไปด้วย",
	"menu.action_control.type.tab": "แท็บ",
	"menu.action_control.type.angle": "มุมกล้อง",
	"menu.action_control.recent_in_streamer_mode": "แน่ใจหรือไม่? โหมดสตรีมเมอร์เปิดอยู่",
	"menu.action_control.recent_in_streamer_mode.desc": "คุณแน่ใจหรือไม่ว่าต้องการแสดงโมเดลล่าสุด?",
	"menu.tools": "เครื่องมือ",
	"menu.file.recent.more": "ดูเพิ่มเติม...",
	"menu.null_object.lock_ik_target_rotation": "ล็อกการหมุนกระดูกปลายทาง IK",
	"menu.animation_file.import_remaining": "นำเข้าที่เหลือจากไฟล์",
	"edit.loop_cut.offset": "ระยะเลื่อนแนวตัด",
	"edit.extrude_mesh_selection.extend": "ระยะดึง",
	"cube.color.pink": "ชมพู",
	"cube.color.silver": "เงิน",
	"dialog.plugins.offline": "ไม่มีการเชื่อมต่ออินเทอร์เน็ต",
	"dialog.create_texture.pixel_density": "ความละเอียดเทกซ์เจอร์ต่อเมตร",
	"dialog.create_texture.pixel_density.desc": "จำนวนพิกเซลต่อความยาวโมเดลหนึ่งเมตร ขนาดภาพเทกซ์เจอร์ที่ได้ขึ้นอยู่กับจำนวนและขนาดของชิ้นงาน",
	"panel.skin_pose": "ท่าทาง",
	"panel.skin_pose.none": "ไม่มี",
	"panel.skin_pose.natural": "ธรรมชาติ",
	"panel.skin_pose.walking": "เดิน",
	"panel.skin_pose.crouching": "ย่อ",
	"panel.skin_pose.sitting": "นั่ง",
	"panel.skin_pose.jumping": "กระโดด",
	"panel.skin_pose.aiming": "เล็ง",
	"edit.loop_cut.direction": "ทิศทาง",
	"data.texture_mesh": "เมชเทกซ์เจอร์",
	"generic.left": "ซ้าย",
	"generic.right": "ขวา",
	"mode.start.quick_setup": "ตั้งค่าด่วน",
	"mode.start.keymap": "แป้นพิมพ์ลัด",
	"mode.start.quick_setup.more_themes": "เพิ่มเติม...",
	"dialog.resize_texture.animation_frames": "เฟรมแอนิเมชัน",
	"dialog.export_emission_map.title": "ส่งออกแผนที่แสงเรือง",
	"dialog.export_emission_map.format": "รูปแบบ",
	"dialog.export_emission_map.format.luminance": "ความสว่าง",
	"dialog.export_emission_map.format.luminance_inverted": "ความสว่างกลับด้าน",
	"dialog.export_emission_map.format.colors": "สี",
	"dialog.export_emission_map.threshold": "เกณฑ์ความโปร่งใส",
	"dialog.export_emission_map.round_up": "ปัดขึ้นเป็น %0 x %1",
	"dialog.export_emission_map.flip_y": "พลิกแกน Y",
	"dialog.select.type": "ประเภทชิ้นงาน",
	"dialog.create_texture.max_edge_angle": "มุมสูงสุดระหว่างหน้า",
	"dialog.create_texture.max_edge_angle.desc": "รวมหน้าที่อยู่ติดกันได้เมื่อมุมระหว่างหน้าไม่เกินค่านี้",
	"dialog.create_texture.max_island_angle": "มุมสูงสุดของกลุ่มหน้า UV",
	"dialog.create_texture.max_island_angle.desc": "มุมสูงสุดที่ยังรวมหน้าไว้ในกลุ่ม UV เดียวกันได้",
	"settings.mobile_panel_side": "ตำแหน่งแผงบนมือถือ",
	"settings.mobile_panel_side.desc": "เลือกว่าจะวางแผงไว้ด้านไหนของหน้าจอ เมื่อใช้ Blockbench แนวนอนบนมือถือ",
	"settings.obj_face_export_mode": "โหมดส่งออกหน้า OBJ",
	"settings.obj_face_export_mode.desc": "เลือกให้ตัวส่งออก OBJ แปลงหน้าทั้งหมดเป็นสามเหลี่ยมหรือสี่เหลี่ยม",
	"settings.obj_face_export_mode.both": "ค่าเริ่มต้น",
	"settings.obj_face_export_mode.tris": "แปลงเป็นสามเหลี่ยม",
	"settings.obj_face_export_mode.quads": "แปลงเป็นสี่เหลี่ยม",
	"action.seam_tool": "เครื่องมือรอยตัด UV",
	"action.seam_tool.desc": "กำหนดขอบที่จะตัดแยกหรือเชื่อมต่อกันตอนคลี่ UV ของเมช",
	"action.resolve_group": "แยกกลุ่ม",
	"action.resolve_group.desc": "นำชิ้นงานออกจากกลุ่มแล้วลบกลุ่ม โดยไม่ย้ายตำแหน่งชิ้นงาน",
	"action.move_to_group": "ย้ายไปยัง",
	"action.move_to_group.desc": "ย้ายชิ้นงานที่เลือกไปอยู่ใต้กลุ่มหรือชิ้นงานอื่นในรายการชิ้นงาน",
	"action.select_seam": "กำหนดรอยตัด UV",
	"action.select_seam.desc": "เลือกว่าจะเชื่อมหรือตัดแยก UV ตรงขอบที่เลือก",
	"action.select_seam.auto": "อัตโนมัติ",
	"action.select_seam.join": "เชื่อม",
	"action.select_seam.divide": "ตัดแยก",
	"action.adjust_brightness_contrast": "ปรับความสว่างและคอนทราสต์...",
	"action.adjust_brightness_contrast.desc": "ปรับความสว่างและคอนทราสต์ของเทกซ์เจอร์ที่เลือก",
	"action.adjust_saturation_hue": "ปรับความสดและเฉดสี...",
	"action.adjust_saturation_hue.desc": "ปรับความสดและเฉดสีของเทกซ์เจอร์ที่เลือก",
	"action.invert_colors": "กลับสี",
	"action.invert_colors.desc": "กลับสีทั้งหมดของเทกซ์เจอร์ที่เลือก",
	"action.adjust_curves": "ปรับเส้นโค้ง...",
	"action.adjust_curves.desc": "ปรับเส้นโค้งความสว่างของเทกซ์เจอร์ที่เลือก",
	"action.flip_texture_x": "พลิกแนวนอน",
	"action.flip_texture_y": "พลิกแนวตั้ง",
	"action.resize_texture": "ปรับขนาดเทกซ์เจอร์...",
	"action.view_mode.uv": "ดูตัวอย่าง UV",
	"action.append_to_template": "เพิ่มชิ้นงานในเทมเพลต...",
	"action.append_to_template.desc": "เพิ่มชิ้นงานที่เลือกในเทมเพลตเทกซ์เจอร์",
	"action.move_texture_with_uv": "ย้ายเทกซ์เจอร์พร้อม UV",
	"action.move_texture_with_uv.desc": "ย้ายเทกซ์เจอร์ของหน้าไปพร้อมกับการลากหน้า UV",
	"action.timeline_setups": "รูปแบบการแสดงไทม์ไลน์",
	"action.save_timeline_setup": "บันทึกรูปแบบไทม์ไลน์...",
	"action.save_timeline_setup.desc": "บันทึกแทร็กและช่องที่เลือกไว้เป็นพรีเซ็ตไทม์ไลน์",
	"menu.texture": "เทกซ์เจอร์",
	"menu.texture.render_mode.default": "ค่าเริ่มต้น",
	"menu.texture.merge_onto_texture": "รวมเข้ากับเทกซ์เจอร์ด้านบน",
	"menu.animation.unload": "นำออกจากโปรเจกต์",
	"panel.timeline": "ไทม์ไลน์",
	"action.pan_tool": "เครื่องมือเลื่อนมุมมอง",
	"action.pan_tool.desc": "ลากเพื่อเลื่อนมุมมองโมเดลหรือภาพเทกซ์เจอร์",
	"mode.start.recent.favorite": "ทำเครื่องหมายเป็นรายการโปรด",
	"mode.start.info": "ข้อมูล",
	"mode.start.target": "เป้าหมาย",
	"mode.start.start": "เริ่มต้น",
	"mode.start.create_new": "สร้างโมเดลใหม่",
	"mode.start.format.informations": "น่ารู้:",
	"mode.start.format.resources": "แหล่งข้อมูล:",
	"format.free.info.meshes": "ในรูปแบบนี้ คุณสามารถสร้างโมเดลโลว์โพลีด้วยคิวบ์และเมชรูปทรงกำหนดเอง",
	"format.free.info.limitation": "โมเดลไม่สามารถโหลดเข้าสู่เกมที่ต้องการรูปแบบเฉพาะ เช่น Minecraft",
	"format.skin.info.skin": "รูปแบบนี้ออกแบบมาเพื่อสร้างสกิน Minecraft และเทกซ์เจอร์เอนทิตี",
	"format.skin.info.model": "ไม่สามารถเปลี่ยนแปลงโมเดลได้ หากต้องการแก้ไขโมเดล ให้แปลงเป็นรูปแบบอื่นผ่าน **ไฟล์** > **แปลงโปรเจกต์**",
	"format.java_block.info.rotation": "การหมุนจำกัดเพียงหนึ่งแกนต่อชิ้นงาน",
	"format.java_block.info.size": "โมเดลมีขนาดได้ไม่เกิน 3x3x3 บล็อก แต่ใช้การตั้งค่าการแสดงผลขยายไอเทมให้ดูใหญ่ขึ้นได้",
	"format.java_block.info.animation": "รูปแบบนี้ไม่รองรับแอนิเมชันใน Minecraft แบบดั้งเดิม หากคุณกำลังสร้างม็อด คุณสามารถใช้ GeckoLib เพื่อทำแอนิเมชันโมเดลได้ หากไม่ใช่ วิธีเดียวคือสลับโมเดลโดยใช้คำสั่งหรือเทกซ์เจอร์แบบเคลื่อนไหว",
	"format.bedrock.info.textures": "แต่ละโมเดลสามารถมีเทกซ์เจอร์ได้เพียงหนึ่งอันเท่านั้น",
	"format.bedrock_block": "บล็อก Bedrock",
	"format.bedrock_block.desc": "โมเดลบล็อกสำหรับ Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "คิวบ์แต่ละชิ้นต้องมีขนาดเป็นจำนวนเต็ม",
	"format.modded_entity.info.format": "รูปแบบนี้บันทึกโมเดลเป็นโค้ด Java ต่างจากรูปแบบอื่นของ Blockbench ที่บันทึกเป็นข้อมูลโมเดลโดยตรง",
	"format.optifine_entity.info.optifine_required": "ผู้ใช้ที่ไม่ได้ติดตั้ง OptiFine จะไม่เห็นโมเดล",
	"format.optifine_entity.info.pivots": "รูปแบบนี้ล็อกจุดหมุนของกระดูกไว้ จึงควรใช้ตำแหน่งเดิม",
	"format_category.low_poly": "โลว์โพลี",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "อื่น ๆ",
	"format_category.loaders": "ตัวโหลด",
	"message.recover_backup.recover": "กู้คืน",
	"message.invalid_characters.title": "เส้นทางไม่ถูกต้อง",
	"message.invalid_characters.message": "ตำแหน่งไฟล์ที่นำเข้ามีตัวอักษรพิมพ์ใหญ่ ช่องว่าง หรืออักขระที่ไม่รองรับ ใช้ได้เฉพาะ: %0",
	"dialog.share_model.thumbnail": "ภาพปก",
	"dialog.skin.high_res_texture": "ความละเอียดนี้ใช้เป็นสกิน Minecraft แบบปกติไม่ได้ โปรดเลือกความละเอียดที่ต่ำลง",
	"settings.allow_display_slot_mirror": "อนุญาตการสะท้อนช่องแสดงผล",
	"settings.allow_display_slot_mirror.desc": "อนุญาตให้สะท้อนโมเดลไอเทม Java ในช่องแสดงผล คำเตือน: ใช้ได้เฉพาะ Minecraft 1.14 หรือเก่ากว่า หรือในบางกรณีพิเศษ",
	"action.switch_tabs": "สลับแท็บ",
	"action.switch_tabs.desc": "สลับระหว่างแท็บที่เปิดอยู่ กด Shift เพื่อสลับในทิศทางตรงกันข้าม",
	"action.unselect_all": "ยกเลิกการเลือกทั้งหมด",
	"action.save_palette": "บันทึกชุดสี...",
	"action.save_palette.desc": "บันทึกชุดสีปัจจุบันใน Blockbench เพื่อใช้ภายหลัง",
	"action.keyframe_column_create": "เพิ่มคีย์เฟรมที่เวลาปัจจุบัน",
	"action.keyframe_column_create.desc": "เพิ่มคีย์เฟรมที่เวลาปัจจุบันให้ทุกช่องในไทม์ไลน์ที่มีคีย์เฟรมอยู่แล้ว",
	"action.keyframe_column_select": "เลือกคีย์เฟรมที่เวลาปัจจุบัน",
	"action.keyframe_column_select.desc": "เลือกคีย์เฟรมทุกแทร็กที่อยู่ตรงตำแหน่งเวลาเล่นปัจจุบัน",
	"menu.uv": "UV",
	"menu.keyframe": "คีย์เฟรม",
	"menu.palette.load.update": "อัปเดตชุดสี",
	"menu.palette.load.update.desc": "อัปเดตชุดสีนี้ด้วยสีของชุดสี Blockbench ปัจจุบัน",
	"menu.timeline_marker.set_time": "ตั้งเวลา...",
	"uv_editor.scale_uv": "ปรับขนาด UV",
	"action.preview_scene": "ฉากตัวอย่าง",
	"action.preview_scene.desc": "เปลี่ยนฉากตัวอย่างโมเดล",
	"preview_scene.minecraft_overworld": "โอเวอร์เวิลด์",
	"preview_scene.minecraft_nether": "เนเธอร์",
	"preview_scene.minecraft_end": "ดิเอนด์",
	"dialog.project.modded_entity_flip_y": "พลิกแกน Y",
	"preview_scene.studio": "สตูดิโอ",
	"format.image": "รูปภาพ",
	"modifier_actions.set_copy_source": "เลือกจุดต้นทางที่จะคัดลอก",
	"message.load_images.title": "โหลดรูปภาพ",
	"message.load_images.edit_image": "แก้ไขรูปภาพ",
	"dialog.add_primitive.align_edges": "จัดขอบ",
	"dialog.flip_animation.show_in_timeline": "แสดงกระดูกที่แก้ไขในไทม์ไลน์",
	"settings.default_cube_size": "ขนาดคิวบ์เริ่มต้น",
	"settings.default_cube_size.desc": "ขนาดเริ่มต้นเมื่อสร้างคิวบ์ใหม่",
	"settings.uniform_keyframe": "คีย์เฟรมปรับขนาดทุกแกนเท่ากัน",
	"settings.uniform_keyframe.desc": "ให้คีย์เฟรมปรับขนาดทุกแกนด้วยค่าเดียวกันเป็นค่าเริ่มต้น",
	"settings.nearest_rectangle_select": "กรอบเลือกชิดขอบพิกเซลที่ใกล้ที่สุด",
	"settings.nearest_rectangle_select.desc": "จัดขอบกรอบเลือกให้ตรงกับขอบพิกเซลที่ใกล้ที่สุดแบบเดียวกับ GIMP แทนการครอบให้เต็มทุกพิกเซล",
	"settings.pick_color_opacity": "ดูดค่าความทึบพร้อมสี",
	"settings.pick_color_opacity.desc": "ให้หลอดดูดสีเก็บค่าความทึบของสีด้วย แล้วใช้ค่านั้นกับแปรง",
	"settings.paint_with_stylus_only": "ระบายสีด้วยปากกาเท่านั้น",
	"settings.paint_with_stylus_only.desc": "ใช้ปากการะบายสี และใช้เมาส์หรือการสัมผัสเพื่อเลื่อนมุมมอง",
	"action.copy_brush_mode": "โหมดแปรงคัดลอก",
	"action.copy_brush_mode.copy": "คัดลอกตามการลาก",
	"action.copy_brush_mode.pattern": "ระบายลวดลายซ้ำ",
	"action.copy_brush_mode.sample": "ระบายด้วยภาพตัวอย่างเดิม",
	"action.brush_shape": "รูปร่างแปรง",
	"action.brush_shape.square": "สี่เหลี่ยม",
	"action.brush_shape.circle": "วงกลม",
	"action.blend_mode": "โหมดผสมสี",
	"action.blend_mode.default": "ค่าเริ่มต้น",
	"action.blend_mode.set_opacity": "ตั้งความทึบ",
	"action.blend_mode.color": "สี",
	"action.blend_mode.behind": "ด้านหลัง",
	"action.blend_mode.multiply": "คูณสี (Multiply)",
	"action.blend_mode.divide": "หารสี (Divide)",
	"action.blend_mode.add": "บวกสี (Add)",
	"action.blend_mode.subtract": "ลบสี (Subtract)",
	"action.blend_mode.screen": "สกรีน (Screen)",
	"action.blend_mode.overlay": "ซ้อนทับ (Overlay)",
	"action.blend_mode.hard_light": "แสงจัด (Hard Light)",
	"action.blend_mode.difference": "ผลต่างสี (Difference)",
	"action.copy_brush": "แปรงคัดลอก",
	"action.copy_brush.desc": "คัดลอกบางส่วนของเทกซ์เจอร์มาระบาย หรือวาดเป็นลวดลาย กด Ctrl ค้างแล้วคลิกเพื่อเลือกจุดต้นทาง",
	"action.validator_window": "ดูปัญหาโมเดล...",
	"action.validator_window.desc": "เปิดหน้าต่างตรวจสอบปัญหาของโมเดลปัจจุบัน",
	"action.cancel_gif": "ยกเลิกการบันทึก GIF",
	"menu.text_edit.copy_vector": "คัดลอกค่าทุกแกน",
	"menu.brush_presets.dialog": "พรีเซ็ตแปรง...",
	"menu.brush_presets.pixel_brush": "แปรงพิกเซล",
	"menu.brush_presets.smooth_brush": "แปรงขอบนุ่ม",
	"menu.texture.edit_in_blockbench": "แก้ไขใน Blockbench",
	"menu.mirror_painting.axis": "แกน",
	"menu.mirror_painting.axis.desc": "เลือกแกนที่จะใช้สะท้อนสีที่ระบาย",
	"menu.mirror_painting.global": "สะท้อนทั้งโมเดล",
	"menu.mirror_painting.global.desc": "สะท้อนสีที่ระบายโดยอิงแกนของทั้งฉาก",
	"menu.mirror_painting.local": "สะท้อนแต่ละชิ้นงาน",
	"menu.mirror_painting.local.desc": "สะท้อนสีที่ระบายโดยอิงแกนของแต่ละชิ้นงาน",
	"menu.mirror_painting.texture_frames": "ระบายซ้ำทุกเฟรม",
	"menu.mirror_painting.texture_frames.desc": "ใช้สีที่ระบายกับทุกเฟรมของเทกซ์เจอร์เคลื่อนไหว",
	"format.bedrock_block.info.size_limit": "ขนาดรวมของบล็อกจำกัดที่ 30 พิกเซลในทุกมิติ ขีดจำกัดสามารถเลื่อนออกจากศูนย์กลางได้ 7 พิกเซลในทุกทิศทาง",
	"format.bedrock_block.info.textures": "ใช้เทกซ์เจอร์หลายภาพกับคิวบ์แต่ละชิ้นใน Blockbench ได้ แต่ต้องตั้งค่าเพิ่มในแพ็คพฤติกรรมเพื่อให้แสดงถูกต้องในเกม",
	"format.image.desc": "แต่งภาพในพื้นที่ทำงาน 2D",
	"generic.delete_all": "ลบทั้งหมด",
	"message.child_model_only.open": "เปิดโมเดลแม่",
	"dialog.project.credit": "เครดิต",
	"dialog.convert_project.create_copy": "สร้างสำเนา",
	"dialog.texture.frame_time": "ระยะเวลาแต่ละเฟรม",
	"dialog.texture.frame_time.desc": "ตั้งระยะเวลาที่แสดงแต่ละเฟรมเป็นหน่วยทิก โดย 1 ทิกเท่ากับ 1/20 วินาที",
	"dialog.texture.frame_interpolate": "เปลี่ยนเฟรมอย่างนุ่มนวล",
	"dialog.texture.frame_interpolate.desc": "ค่อย ๆ ผสมภาพจากเฟรมปัจจุบันไปยังเฟรมถัดไป",
	"dialog.texture.frame_order_type": "โหมดวนซ้ำ",
	"dialog.texture.frame_order_type.loop": "วนซ้ำ",
	"dialog.texture.frame_order_type.backwards": "วนซ้ำย้อนกลับ",
	"dialog.texture.frame_order_type.back_and_forth": "ไป-กลับ",
	"dialog.texture.frame_order_type.custom": "ลำดับกำหนดเอง",
	"dialog.texture.frame_order": "ลำดับเฟรม",
	"dialog.texture.frame_order.desc": "กำหนดลำดับการเล่นด้วยหมายเลขเฟรม โดยเฟรมแรกคือหมายเลข 0",
	"dialog.select.mode": "โหมด",
	"dialog.select.mode.new": "เลือกใหม่",
	"dialog.select.mode.add": "เพิ่มในที่เลือก",
	"dialog.select.mode.remove": "ลบออกจากที่เลือก",
	"dialog.select.mode.in_selection": "เลือกเฉพาะจากที่เลือก",
	"dialog.predicate_overrides.model": "โมเดล",
	"dialog.predicate_overrides.predicates": "เงื่อนไข",
	"dialog.predicate_overrides.variants": "รูปแบบย่อย",
	"dialog.predicate_overrides.start_value": "เริ่มต้น",
	"dialog.predicate_overrides.add_override": "เพิ่มการแทนที่โมเดล",
	"dialog.predicate_overrides.add_predicate": "เพิ่มเงื่อนไข",
	"dialog.predicate_overrides.generate_overrides": "สร้างรายการแทนที่โมเดล",
	"dialog.predicate_overrides.confirm_delete": "ต้องการลบรายการแทนที่โมเดลทั้งหมดหรือไม่?",
	"dialog.predicate_overrides.predicate.angle": "มุมเข็มทิศ",
	"dialog.predicate_overrides.predicate.blocking": "กำลังยกโล่ป้องกัน",
	"dialog.predicate_overrides.predicate.broken": "พังแล้ว",
	"dialog.predicate_overrides.predicate.cast": "เหวี่ยงเบ็ดแล้ว",
	"dialog.predicate_overrides.predicate.cooldown": "คูลดาวน์",
	"dialog.predicate_overrides.predicate.damage": "ความเสียหาย",
	"dialog.predicate_overrides.predicate.damaged": "เสียหาย",
	"dialog.predicate_overrides.predicate.lefthanded": "ถนัดซ้าย",
	"dialog.predicate_overrides.predicate.pull": "ระยะง้าง",
	"dialog.predicate_overrides.predicate.pulling": "กำลังง้าง",
	"dialog.predicate_overrides.predicate.charged": "บรรจุกระสุนแล้ว",
	"dialog.predicate_overrides.predicate.firework": "มีดอกไม้ไฟ",
	"dialog.predicate_overrides.predicate.throwing": "พร้อมขว้าง",
	"dialog.predicate_overrides.predicate.time": "เวลาของวัน",
	"dialog.predicate_overrides.predicate.custom_model_data": "ข้อมูลโมเดลกำหนดเอง",
	"dialog.predicate_overrides.predicate.level": "ระดับแสง",
	"dialog.predicate_overrides.predicate.filled": "ความจุที่ใช้ในถุงมัด",
	"dialog.predicate_overrides.predicate.tooting": "กำลังเป่า",
	"settings.model_export_scale": "อัตราส่วนขนาดโมเดลที่ส่งออก",
	"settings.model_export_scale.desc": "หารขนาดโมเดล glTF, DAE และ FBX ที่ส่งออกด้วยค่านี้ ค่าเริ่มต้นคือ 16 ซึ่งเท่ากับให้ 16 หน่วยใน Blockbench เป็น 1 เมตรในไฟล์ที่ส่งออก",
	"action.export_fbx": "ส่งออกโมเดล FBX",
	"action.export_fbx.desc": "ส่งออกโมเดลและแอนิเมชันเป็นไฟล์ FBX เพื่อใช้ในแอป 3D และเอนจินเกมอื่น",
	"action.center_lateral": "จัดกึ่งกลางแนวนอน",
	"action.center_lateral.desc": "จัดชิ้นงานที่เลือกให้อยู่กึ่งกลางบนแกน X และ Z",
	"action.adjust_opacity": "ปรับความทึบ...",
	"action.adjust_opacity.desc": "ปรับความทึบของเทกซ์เจอร์ที่เลือก",
	"action.rotate_texture_cw": "หมุนตามเข็มนาฬิกา",
	"action.rotate_texture_ccw": "หมุนทวนเข็มนาฬิกา",
	"action.predicate_overrides": "เปลี่ยนโมเดลตามเงื่อนไข...",
	"action.predicate_overrides.desc": "เลือกโมเดลที่จะใช้แทนเมื่อเข้าเงื่อนไขที่กำหนด",
	"action.auto_set_cullfaces": "ตั้งการซ่อนหน้าที่ถูกบังอัตโนมัติ",
	"action.auto_set_cullfaces.desc": "ตั้งทิศทางการซ่อนหน้าโดยอัตโนมัติ เพื่อซ่อนหน้าที่ถูกบล็อกข้างเคียงบัง",
	"menu.texture.edit_externally": "เปิดแก้ไขในโปรแกรมอื่น",
	"menu.mirror_painting.texture": "สะท้อนบนภาพ 2D",
	"menu.mirror_painting.texture.desc": "ระบายสีแบบสะท้อนบนรูปภาพหรือเทกซ์เจอร์ในพื้นที่ทำงาน 2D",
	"menu.animator.rotation_global": "หมุนตามแกนของฉาก",
	"uv_editor.face_properties": "คุณสมบัติหน้า",
	"uv_editor.face_properties.material_instance": "ชื่ออ้างอิงวัสดุ",
	"uv_editor.tint.info": "เปิดการย้อมสีเพื่อให้ Minecraft เติมสีให้หน้านี้ ในเกมที่ไม่ลงม็อดจะใช้ได้กับบางบล็อกเท่านั้น เช่น ใบไม้และผงเรดสโตน และใช้ค่าได้เพียง 0",
	"uv_editor.cullface.info": "การซ่อนหน้าที่ถูกบังจะทำให้หน้าของบล็อกไม่แสดงผลเมื่อมีบล็อกเต็มอยู่ติดกันในทิศทางที่ระบุในโลก Minecraft ของคุณ ซึ่งช่วยเพิ่มประสิทธิภาพการแสดงผล",
	"uv_editor.material_instance.info": "ตั้งชื่ออ้างอิงเองได้ แล้วใช้ชื่อนี้ในไฟล์ JSON ของบล็อกในแพ็คพฤติกรรม เพื่อกำหนดเทกซ์เจอร์และวัสดุให้หน้านี้",
	"display.reference.frame_invisible": "กรอบไอเทม (ล่องหน)",
	"data.settings_profile": "โปรไฟล์",
	"message.display_skin.invalid_name": "ไม่พบบัญชี Minecraft ที่มีชื่อ \"%0\"",
	"dialog.load_plugins_from_query.title": "โหลดปลั๊กอิน",
	"dialog.load_plugins_from_query.text": "คุณใช้ลิงก์ที่ต้องใช้ปลั๊กอิน คุณต้องการติดตั้งหรือไม่?",
	"dialog.select_model.title": "เลือกโมเดล",
	"dialog.select_model.bones": "กระดูก",
	"dialog.select_model.cubes": "คิวบ์",
	"dialog.settings.create_profile": "สร้างโปรไฟล์...",
	"settings_profile.confirm_delete": "คุณแน่ใจหรือไม่ว่าต้องการลบโปรไฟล์การตั้งค่านี้?",
	"settings_profile.condition.type.selectable": "เลือกได้ด้วยตนเอง",
	"settings.interface_mode": "โหมดหน้าตาโปรแกรม",
	"settings.interface_mode.desc": "เลือกรูปแบบหน้าตาโปรแกรมสำหรับคอมพิวเตอร์หรือมือถือ",
	"settings.interface_mode.auto": "อัตโนมัติ",
	"settings.interface_mode.desktop": "เดสก์ท็อป",
	"settings.interface_mode.mobile": "มือถือ",
	"settings.paint_through_transparency": "ระบายทะลุส่วนโปร่งใส",
	"settings.paint_through_transparency.desc": "เมื่อล็อกความโปร่งใส ให้ระบายผ่านพิกเซลโปร่งใสไปยังพื้นผิวด้านหลังได้",
	"action.tab_overview": "ภาพรวมแท็บ",
	"action.tab_overview.desc": "แสดงแท็บที่เปิดอยู่เป็นตาราง แล้วเลือกแท็บที่จะไป",
	"action.slider_color_red": "สีแดง",
	"action.slider_color_green": "สีเขียว",
	"action.slider_color_blue": "สีน้ำเงิน",
	"action.add_animation_controller": "เพิ่มตัวควบคุมแอนิเมชัน",
	"action.add_animation_controller.desc": "สร้างตัวควบคุมแอนิเมชันใหม่ที่ยังไม่มีข้อมูล",
	"action.animation_controller_preview_mode": "ดูตัวอย่างตัวควบคุมแอนิเมชัน",
	"action.animation_controller_preview_mode.paused": "หยุดชั่วคราว",
	"action.animation_controller_preview_mode.manual": "ควบคุมเอง",
	"action.animation_controller_preview_mode.play": "เล่นอัตโนมัติ",
	"action.keyframe_interpolation.bezier": "เส้นโค้ง (Bézier)",
	"action.keyframe_bezier_linked": "เชื่อมแขนควบคุมกราฟ",
	"action.keyframe_bezier_linked.desc": "เชื่อมแขนควบคุมเส้นโค้งด้านซ้ายและขวาของคีย์เฟรมให้ปรับตามกัน",
	"action.reset_keyframe_handles": "รีเซ็ตแขนควบคุมกราฟ",
	"action.reset_keyframe_handles.desc": "คืนค่าแขนควบคุมเส้นโค้งของคีย์เฟรมที่เลือก",
	"action.looped_animation_playback": "เล่นวนซ้ำ",
	"action.looped_animation_playback.desc": "เล่นตัวอย่างแอนิเมชันวนซ้ำไปเรื่อย ๆ",
	"timeline.bind_to_actor": "ผูกตัวปล่อยอนุภาคกับเอนทิตี",
	"animation_controllers.select_preset": "เลือกพรีเซ็ตตัวควบคุมแอนิเมชัน...",
	"animation_controllers.state.animations": "แอนิเมชัน",
	"animation_controllers.state.particles": "อนุภาค",
	"animation_controllers.state.sounds": "เสียง",
	"animation_controllers.state.on_entry": "เมื่อเข้าสถานะนี้",
	"animation_controllers.state.on_exit": "เมื่อออกจากสถานะนี้",
	"animation_controllers.state.transitions": "การเปลี่ยนสถานะ",
	"animation_controllers.state.condition": "เงื่อนไข",
	"animation_controllers.state.blend_transition": "ระยะเวลาเปลี่ยนท่า",
	"animation_controllers.state.shortest_path": "หมุนเปลี่ยนท่าในทางที่สั้นที่สุด",
	"animation_controllers.state.edit_transition": "แก้ไขการเปลี่ยนสถานะ",
	"menu.color_picker.picker_type": "รูปแบบแผงเลือกสี",
	"menu.color_picker.picker_type.square": "สี่เหลี่ยม",
	"menu.color_picker.picker_type.wheel": "วงล้อ",
	"menu.color_picker.slider_mode": "รูปแบบแถบปรับสี",
	"menu.color_picker.slider_mode.hsv": "เฉดสี, ความสด, ความสว่าง (HSV)",
	"menu.color_picker.slider_mode.rgb": "แดง, เขียว, น้ำเงิน (RGB)",
	"menu.texture.render_mode.additive": "บวกสี (Additive)",
	"panel.color.picker_options": "ตั้งค่าแผงเลือกสี",
	"panel.animation_controllers": "ตัวควบคุมแอนิเมชัน",
	"display.preset.armor_stand": "พื้น (แท่นเกราะ)",
	"data.file_path": "เส้นทางไฟล์",
	"dialog.extrude.orientation": "การวางแนว",
	"dialog.extrude.orientation.upright": "ตั้งบนระนาบ XY",
	"dialog.extrude.orientation.flat": "วางราบบนระนาบ XZ",
	"dialog.scale.box_uv_warning": "การปรับขนาดคิวบ์ที่ใช้ UV แบบกล่องอาจทำให้ UV ผิดเพี้ยน ลองปรับขนาดตอนนำโมเดลไปใช้ หรือเปลี่ยนเป็น UV ต่อหน้า ที่ ไฟล์ > โปรเจกต์ หรือเปลี่ยนแยกให้แต่ละคิวบ์",
	"dialog.create_gif.format": "รูปแบบ",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "ชุดภาพ PNG ต่อเนื่อง",
	"dialog.create_gif.pixelate": "ทำภาพพิกเซล",
	"dialog.create_gif.bg_image": "ภาพพื้นหลัง",
	"dialog.create_gif.turn.desc": "หมุนโมเดลขณะบันทึก ใช้ค่าลบเพื่อหมุนตามเข็มนาฬิกา ค่า 60 หมายถึงหมุนหนึ่งรอบต่อวินาที",
	"settings_profile.condition": "เงื่อนไข",
	"settings_profile.condition.type.file_path.desc": "ใช้ Regex ตรวจสอบตำแหน่งไฟล์ของโปรเจกต์ปัจจุบัน และใช้เครื่องหมาย / คั่นโฟลเดอร์",
	"settings.only_selected_bezier_handles": "แสดงแขนควบคุมกราฟเฉพาะที่เลือก",
	"settings.only_selected_bezier_handles.desc": "ซ่อนแขนควบคุมเส้นโค้งของคีย์เฟรมที่ไม่ได้เลือก",
	"settings.embed_textures": "ฝังเทกซ์เจอร์",
	"settings.embed_textures.desc": "เก็บข้อมูลรูปภาพเทกซ์เจอร์ไว้ในไฟล์ .bbmodel ด้วย",
	"action.selection_mode.cluster": "ส่วนที่เชื่อมกัน",
	"dialog.copied_to_clipboard": "คัดลอกไปยังคลิปบอร์ดแล้ว",
	"data.reference_image": "ภาพอ้างอิง",
	"message.delete_reference_image": "คุณแน่ใจหรือไม่ว่าต้องการลบภาพอ้างอิงนี้? ไม่สามารถย้อนกลับได้",
	"message.add_reference_image.message": "เลือกตำแหน่งที่จะโหลดภาพอ้างอิง",
	"message.import_particle_texture.import": "นำเข้าเทกซ์เจอร์อนุภาค",
	"message.import_particle_texture.message": "คุณต้องการนำเข้าไฟล์เทกซ์เจอร์สำหรับอนุภาคของคุณหรือไม่?",
	"message.save_codec_selector.title": "รูปแบบบันทึกโมเดล",
	"message.save_codec_selector.message": "เลือกรูปแบบที่จะบันทึกโมเดล",
	"message.save_codec_selector.project_file": "โปรเจกต์ Blockbench (.bbmodel)",
	"message.save_codec_selector.both": "ทั้งสอง",
	"message.display_skin.username": "ชื่อผู้ใช้ (Java)",
	"message.palette_locked": "ชุดสีถูกล็อก",
	"dialog.project.default_uv_mode": "โหมด UV เริ่มต้น",
	"dialog.project.default_uv_mode.description": "เลือกโหมด UV เริ่มต้นสำหรับโปรเจกต์ โดยยังเปลี่ยนแยกให้แต่ละคิวบ์ได้",
	"dialog.export_options.title": "ตัวเลือกการส่งออก",
	"dialog.edit_texture.preview": "ตัวอย่าง",
	"dialog.proportional_editing.range": "ระยะที่มีผล",
	"dialog.proportional_editing.falloff": "การลดแรงตามระยะ",
	"dialog.proportional_editing.falloff.linear": "ลดลงสม่ำเสมอ",
	"dialog.proportional_editing.falloff.hermite_spline": "ลดลงนุ่มนวล",
	"dialog.proportional_editing.falloff.constant": "คงที่",
	"dialog.proportional_editing.selection": "การเลือก",
	"dialog.proportional_editing.selection.linear": "ระยะห่างโดยตรง",
	"dialog.proportional_editing.selection.connections": "ตามจุดที่เชื่อมกัน",
	"dialog.mirror_painting_texture_center.middle": "กลาง",
	"dialog.mirror_painting_texture_center.custom": "กำหนดเอง",
	"dialog.settings.reset_to_default": "รีเซ็ตเป็นค่าเริ่มต้น",
	"keybindings.item.num_slider.increase": "เพิ่ม",
	"keybindings.item.num_slider.decrease": "ลด",
	"settings.always_show_splash_art": "แสดงภาพหน้าต้อนรับเสมอ",
	"settings.always_show_splash_art.desc": "แสดงภาพประกอบบนหน้าเริ่มต้นเสมอ",
	"action.slider_palette_color": "สลับสีชุดสี",
	"action.slider_palette_color.desc": "วนสลับระหว่างสีในชุดสี",
	"action.proportional_editing": "ปรับจุดรอบข้างตาม (Proportional Editing)",
	"action.proportional_editing.desc": "เมื่อปรับส่วนที่เลือก จุดยอดรอบ ๆ จะขยับตามด้วย โดยขึ้นอยู่กับระยะและรูปแบบที่ตั้งไว้",
	"action.limit_to_palette": "ใช้เฉพาะสีในชุดสี",
	"action.limit_to_palette.desc": "เปลี่ยนสีในเทกซ์เจอร์ให้ใช้เฉพาะสีจากชุดสีที่เปิดอยู่",
	"action.edit_reference_images": "แก้ไขภาพอ้างอิง",
	"action.edit_reference_images.desc": "เปิดโหมดภาพอ้างอิงเพื่อเพิ่มหรือแก้ไขภาพอ้างอิงและพิมพ์เขียว",
	"action.add_reference_image": "เพิ่มภาพอ้างอิง",
	"action.reference_image_from_clipboard": "ภาพอ้างอิงจากคลิปบอร์ด",
	"action.reference_image_list": "ภาพอ้างอิง",
	"action.connect_uv_faces": "เชื่อมหน้า UV",
	"action.connect_uv_faces.desc": "เชื่อมหน้า UV ที่เลือกกับหน้า UV ที่เลือกล่าสุด",
	"action.merge_uv_vertices": "รวมจุดยอด UV",
	"action.merge_uv_vertices.desc": "ย้ายจุดยอด UV ที่เลือกไว้ก่อนหน้าไปยังจุดยอดที่เลือกล่าสุด",
	"action.bedrock_animation_mode": "โหมดแอนิเมชัน Bedrock",
	"action.bedrock_animation_mode.desc": "เลือกโหมดเพื่อแก้ไขแอนิเมชันสำหรับ Minecraft: Bedrock Edition",
	"action.bedrock_animation_mode.entity": "เอนทิตี",
	"action.bedrock_animation_mode.attachable_first": "ไอเทม — มุมมองบุคคลที่หนึ่ง",
	"action.bedrock_animation_mode.attachable_third": "ไอเทม — มุมมองบุคคลที่สาม",
	"timeline.amplify": "ยืดหรือบีบช่วงค่าคีย์เฟรม",
	"menu.options": "ตัวเลือก...",
	"menu.palette.lock_palette": "ล็อกชุดสี",
	"menu.uv.export": "ส่งออกการแมป UV",
	"menu.uv.flip_x": "สะท้อน X",
	"menu.uv.flip_y": "สะท้อน Y",
	"menu.mirror_painting.enabled": "เปิดใช้",
	"reference_image.position": "ตำแหน่ง",
	"reference_image.size": "ขนาด",
	"reference_image.rotation": "การหมุน",
	"reference_image.opacity": "ความทึบ",
	"reference_image.visibility": "แสดง/ซ่อน",
	"reference_image.clear_mode": "ลดพื้นหลังภาพอ้างอิง",
	"reference_image.layer": "เลเยอร์",
	"reference_image.layer.background": "หลังโมเดล",
	"reference_image.layer.viewport": "หน้าโมเดล",
	"reference_image.layer.float": "ทับบนหน้าตาโปรแกรม",
	"reference_image.scope": "ใช้ภาพนี้ใน",
	"reference_image.scope.project": "เฉพาะโปรเจกต์นี้",
	"reference_image.scope.global": "ทุกโปรเจกต์",
	"reference_image.enabled_modes": "แสดงในโหมด",
	"codec.common.encoding": "รูปแบบการบันทึกข้อมูล",
	"codec.common.armature": "ส่งออกกลุ่มเป็นโครงกระดูก",
	"codec.common.export_animations": "ส่งออกแอนิเมชัน",
	"codec.common.embed_textures": "ฝังเทกซ์เจอร์",
	"preview.center_camera": "จัดกล้องกึ่งกลาง",
	"display.reference.frame_top": "กรอบไอเทมด้านบน",
	"display.reference.frame_top_invisible": "กรอบไอเทมด้านบน (ล่องหน)",
	"action.proportional_editing_range": "ระยะปรับจุดรอบข้าง",
	"action.proportional_editing_range.desc": "กำหนดว่าจุดยอดรอบ ๆ ส่วนที่เลือกจะได้รับผลไกลแค่ไหน",
	"action.toggle_all_reference_images": "ซ่อน/แสดงภาพอ้างอิงทั้งหมด",
	"action.toggle_all_reference_images.desc": "สลับการมองเห็นภาพอ้างอิงทั้งหมดพร้อมกัน",
	"action.add_animation_controller_state": "เพิ่มสถานะแอนิเมชัน",
	"action.add_animation_controller_state.desc": "เพิ่มสถานะใหม่ในตัวควบคุมแอนิเมชัน",
	"menu.slider.round_value": "ปัดค่า",
	"texture.error.too_large": "ความละเอียดเกินค่าสูงสุด %0",
	"dialog.copy_to_clipboard": "คัดลอกไปยังคลิปบอร์ด",
	"dialog.open_url": "เปิด URL",
	"reference_image.image": "รูปภาพ",
	"uv_editor.rotate_uv": "หมุน UV",
	"generic.error": "ข้อผิดพลาด",
	"projects.start_screen": "หน้าจอเริ่มต้น",
	"message.invalid_link.message": "โมเดลที่แชร์ \"%0\" ที่คุณพยายามโหลดไม่ถูกต้องหรือหมดอายุแล้ว",
	"message.plugin_dependencies.title": "ปลั๊กอินที่ต้องติดตั้งเพิ่ม",
	"message.plugin_dependencies.message1": "ปลั๊กอินนี้ต้องใช้ปลั๊กอินต่อไปนี้ร่วมด้วย:",
	"message.plugin_dependencies.message1_update": "ปลั๊กอิน %0 อัปเดตแล้ว และต้องใช้ปลั๊กอินต่อไปนี้เพิ่ม:",
	"message.plugin_dependencies.message2": "ต้องการติดตั้งเพื่อทำต่อหรือไม่?",
	"message.plugin_dependencies.invalid": "ติดตั้งไม่ได้ เพราะปลั๊กอินที่ต้องใช้ต่อไปนี้ไม่ถูกต้อง:",
	"message.preview_scene_load_failed": "โหลดฉากตัวอย่างล้มเหลว ตรวจสอบการเชื่อมต่ออินเทอร์เน็ตของคุณ",
	"dialog.convert_project.text1": "แปลงโปรเจกต์เป็นรูปแบบอื่น",
	"dialog.convert_project.text2": "แต่ละรูปแบบรองรับฟีเจอร์และมีข้อจำกัดต่างกัน การแปลงจึงอาจทำให้ข้อมูลบางส่วนหายไปหรือแสดงไม่ถูกต้อง",
	"dialog.convert_project.text3": "การแปลงย้อนกลับด้วยคำสั่งเลิกทำไม่ได้ โปรแกรมจึงสร้างสำเนาไว้ให้เป็นค่าเริ่มต้น",
	"dialog.unsaved_work.title": "งานที่ยังไม่ได้บันทึก",
	"dialog.unsaved_work.text": "โปรเจกต์ต่อไปนี้มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก คุณต้องการบันทึกการเปลี่ยนแปลงหรือไม่?",
	"dialog.unsaved_work.discard_all": "ละทิ้งทั้งหมด",
	"dialog.unsaved_work.save_all": "บันทึกทั้งหมด",
	"dialog.resize_texture.mode": "โหมด",
	"dialog.resize_texture.mode.crop": "ครอบตัด/ขยาย",
	"dialog.resize_texture.mode.scale": "ปรับขนาด",
	"dialog.plugins.is_installed": "ติดตั้งแล้ว",
	"dialog.plugins.is_disabled": "ปิดใช้งาน",
	"dialog.plugins.disable": "ปิดใช้งาน",
	"dialog.plugins.enable": "เปิดใช้งาน",
	"dialog.plugins.dependencies": "ต้องใช้ร่วมกับ:",
	"dialog.view_backups.open_folder": "เปิดโฟลเดอร์",
	"dialog.share_model.reference_images": "รวมภาพอ้างอิง",
	"dialog.share_model.too_large": "อัปโหลดไม่ได้: ไฟล์โมเดลใหญ่เกินไป",
	"dialog.share_model.too_large_references": "อัปโหลดไม่ได้เพราะโมเดลมีขนาดไฟล์ใหญ่เกินไป ลองแชร์โดยไม่รวมภาพอ้างอิง",
	"settings.stretch_linked": "ยืดทุกแกนเท่ากัน",
	"settings.stretch_linked.desc": "ยืดคิวบ์ในทุกทิศทางด้วยค่าเดียวกัน",
	"settings.grids": "แสดงกริด",
	"settings.grids.desc": "แสดงหรือซ่อนกริด 3D ทั้งหมด",
	"settings.double_click_switch_tools": "สลับเครื่องมือเมื่อดับเบิลคลิก",
	"settings.double_click_switch_tools.desc": "ดับเบิลคลิกมุมมองโมเดลเพื่อสลับระหว่างเครื่องมือ",
	"settings.outlines_in_paint_mode": "เส้นขอบส่วนที่เลือกในโหมดระบายสี",
	"settings.outlines_in_paint_mode.desc": "แสดงเส้นขอบของชิ้นงานที่เลือกขณะอยู่ในโหมดระบายสี",
	"settings.json_indentation": "การเยื้อง JSON",
	"settings.json_indentation.desc": "รูปแบบการเยื้องสำหรับไฟล์ JSON ที่ส่งออก",
	"settings.json_indentation.tabs": "แท็บ",
	"settings.json_indentation.spaces_4": "ช่องว่าง: 4",
	"settings.json_indentation.spaces_2": "ช่องว่าง: 2",
	"action.slider_stretch": "ยืด",
	"action.slider_stretch.desc": "ยืดคิวบ์ตามแกน %0 ด้วยตัวคูณขนาด โดยไม่เปลี่ยน UV",
	"action.view_backups": "ดูไฟล์สำรอง",
	"action.view_backups.desc": "เปิดดูไฟล์สำรองอัตโนมัติของโปรเจกต์",
	"action.search_outliner": "ค้นหารายการชิ้นงาน",
	"action.search_outliner.desc": "ค้นหาชื่อในรายการชิ้นงาน",
	"action.mirror_modeling": "สร้างโมเดลแบบสะท้อน",
	"action.mirror_modeling.desc": "สะท้อนการแก้ไขในมุมมองโมเดลไปยังอีกด้านของแกน X โดยเว้นชิ้นงานที่ปิดการสะท้อนไว้",
	"action.allow_element_mirror_modeling": "ให้ชิ้นงานนี้สะท้อนตาม",
	"action.allow_element_mirror_modeling.desc": "เลือกว่าจะให้ชิ้นงานที่เลือกได้รับผลจากการสร้างโมเดลแบบสะท้อนหรือไม่",
	"action.switch_face_crease": "สลับแนวพับของหน้า",
	"action.switch_face_crease.desc": "สลับเส้นทแยงมุมที่ใช้แบ่งหน้าสี่เหลี่ยมเป็นสองสามเหลี่ยม",
	"action.clear_unused_texture_space": "ล้างพื้นที่เทกซ์เจอร์ที่ไม่ได้ใช้",
	"action.clear_unused_texture_space.desc": "ลบสีในพื้นที่เทกซ์เจอร์ที่ไม่มีชิ้นงานใดใช้ผ่าน UV",
	"action.split_screen": "แบ่งหน้าจอ",
	"action.split_screen.desc": "เลือกโหมดแบ่งหน้าจอ",
	"action.split_screen.single": "ช่องเดียว",
	"action.split_screen.double_horizontal": "สองช่อง — บนและล่าง",
	"action.split_screen.double_vertical": "สองช่อง — ซ้ายและขวา",
	"action.split_screen.quad": "สี่ช่อง",
	"action.split_screen.triple_left": "สามช่อง — ช่องใหญ่ด้านซ้าย",
	"action.split_screen.triple_right": "สามช่อง — ช่องใหญ่ด้านขวา",
	"action.split_screen.triple_top": "สามช่อง — ช่องใหญ่ด้านบน",
	"action.split_screen.triple_bottom": "สามช่อง — ช่องใหญ่ด้านล่าง",
	"action.uv_project_from_view": "วาง UV จากมุมมองปัจจุบัน",
	"action.uv_project_from_view.desc": "สร้าง UV ให้หน้าที่เลือกตามภาพที่เห็นในมุมมอง 3D ปัจจุบัน",
	"action.graph_editor_other_graphs": "แสดงกราฟอื่น",
	"action.graph_editor_other_graphs.desc": "แสดงหรือซ่อนกราฟของแกนที่ไม่ได้เลือก",
	"action.graph_editor_include_other_graphs": "ปรับมุมมองให้รวมกราฟอื่น",
	"action.graph_editor_include_other_graphs.desc": "ให้มุมมองกราฟครอบคลุมกราฟที่ไม่ได้เลือกด้วยหรือไม่",
	"action.set_ik_source": "เลือกกระดูกต้นทาง IK",
	"action.set_ik_source.desc": "เลือกกระดูกเริ่มต้นของชุดที่ IK จะควบคุม เช่น ต้นขาหรือต้นแขน เมื่อขยับตัวควบคุม กระดูกตั้งแต่จุดนี้ถึงปลายทางจะปรับท่าตาม",
	"edit.loop_cut.cuts": "จำนวนแนวตัด",
	"panel.element.stretch": "ยืด",
	"preview_scene.minecraft_plains": "ที่ราบ",
	"preview_scene.minecraft_cherry_grove": "สวนเชอร์รี่",
	"preview_scene.minecraft_snowy_tundra": "ทุนดราหิมะ",
	"preview_scene.minecraft_sunset": "พระอาทิตย์ตก",
	"preview_scene.minecraft_night": "กลางคืน",
	"preview_scene.minecraft_desert": "ทะเลทราย",
	"preview_scene.minecraft_underwater": "ใต้น้ำ",
	"preview_scene.minecraft_coral_reef": "แนวปะการัง",
	"preview_scene.minecraft_lush_cave": "ถ้ำเขียวชอุ่ม",
	"preview_scene.minecraft_deep_dark": "ดีปดาร์ก",
	"generic.navigate_forward": "ไปข้างหน้า",
	"generic.navigate_back": "ย้อนกลับ",
	"action.element_render_order": "ลำดับแสดงชิ้นงานโปร่งใส",
	"action.element_render_order.default": "อัตโนมัติ",
	"action.element_render_order.behind": "ด้านหลัง",
	"action.element_render_order.in_front": "ด้านหน้า",
	"message.installing_update.title": "มีอัปเดตพร้อมใช้งาน",
	"message.installing_update.message": "เวอร์ชันใหม่พร้อมติดตั้งแล้ว หลังปิดโปรแกรม ให้รอประมาณ %0 วินาทีก่อนเปิด Blockbench อีกครั้งหรือปิดคอมพิวเตอร์ เพื่อให้ติดตั้งอัปเดตเสร็จ",
	"settings.brush_cursor_2d": "เส้นขอบแปรงใน 2D",
	"settings.brush_cursor_2d.desc": "แสดงเส้นขอบแปรงในพื้นที่ทำงาน 2D",
	"settings.brush_cursor_3d": "เส้นขอบแปรงใน 3D",
	"settings.brush_cursor_3d.desc": "แสดงเส้นขอบแปรงในพื้นที่ทำงาน 3D",
	"settings.cdn_mirror": "ใช้เซิร์ฟเวอร์สำรอง CDN",
	"settings.cdn_mirror.desc": "ใช้เซิร์ฟเวอร์สำรอง CDN เพื่อดาวน์โหลดปลั๊กอิน เซิร์ฟเวอร์สำรองจะได้รับการอัปเดตเร็วกว่า และใช้งานได้ในบางภูมิภาคที่เซิร์ฟเวอร์เริ่มต้นใช้งานไม่ได้",
	"data.layer": "เลเยอร์",
	"data.panel": "แผง",
	"generic.confirm_delete": "คุณแน่ใจหรือไม่ว่าต้องการลบรายการนี้?",
	"format_category.general": "ทั่วไป",
	"modifier_actions.no_uniform_scaling": "ปรับขนาดอิสระ",
	"message.texture_refresh_conflict.title": "เทกซ์เจอร์ในไฟล์ไม่ตรงกับในโปรแกรม",
	"message.texture_refresh_conflict.message": "ไฟล์เทกซ์เจอร์อาจถูกแก้ไขจากภายนอก และไม่ตรงกับเวอร์ชันที่กำลังแก้ใน Blockbench",
	"message.texture_refresh_conflict.keep_ours": "เก็บเวอร์ชันที่แก้ใน Blockbench",
	"message.texture_refresh_conflict.keep_theirs": "โหลดจากไฟล์ แล้วทิ้งการแก้ไขและเลเยอร์ใน Blockbench",
	"message.group_required_to_animate": "ชิ้นงานประเภทนี้ทำแอนิเมชันโดยตรงไม่ได้ ให้ใส่ในกลุ่มหรือใช้โครงกระดูกควบคุมแทน",
	"dialog.texture.uv_size": "ขนาด UV",
	"dialog.advanced_screenshot.angle_preset": "พรีเซ็ตมุม",
	"dialog.advanced_screenshot.resolution": "ความละเอียด",
	"dialog.advanced_screenshot.zoom_to_fit": "ซูมให้พอดี",
	"dialog.advanced_screenshot.zoom": "ซูม / ความยาวโฟกัส",
	"dialog.advanced_screenshot.anti_aliasing": "เกลี่ยขอบหยัก",
	"dialog.advanced_screenshot.anti_aliasing.off": "ปิด",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "MSAA",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "SSAA",
	"dialog.advanced_screenshot.show_gizmos": "แสดงตัวควบคุมบนโมเดล",
	"dialog.advanced_screenshot.shading": "การแรเงา",
	"settings.auto_keyframe": "เพิ่มคีย์เฟรมเริ่มต้นอัตโนมัติ",
	"settings.auto_keyframe.desc": "เมื่อปรับกระดูกที่เวลาหลังจากจุดเริ่มไทม์ไลน์ ให้สร้างคีย์เฟรมค่าเริ่มต้นไว้ที่ต้นไทม์ไลน์โดยอัตโนมัติ",
	"settings.modded_entity_integer_size": "ใช้ขนาดจำนวนเต็มสำหรับเอนทิตีม็อด",
	"settings.modded_entity_integer_size.desc": "ให้คิวบ์ในรูปแบบเอนทิตีม็อดมีขนาดเป็นจำนวนเต็ม แม้บางเวอร์ชันจะรองรับทศนิยม เพราะจำนวนเต็มช่วยให้จัด UV ได้ง่ายกว่า",
	"category.layers": "เลเยอร์",
	"keybind.paint_secondary_color": "ระบายด้วยสีรอง",
	"action.selection_tool_operation_mode": "วิธีรวมส่วนที่เลือก",
	"action.selection_tool_operation_mode.create": "เลือกใหม่",
	"action.selection_tool_operation_mode.add": "เพิ่มในส่วนที่เลือก",
	"action.selection_tool_operation_mode.subtract": "ลบออกจากส่วนที่เลือก",
	"action.selection_tool_operation_mode.intersect": "เก็บเฉพาะส่วนที่ซ้อนกัน",
	"action.pixel_perfect_drawing": "วาดเส้นพิกเซลให้สะอาด",
	"action.pixel_perfect_drawing.desc": "วาดเส้นพิกเซลอาร์ตโดยตัดพิกเซลซ้ำตรงมุมออก เพื่อให้เส้นไม่หนาเป็นก้อน",
	"action.selection_tool": "เครื่องมือเลือก",
	"action.selection_tool.desc": "เลือกพื้นที่บนรูปภาพ",
	"action.selection_tool.rectangle": "สี่เหลี่ยม",
	"action.selection_tool.ellipse": "วงรี",
	"action.selection_tool.lasso": "ลากเลือกอิสระ (Lasso)",
	"action.selection_tool.wand": "เลือกสีที่ติดกัน (Magic Wand)",
	"action.selection_tool.color": "สีเดียวกัน",
	"action.move_layer_tool": "ย้ายเลเยอร์",
	"action.move_layer_tool.desc": "ย้ายเลเยอร์หรือส่วนที่เลือกปัจจุบัน",
	"action.export_modded_animations": "ส่งออกแอนิเมชันเอนทิตีม็อด",
	"action.export_modded_animations.desc": "ส่งออกแอนิเมชันสำหรับโมเดลเอนทิตีม็อด Minecraft Java Edition",
	"action.swap_colors": "สลับสี",
	"action.swap_colors.desc": "สลับสีหลักกับสีรอง",
	"action.apply_mesh_rotation": "ใช้ทิศทางนี้เป็นค่าหมุนเริ่มต้น",
	"action.apply_mesh_rotation.desc": "นำการหมุนไปใช้กับรูปทรงเมชโดยตรง แล้วตั้งค่าการหมุนของชิ้นงานเป็นศูนย์ โดยให้รูปทรงที่เห็นคงเดิม",
	"action.flip_texture_x.desc": "พลิกเทกซ์เจอร์หรือเลเยอร์แนวนอน",
	"action.flip_texture_y.desc": "พลิกเทกซ์เจอร์หรือเลเยอร์แนวตั้ง",
	"action.rotate_texture_cw.desc": "หมุนเทกซ์เจอร์หรือเลเยอร์ตามเข็มนาฬิกา",
	"action.rotate_texture_ccw.desc": "หมุนเทกซ์เจอร์หรือเลเยอร์ทวนเข็มนาฬิกา",
	"action.crop_texture_to_selection": "ครอบเทกซ์เจอร์ตามที่เลือก",
	"action.create_empty_layer": "สร้างเลเยอร์เปล่า",
	"action.enable_texture_layers": "เปิดใช้เลเยอร์",
	"action.disable_texture_layers": "ปิดใช้เลเยอร์",
	"action.layer_opacity": "ความทึบเลเยอร์",
	"action.layer_to_texture_size": "ขยายเลเยอร์ให้เท่าขนาดเทกซ์เจอร์",
	"action.layer_to_texture_size.desc": "ขยายเลเยอร์ให้เท่าขนาดของเทกซ์เจอร์",
	"action.merge_layer_down": "รวมกับเลเยอร์ด้านล่าง",
	"action.merge_layer_down.desc": "รวมเลเยอร์นี้เข้ากับเลเยอร์ที่อยู่ถัดลงไป",
	"action.advanced_screenshot": "ถ่ายภาพโมเดลแบบกำหนดเอง...",
	"action.advanced_screenshot.desc": "ถ่ายภาพโมเดลโดยกำหนดความละเอียด มุมกล้อง และตัวเลือกอื่น ๆ",
	"action.bake_ik_animation": "แปลงการเคลื่อนไหว IK เป็นคีย์เฟรม",
	"action.bake_ik_animation.desc": "บันทึกการหมุนที่ IK คำนวณให้เป็นคีย์เฟรมในแอนิเมชันที่เลือก",
	"action.save_animation_preset": "บันทึกพรีเซ็ตแอนิเมชัน...",
	"action.save_animation_preset.desc": "บันทึกคีย์เฟรมที่เลือกเป็นพรีเซ็ตแอนิเมชัน",
	"action.animation_onion_skin": "แสดงท่าจากเฟรมอื่น (Onion Skin)",
	"action.animation_onion_skin.desc": "แสดงโครงลวดของโมเดลจากเฟรมอื่น เพื่อเทียบกับท่าปัจจุบัน",
	"action.apply_animation_preset": "ใช้พรีเซ็ตแอนิเมชัน",
	"action.apply_animation_preset.desc": "เลือกจากรายการพรีเซ็ตแอนิเมชันและใช้กับกระดูกที่เลือก",
	"menu.brush_presets.pixel_perfect": "แปรงพิกเซลตัดมุมซ้ำ",
	"panel.layers": "เลเยอร์",
	"uv_editor.copy_paste_tool.to_layer": "ไปยังเลเยอร์ใหม่",
	"format.image.new": "สร้างรูปภาพใหม่",
	"format.image.info.summary": "สร้างและแต่งภาพ เทกซ์เจอร์ หรือพิกเซลอาร์ตได้ในพื้นที่ทำงาน 2D ของ Blockbench โดยไม่ต้องเปิดโปรแกรมแต่งภาพอื่น",
	"settings.move_with_selection_tool": "ใช้เครื่องมือเลือกเพื่อย้ายส่วนที่เลือก",
	"settings.move_with_selection_tool.desc": "อนุญาตให้เครื่องมือเลือกย้ายส่วนที่เลือกโดยตรง โดยไม่ต้องสลับไปยังเครื่องมือย้ายเลเยอร์",
	"settings.final_newline": "ขึ้นบรรทัดใหม่ท้ายไฟล์",
	"settings.final_newline.desc": "เติมอักขระขึ้นบรรทัดใหม่ไว้ท้ายไฟล์ที่ส่งออก",
	"action.crop_layer_to_selection": "ครอบเลเยอร์ตามที่เลือก",
	"action.edit_mode_uv_overlay.desc": "แสดงเส้น UV ของทุกชิ้นงานทับบนเทกซ์เจอร์ในโหมดแก้ไข",
	"menu.image": "รูปภาพ",
	"menu.texture.discard_changes": "ละทิ้งการเปลี่ยนแปลง",
	"menu.texture.discard_changes.desc": "ทิ้งการแก้ไขที่ยังไม่ได้บันทึก แล้วโหลดข้อมูลล่าสุดจากไฟล์",
	"panel.textures.images": "รูปภาพ",
	"dialog.advanced": "ขั้นสูง",
	"dialog.recommended_option": "แนะนำ",
	"modifier_actions.snap_to_center": "จัดให้ตรงจุดกึ่งกลาง",
	"modifier_actions.snap_to_pixels": "จัดให้ตรงพิกเซล",
	"message.invalid_format.install_plugin": "ติดตั้งปลั๊กอิน '%0'",
	"message.plugin_deprecated.message": "ปลั๊กอินนี้ไม่แนะนำให้ใช้แล้ว ต้องการติดตั้งต่อหรือไม่?",
	"message.plugin_deprecated.install_anyway": "ติดตั้งต่อ",
	"message.image_editor.not_found": "ไม่พบโปรแกรมแต่งภาพที่เลือก โปรดเลือกโปรแกรมอื่น",
	"message.knife_tool.confirm": "กด %0 หรือคลิกที่นี่เพื่อยืนยันแนวตัด",
	"message.knife_tool.skipped_face": "ตัดข้ามหน้าโดยตรงไม่ได้ ต้องเพิ่มจุดตัดบนขอบหรือจุดยอดที่คั่นอยู่ด้วย",
	"message.optimize_animation.keyframes_removed": "ลบคีย์เฟรมที่ไม่จำเป็น %0 คีย์เฟรมแล้ว",
	"message.optimize_animation.nothing_to_optimize": "ไม่พบคีย์เฟรมที่ลดได้ตามเงื่อนไขนี้",
	"message.duplicate_bone_copy_animation.title": "คัดลอกแอนิเมชัน",
	"message.duplicate_bone_copy_animation.message": "กระดูกที่ทำสำเนามีคีย์เฟรมอยู่ในแอนิเมชัน %0 รายการ ต้องการคัดลอกคีย์เฟรมไปยังกระดูกใหม่ด้วยหรือไม่?",
	"message.auto_fix_mesh_edit.title": "แก้ไขอัตโนมัติ",
	"message.auto_fix_mesh_edit.revert": "ย้อนกลับการแก้ไข",
	"message.auto_fix_mesh_edit.overlapping_vertices": "จุดยอดบางจุดถูกย้ายไปยังตำแหน่งเดียวกัน คุณต้องการดำเนินการอย่างไร?",
	"message.auto_fix_mesh_edit.concave_quads": "มีหน้าสี่เหลี่ยมที่เว้าเข้า ซึ่งอาจทำให้ UV หรือภาพเรนเดอร์ผิดเพี้ยน Blockbench ช่วยแก้ให้อัตโนมัติได้:",
	"message.auto_fix_mesh_edit.merge_vertices": "รวมจุดยอด",
	"message.auto_fix_mesh_edit.split_quads": "แบ่งหน้าสี่เหลี่ยม",
	"message.load_images.add_image": "เพิ่มรูปภาพ",
	"dialog.project.modded_entity_entity_class": "คลาสเอนทิตี",
	"dialog.resize_texture.offset": "ระยะเลื่อนภาพ",
	"dialog.animated_texture_editor.code_reference": "โค้ดตัวอย่าง",
	"dialog.animated_texture_editor.code_reference.about": "โค้ดนี้เป็นตัวอย่างสำหรับทำเทกซ์เจอร์เคลื่อนไหว อาจต้องปรับก่อนนำไปใช้ ดูรายละเอียดเพิ่มเติมในเอกสาร",
	"dialog.animated_texture_editor.code_reference.docs": "เอกสารประกอบ",
	"dialog.animated_texture_editor.reframe": "จัดเฟรมใหม่",
	"dialog.animated_texture_editor.stride": "ขนาดเฟรม",
	"dialog.animated_texture_editor.frames": "จำนวนเฟรม",
	"dialog.animated_texture_editor.add_frame": "เพิ่มเฟรม",
	"dialog.animated_texture_editor.resize_frames": "ปรับขนาดเฟรม...",
	"dialog.animated_texture_editor.apply": "ใช้",
	"dialog.add_primitive.edge_size": "ความยาวขอบ",
	"dialog.change_animation_speed.speed": "ความเร็ว",
	"dialog.change_animation_speed.adjust_snapping": "ปรับความละเอียดการวางคีย์เฟรมตาม",
	"dialog.optimize_animation.selection": "ส่วนที่เลือก",
	"dialog.optimize_animation.selection.selected_keyframes": "คีย์เฟรมที่เลือก",
	"dialog.optimize_animation.selection.selected_animation": "แอนิเมชันที่เลือก",
	"dialog.optimize_animation.selection.all_animations": "แอนิเมชันทั้งหมด",
	"dialog.optimize_animation.thresholds": "ค่าความคลาดเคลื่อนที่ยอมรับได้",
	"dialog.import_obj.obj": "ไฟล์ OBJ",
	"dialog.import_obj.mtl": "ไฟล์ MTL",
	"dialog.import_obj.scale": "ขนาด",
	"layout.thumbnail": "CSS ภาพปกกำหนดเอง",
	"settings.pixel_grid": "กริดพิกเซล",
	"settings.pixel_grid.desc": "แสดงกริดพิกเซลเทกซ์เจอร์บนชิ้นงานในโหมดแก้ไข",
	"settings.image_editor_grid_size": "ขนาดกริดหน้าต่างแต่งภาพ",
	"settings.image_editor_grid_size.desc": "ขนาดของกริดใหญ่ในหน้าต่างแต่งภาพ 2D",
	"settings.ground_plane_double_side": "มองเห็นพื้นจากด้านล่าง",
	"settings.ground_plane_double_side.desc": "แสดงพื้นใต้โมเดลทั้งด้านบนและด้านล่าง",
	"settings.optifine_save_default_texture": "OptiFine JEM: ส่งออกเทกซ์เจอร์ที่เลือก",
	"settings.optifine_save_default_texture.desc": "ส่งออกเทกซ์เจอร์ที่เลือกเป็นเทกซ์เจอร์เริ่มต้นของโมเดล",
	"action.slider_color_select_threshold": "ช่วงสีที่เลือก",
	"action.slider_color_select_threshold.desc": "กำหนดว่าสีต้องใกล้เคียงกันแค่ไหน จึงจะถูกเลือกด้วยเครื่องมือเลือกสีเดียวกันหรือ Magic Wand",
	"action.stretch_tool": "ยืด",
	"action.stretch_tool.desc": "เครื่องมือเลือกและยืดชิ้นงาน",
	"action.knife_tool": "เครื่องมือมีด",
	"action.knife_tool.desc": "ตัดหน้าเมชให้เป็นส่วนย่อย",
	"action.duplicate_project": "ทำสำเนาโปรเจกต์",
	"action.duplicate_project.desc": "สร้างสำเนาของโปรเจกต์ที่เปิดอยู่",
	"action.transform_space.parent": "แกนของชิ้นงานแม่ (Parent)",
	"action.transform_pivot_space": "แกนที่ใช้ย้ายจุดหมุน",
	"action.solidify_mesh_selection": "เพิ่มความหนาให้หน้า",
	"action.solidify_mesh_selection.desc": "เพิ่มความหนาให้หน้าของเมชที่เลือก",
	"action.animated_texture_editor": "แก้ไขเทกซ์เจอร์เคลื่อนไหว...",
	"action.animated_texture_editor.desc": "จัดเรียงและแก้ไขแต่ละเฟรมของเทกซ์เจอร์เคลื่อนไหวที่เลือก",
	"action.center_individual_pivots": "จัดจุดหมุนไว้กลางแต่ละชิ้น",
	"action.center_individual_pivots.desc": "ย้ายจุดหมุนของชิ้นงานที่เลือกแต่ละชิ้นไปไว้กึ่งกลางชิ้นงานนั้น",
	"action.uv_cycle": "วนลำดับจุด UV",
	"action.uv_cycle.desc": "วนลำดับการจับคู่จุดยอดกับ UV โดยไม่ย้ายจุด UV",
	"action.uv_cycle_invert": "กลับลำดับ UV",
	"action.uv_cycle_invert.desc": "กลับลำดับจุดยอด UV โดยไม่เปลี่ยนตำแหน่ง UV",
	"action.slider_animation_controller_speed": "ความเร็วเล่นตัวควบคุมแอนิเมชัน",
	"action.slider_animation_controller_speed.desc": "กำหนดความเร็วเล่นของตัวควบคุมแอนิเมชันเป็นเปอร์เซ็นต์",
	"action.optimize_animation": "ลดคีย์เฟรมที่ไม่จำเป็น",
	"action.optimize_animation.desc": "ลดจำนวนคีย์เฟรมตามขอบเขตและค่าความคลาดเคลื่อนที่กำหนด",
	"action.change_animation_speed": "เปลี่ยนความเร็วแอนิเมชัน...",
	"action.change_animation_speed.desc": "เปลี่ยนความเร็วของแอนิเมชันที่เลือก",
	"timeline.select_particle_file": "เลือกไฟล์อนุภาค",
	"timeline.select_sound_file": "เลือกไฟล์เสียง",
	"menu.cube.texture.default": "ค่าเริ่มต้น",
	"menu.texture.particle.clear": "หยุดใช้สำหรับอนุภาค",
	"menu.texture.use_as_default": "ตั้งเป็นค่าเริ่มต้น",
	"menu.texture.use_as_default.clear": "ยกเลิกตั้งเป็นค่าเริ่มต้น",
	"menu.toolbar.overflow": "เครื่องมือเพิ่มเติม",
	"edit.solidify_mesh_selection.thickness": "ความหนา",
	"reference_image.sync_to_timeline": "ซิงค์กับไทม์ไลน์",
	"reference_image.toggle_playback": "เล่น/หยุดชั่วคราว",
	"dialog.add_primitive.shape.beveled_cuboid": "ทรงกล่องตัดมุม",
	"dialog.ignore_all": "ข้ามทั้งหมด",
	"data.texture_group": "กลุ่มเทกซ์เจอร์",
	"data.animation": "แอนิเมชัน",
	"generic.on": "เปิด",
	"generic.off": "ปิด",
	"format.free.info.3d_printing": "พิมพ์ 3D",
	"message.invalid_file.merge_conflict": "ไฟล์มีข้อขัดแย้งจากการรวมการเปลี่ยนแปลงของ Git ที่ยังไม่ได้แก้ไข",
	"dialog.expand_texture_selection.radius": "ระยะขยาย",
	"dialog.expand_texture_selection.corner": "รูปร่างมุม",
	"dialog.expand_texture_selection.corner.round": "มน",
	"dialog.expand_texture_selection.corner.square": "สี่เหลี่ยม",
	"dialog.expand_texture_selection.corner.manhattan": "มุมเฉียง (Manhattan)",
	"dialog.merge_animation.merge_target": "รวมเข้ากับ",
	"keybindings.variation_conflict": "ปุ่มลัดเสริมซ้ำกับปุ่มลัดหลัก",
	"settings.recovery_save_interval": "ความถี่บันทึกไฟล์กู้คืน",
	"settings.recovery_save_interval.desc": "Blockbench บันทึกโปรเจกต์ที่เปิดอยู่เป็นระยะเพื่อกู้คืนเมื่อเครื่องขัดข้อง กำหนดช่วงเวลาเป็นวินาที หรือใส่ 0 เพื่อปิดการบันทึก",
	"settings.save_view_per_tab": "บันทึกมุมมองต่อแท็บ",
	"settings.save_view_per_tab.desc": "บันทึกมุมมองปัจจุบันแยกสำหรับแต่ละแท็บ",
	"settings.inherit_parent_color": "ใช้สีเดียวกับชิ้นงานแม่",
	"settings.inherit_parent_color.desc": "ให้ชิ้นงานใหม่ใช้สีเครื่องหมายเดียวกับชิ้นงานแม่ แทนการสุ่มสี",
	"keybind.preview_select.multi_select": "เลือกหลายรายการ",
	"keybind.preview_select.group_select": "เลือกกลุ่ม",
	"keybind.preview_select.loop_select": "เลือกต่อเนื่องเป็นวง",
	"action.fill_mode.selection": "ส่วนที่เลือก",
	"action.fill_mode.selected_elements": "ชิ้นงานที่เลือก",
	"action.image_tiled_view": "แสดงภาพเรียงซ้ำ",
	"action.image_tiled_view.description": "แสดงภาพเรียงต่อกันซ้ำ ๆ ในพื้นที่ทำงาน 2D เพื่อดูรอยต่อของลวดลาย",
	"action.image_onion_skin_view": "แสดงภาพจากเฟรมอื่น (Onion Skin)",
	"action.image_onion_skin_view.description": "แสดงภาพจากเฟรมอื่นซ้อนในพื้นที่ทำงาน 2D เพื่อเทียบกับเฟรมปัจจุบัน",
	"action.expand_texture_selection": "ขยาย/ย่อพื้นที่ที่เลือก",
	"action.expand_texture_selection.desc": "ขยายหรือย่อพื้นที่ที่เลือกบนเทกซ์เจอร์",
	"action.switch_tabs.reverse_order": "ย้อนลำดับ",
	"action.save_project_incremental": "บันทึกสำเนาพร้อมเลขท้ายชื่อ",
	"action.save_project_incremental.desc": "บันทึกโปรเจกต์เป็นไฟล์ใหม่โดยเพิ่มเลขท้ายชื่อ เช่น project_2.bbmodel",
	"action.copy.multiple": "คัดลอกทั้งหมด",
	"action.copy.multiple.desc": "คัดลอกข้อมูลที่มีทั้งหมดแยกกัน",
	"action.paste.multiple": "วางทั้งหมด",
	"action.randomize_marker_colors": "สุ่มสีเครื่องหมาย",
	"action.cube_light_emission": "ระดับแสงที่ปล่อยออกมา",
	"action.cube_light_emission.desc": "ตั้งระดับแสงที่คิวบ์ปล่อยออกมา ตั้งแต่ 0 ถึง 15",
	"action.view_mode.colored_solid": "สีเครื่องหมายแบบทึบ",
	"action.focus_on_selection.rotate_only": "หมุนเท่านั้น",
	"action.create_texture_group": "สร้างกลุ่มเทกซ์เจอร์",
	"action.create_texture_group.desc": "สร้างกลุ่มสำหรับเทกซ์เจอร์ของคุณ",
	"action.uv_maximize.all_faces": "มีผลกับหน้าทั้งหมด",
	"action.retarget_animators": "เปลี่ยนชิ้นงานที่รับแอนิเมชัน",
	"action.retarget_animators.desc": "เลือกกระดูกหรือชิ้นงานที่จะให้แทร็กแอนิเมชันควบคุม",
	"action.merge_animation": "รวมแอนิเมชัน",
	"action.merge_animation.desc": "รวมแอนิเมชันที่เลือกเข้ากับแอนิเมชันอื่น แล้วนำรายการต้นทางออก",
	"action.add_keyframe.reset_values": "ด้วยค่าเริ่มต้น",
	"action.set_timeline_range_start": "ตั้งจุดเริ่มช่วงเล่น",
	"action.set_timeline_range_start.desc": "กำหนดจุดเริ่มของช่วงที่ต้องการเล่นบนไทม์ไลน์",
	"action.set_timeline_range_end": "ตั้งจุดจบช่วงเล่น",
	"action.set_timeline_range_end.desc": "กำหนดจุดจบของช่วงที่ต้องการเล่นบนไทม์ไลน์",
	"action.disable_timeline_range": "ยกเลิกช่วงเล่นที่กำหนด",
	"action.disable_timeline_range.desc": "กลับไปเล่นตามช่วงปกติของแอนิเมชัน",
	"menu.texture_group.resolve": "แยกกลุ่ม",
	"menu.image_tiled_view.mirrored": "ขอบสะท้อน",
	"menu.image_onion_skin_view.frame": "เฟรม",
	"menu.image_onion_skin_view.frame.last_viewed": "เฟรมที่ดูล่าสุด",
	"menu.image_onion_skin_view.frame.previous": "เฟรมก่อนหน้า",
	"menu.image_onion_skin_view.frame.next": "เฟรมถัดไป",
	"menu.image_onion_skin_view.frame.both": "ก่อนหน้า + ถัดไป",
	"menu.image_onion_skin_view.display": "การแสดงผล",
	"menu.image_onion_skin_view.display.pixels": "พิกเซลเล็กลง",
	"menu.image_onion_skin_view.display.transparent": "โปร่งใส",
	"menu.image_onion_skin_view.above": "แสดงทับเฟรมปัจจุบัน",
	"menu.animation.reload": "โหลดใหม่",
	"switches.autouv.alt": "ตามตำแหน่งหน้า",
	"display.rotation_pivot": "จุดศูนย์กลางการหมุน",
	"display.scale_pivot": "จุดศูนย์กลางการปรับขนาด",
	"display.reference.fox": "สุนัขจิ้งจอก",
	"display.reference.eating": "กำลังกิน",
	"preview_scene.sky": "ท้องฟ้า",
	"preview_scene.space": "อวกาศ",
	"preview_scene.minecraft_ocean": "มหาสมุทร",
	"message.import_palette.selection_only": "เฉพาะที่เลือก",
	"dialog.blend_transition_edit.ease_in_out": "เริ่มและจบนุ่มนวล (%0)",
	"dialog.blend_transition_edit.generate": "สร้าง...",
	"dialog.blend_transition_edit.generate.learn_more": "ข้อมูลเพิ่มเติมและตัวอย่าง",
	"dialog.blend_transition_edit.generate.curve": "รูปแบบการเร่งและชะลอ",
	"dialog.blend_transition_edit.generate.steps": "คีย์เฟรม",
	"settings.fps_limit": "ขีดจำกัดเฟรมต่อวินาที",
	"settings.fps_limit.desc": "จำกัดจำนวนเฟรมต่อวินาทีที่ Blockbench เรนเดอร์ อัตราเฟรมจริงจำกัดตามที่อุปกรณ์ของคุณแสดงได้",
	"settings.outliner_reveal_on_select": "เลื่อนไปยังรายการที่เลือก",
	"settings.outliner_reveal_on_select.desc": "แสดงตำแหน่งชิ้นงานในรายการชิ้นงานเมื่อเลือกชิ้นงานนั้น",
	"settings.java_export_pivots": "ส่งออกจุดหมุนในโมเดลบล็อก/ไอเทม Java",
	"settings.java_export_pivots.desc": "บันทึกจุดหมุนในโมเดลบล็อก/ไอเทม Java บนคิวบ์ที่ไม่มีการหมุน",
	"animation_controllers.state.blend_transition_curve": "กราฟการเปลี่ยนท่า",
	"menu.slider.reset_vector": "รีเซ็ตค่าทุกแกน",
	"dialog.blend_transition_edit.extended": "กราฟขยาย",
	"message.screenshot_too_large.title": "ปัญหาความละเอียดภาพหน้าจอ",
	"message.screenshot_too_large.message": "สร้างภาพไม่สำเร็จ ลองลดความละเอียดหรือปิด SSAA",
	"message.rename_elements.numbering": "ใส่เครื่องหมายพิเศษในชื่อเพื่อเพิ่มเลขลำดับได้: % ใช้ลำดับของชิ้นงานในกลุ่ม ส่วน $ ใช้ลำดับภายในส่วนที่เลือก",
	"generic.edit_externally": "เปิดแก้ไขในโปรแกรมอื่น",
	"message.settings_require_restart.title": "ต้องรีสตาร์ท",
	"message.settings_require_restart.message": "การตั้งค่าบางอย่างจะมีผลหลังจากรีสตาร์ทโปรแกรม",
	"message.settings_require_restart.restart_now": "เปิดโปรแกรมใหม่ตอนนี้",
	"message.settings_require_restart.restart_later": "ทำภายหลัง",
	"message.classroom_mode.install_plugin": "ไม่สามารถติดตั้งปลั๊กอินในโหมดห้องเรียน",
	"dialog.collection.export_path": "ตำแหน่งไฟล์ที่ส่งออก",
	"dialog.collection.select_all": "เลือกทั้งหมด",
	"dialog.collection.select_none": "ยกเลิกเลือกทั้งหมด",
	"dialog.collection.add_with_filter": "เพิ่มด้วยตัวกรอง",
	"dialog.collection.remove": "ลบออก",
	"dialog.material_config.title": "การตั้งค่าวัสดุ",
	"dialog.material_config.color_value": "ค่าสี",
	"dialog.material_config.mer": "โลหะ / แสงเรือง / ความหยาบ (MER)",
	"dialog.material_config.mer_value": "ค่า MER",
	"dialog.material_config.depth_type": "ประเภทความลึก",
	"dialog.create_texture.disable_mirror_uv": "ปิดใช้งานการสะท้อน UV",
	"dialog.create_texture.disable_mirror_uv.desc": "ปิดการสะท้อน UV ขณะสร้างโมเดลแบบสะท้อน เพื่อให้แต่ละด้านใช้พื้นที่ UV แยกกัน",
	"dialog.create_gif.turn.sync_to_anim_length": "ซิงค์กับความยาวแอนิเมชัน",
	"settings.category.controls": "การควบคุม",
	"settings.classroom_mode": "โหมดห้องเรียน",
	"settings.classroom_mode.desc": "จำกัดฟังก์ชันบางอย่าง เช่น การติดตั้งปลั๊กอิน และลบลิงก์ไปยังโซเชียลมีเดีย",
	"settings.antialiasing_bleed_fix": "แก้สีล้นเมื่อเกลี่ยขอบหยัก",
	"settings.antialiasing_bleed_fix.desc": "ลดปัญหาสีเทกซ์เจอร์ล้นเมื่อเปิดการเกลี่ยขอบหยัก อาจใช้ไม่ได้กับอุปกรณ์รุ่นเก่า",
	"settings.tone_mapping": "ปรับโทนภาพ (Tone Mapping)",
	"settings.tone_mapping.desc": "เลือกวิธีปรับช่วงความสว่างของภาพ PBR ให้แสดงบนจอทั่วไปได้",
	"settings.audio_scrubbing": "ฟังเสียงขณะเลื่อนไทม์ไลน์",
	"settings.audio_scrubbing.desc": "เล่นเสียงช่วงสั้น ๆ ตามตำแหน่งที่ลากผ่านบนไทม์ไลน์",
	"settings.viewport_rotate_speed": "ความเร็วหมุนมุมมอง",
	"settings.viewport_rotate_speed.desc": "ปรับว่ามุมมองหมุนเร็วแค่ไหนเมื่อขยับเมาส์หรืออุปกรณ์ควบคุม",
	"settings.viewport_zoom_speed": "ความเร็วซูมมุมมอง",
	"settings.viewport_zoom_speed.desc": "ปรับว่ามุมมองซูมเร็วแค่ไหนเมื่อเลื่อนหรือขยับอุปกรณ์ควบคุม",
	"settings.editor_2d_zoom_speed": "ความเร็วซูมในพื้นที่ 2D",
	"settings.editor_2d_zoom_speed.desc": "ปรับความเร็วซูมในหน้าต่าง UV และพื้นที่ระบายสี 2D",
	"category.select": "เลือก",
	"action.vertex_snap_mode.rotate": "หมุน",
	"action.export_image": "ส่งออกรูปภาพ",
	"action.export_image.desc": "ส่งออกเทกซ์เจอร์เป็นไฟล์รูปภาพ",
	"action.apply_mirror_modeling": "สร้างสำเนาสะท้อนจากส่วนที่เลือก",
	"action.apply_mirror_modeling.desc": "คัดลอกชิ้นงานที่เลือกทั้งหมด แล้วพลิกสำเนาข้ามแกน X ไปยังอีกด้าน",
	"action.create_collection": "สร้างคอลเลกชัน",
	"action.create_collection.desc": "สร้างคอลเลกชันจากส่วนที่เลือกในรายการชิ้นงาน",
	"action.set_collection_content_to_selection": "แทนรายการในคอลเลกชันด้วยส่วนที่เลือก",
	"action.set_collection_content_to_selection.desc": "ใช้กลุ่มและชิ้นงานที่เลือกแทนรายการเดิมทั้งหมดในคอลเลกชัน",
	"action.add_to_collection": "เพิ่มส่วนที่เลือกในคอลเลกชัน",
	"action.add_to_collection.desc": "เพิ่มกลุ่มและชิ้นงานที่เลือกในคอลเลกชัน",
	"action.view_mode.material": "ตัวอย่างวัสดุ",
	"action.create_material": "สร้างวัสดุ",
	"action.create_material.desc": "สร้างวัสดุ PBR ใหม่จากเทกซ์เจอร์ที่เลือก",
	"action.generate_pbr_map": "สร้างแมป PBR...",
	"action.generate_pbr_map.desc": "สร้างภาพกำหนดความสูง ความเป็นโลหะ แสงเรือง หรือความหยาบสำหรับวัสดุ PBR จากเทกซ์เจอร์ที่มีอยู่",
	"menu.tools.main_tools": "กล่องเครื่องมือ",
	"menu.view.panels": "แผง",
	"menu.texture.pbr_channel": "ช่อง PBR",
	"menu.texture.pbr_channel.color": "สี",
	"menu.texture.pbr_channel.normal": "แนวผิว (Normal)",
	"menu.texture.pbr_channel.height": "ความสูง",
	"menu.texture.pbr_channel.mer": "MER (โลหะ / แสงเรือง / ความหยาบ)",
	"menu.texture.pbr_channel.mer_subsurface": "MER พร้อมการกระจายแสงใต้ผิว",
	"menu.collection.export_project": "ส่งออกโปรเจกต์",
	"menu.collection.export_as": "ส่งออกเป็น \"%0\"",
	"menu.panel.enable": "เปิดใช้",
	"menu.panel.move_to": "ย้ายไปยัง",
	"menu.panel.move_to.left_bar": "แถบข้างซ้าย",
	"menu.panel.move_to.right_bar": "แถบข้างขวา",
	"menu.panel.move_to.top": "ด้านบน",
	"menu.panel.move_to.bottom": "ด้านล่าง",
	"menu.panel.move_to.float": "หน้าต่างลอย",
	"menu.panel.move_to.hidden": "ซ่อน",
	"menu.panel.fold": "พับแผง",
	"menu.mirror_painting.texture_center": "จุดกึ่งกลางการสะท้อน",
	"menu.mirror_modeling.mirror_uv": "สะท้อน UV",
	"menu.animation_onion_skin.frames": "เฟรม",
	"menu.animation_onion_skin.select": "เลือก",
	"menu.animation_onion_skin.previous": "ก่อนหน้า",
	"menu.animation_onion_skin.next": "ถัดไป",
	"menu.animation_onion_skin.previous_next": "ก่อนหน้า + ถัดไป",
	"menu.animation_onion_skin.count": "จำนวน",
	"menu.animation_onion_skin.interval": "ระยะห่างระหว่างเฟรม",
	"menu.animation_onion_skin_selective": "แสดงท่าอ้างอิงเฉพาะส่วนที่เลือก",
	"menu.animation_onion_skin_selective.desc": "แสดงโครงลวดจากเฟรมอื่นเฉพาะส่วนของโมเดลที่เลือก",
	"edit.loop_cut.unit": "หน่วย",
	"edit.loop_cut.unit.size_units": "หน่วยของโมเดล",
	"edit.loop_cut.unit.percent": "เปอร์เซ็นต์",
	"edit.extrude_mesh_selection.direction": "ทิศทาง",
	"edit.extrude_mesh_selection.direction.outwards": "ออกด้านนอก",
	"edit.extrude_mesh_selection.direction.average": "เฉลี่ย",
	"edit.extrude_mesh_selection.even_extend": "ดึงให้หนาเท่ากัน",
	"edit.vertex_snap.align": "จัดแนว",
	"edit.vertex_snap.align.longest": "แกนที่ยาวที่สุด",
	"edit.vertex_snap.align.direction": "ทิศทางจากจุดหมุน",
	"edit.vertex_snap.align.align_axis": "แกน %0",
	"edit.vertex_snap.ignore_axis": "ไม่ปรับแกน",
	"codec.common.format": "รูปแบบ",
	"codec.image.quality": "คุณภาพ",
	"panel.collections": "คอลเลกชัน",
	"modifier_actions.always": "เปิดใช้งานเสมอ",
	"modifier_actions.unless": "ยกเว้น %0",
	"settings.undo_selections": "เลิกทำการเลือก",
	"settings.undo_selections.desc": "เก็บการเปลี่ยนส่วนที่เลือกไว้ในประวัติ เพื่อให้เลิกทำได้",
	"action.focus_on_selection.zoom": "ซูมให้พอดี",
	"display.reference.tooting": "เป่าเขาแพะ",
	"settings.selection_tolerance": "พื้นที่คลิกเลือกจุดและขอบ",
	"settings.selection_tolerance.desc": "กำหนดว่าคลิกห่างจากจุดยอดหรือขอบได้แค่ไหนจึงจะยังเลือกได้",
	"action.delete.keep_vertices": "คงขอบ/จุดยอด",
	"menu.mesh": "เมช",
	"dialog.material_config.subsurface": "การกระจายแสงใต้ผิว (Subsurface)",
	"dialog.material_config.subsurface_enabled.desc": "ใช้ช่องอัลฟาของแมป MER กำหนดการกระจายแสงใต้ผิววัสดุ",
	"settings.pick_combined_color": "ดูดสีจากทุกเลเยอร์รวมกัน",
	"settings.pick_combined_color.desc": "ดูดสีที่มองเห็นจากทุกเลเยอร์รวมกัน แทนการดูดเฉพาะสีบนเลเยอร์ปัจจุบัน",
	"action.split_rgb_into_layers": "แยกช่อง RGBA เป็นเลเยอร์",
	"action.split_rgb_into_layers.desc": "แยกสีแดง เขียว และน้ำเงินเป็นเลเยอร์ผสมสีแบบบวก และแยกช่องอัลฟาเป็นเลเยอร์มาสก์ความโปร่งใส",
	"dialog.project.java_block_version": "เวอร์ชันรูปแบบ",
	"data.spline_mesh": "เส้นโค้ง (Spline)",
	"data.billboard": "แผ่นภาพหันเข้ากล้อง (Billboard)",
	"data.armature": "โครงกระดูก (Armature)",
	"data.armature_bone": "กระดูกในโครง",
	"generic.reload": "โหลดใหม่",
	"modifier_actions.subtract": "ลบออก",
	"modifier_actions.reduced_intensity": "ปรับละเอียด",
	"modifier_actions.select_bone": "เลือกกระดูก",
	"modifier_actions.spline_select_multiple_points": "เลือกหลายจุดหรือแขนควบคุม",
	"modifier_actions.move_panel_without_docking": "ย้ายโดยไม่ตรึง",
	"message.save_all_textures.message": "ต้องการบันทึกเทกซ์เจอร์แต่ละภาพต่อไปนี้หรือไม่?",
	"message.save_all_textures.skip": "ข้าม",
	"dialog.add_spline.shape": "รูปทรง",
	"dialog.add_spline.shape.segment": "เส้นตรง",
	"dialog.add_spline.shape.square": "สี่เหลี่ยมผืนผ้า",
	"dialog.add_spline.shape.circle": "วงกลม",
	"dialog.add_spline.diameter": "เส้นผ่านศูนย์กลาง",
	"dialog.add_spline.sides_tubular": "จำนวนช่วงตามแนวท่อ",
	"dialog.add_spline.sides_radial": "จำนวนด้านรอบท่อ",
	"dialog.add_spline.radius": "รัศมีท่อ",
	"dialog.add_spline.length": "ความยาว",
	"dialog.add_spline.width": "ความกว้าง",
	"dialog.plugins.revoke_permissions": "เพิกถอนสิทธิ์",
	"dialog.expression_editor.pretty_print": "จัดโค้ดให้อ่านง่าย",
	"dialog.expression_editor.minify": "ย่อโค้ด",
	"dialog.expression_editor.find_replace": "ค้นหา/แทนที่",
	"dialog.create_gif.show_gizmos": "บันทึกตัวควบคุมและกริดด้วย",
	"dialog.preview_options.title": "ตั้งค่ามุมมองตัวอย่าง",
	"dialog.preview_options.background": "พื้นหลัง",
	"dialog.preview_options.background.checkerboard": "ตารางหมากรุก",
	"dialog.preview_options.background.solid": "ทึบ",
	"dialog.preview_options.background.custom_color": "สีกำหนดเอง",
	"dialog.preview_options.show_gizmos": "แสดงตัวควบคุมบนโมเดล",
	"dialog.skin.texture_source": "แหล่งเทกซ์เจอร์",
	"dialog.skin.texture_source.template": "สร้างเทมเพลต",
	"dialog.skin.texture_source.load_texture": "โหลดจาก Minecraft",
	"dialog.skin.texture_file": "ไฟล์เทกซ์เจอร์",
	"dialog.convert_skin.adjust_texture": "ปรับเทกซ์เจอร์",
	"dialog.settings.clear_profile_value": "ล้างค่าโปรไฟล์",
	"layout.section.customize": "ปรับแต่ง",
	"layout.theme.configure": "กำหนดค่า",
	"layout.color.elevated": "ส่วนที่ลอยเหนือพื้นหลัง",
	"layout.color.elevated.desc": "ส่วนของหน้าตาโปรแกรมที่ดูยกขึ้นจากพื้นหลัง มักแยกด้วยเงา",
	"layout.file.watch_changes": "โหลดใหม่เมื่อไฟล์เปลี่ยน",
	"settings.autocomplete_code": "เติมโค้ดอัตโนมัติ",
	"settings.autocomplete_code.desc": "แสดงคำแนะนำขณะพิมพ์โค้ด",
	"settings.detect_flipbook_textures": "ตรวจจับเทกซ์เจอร์เคลื่อนไหว",
	"settings.detect_flipbook_textures.desc": "ตรวจจับภาพที่รวมหลายเฟรมไว้ในเทกซ์เจอร์เดียว แล้วเล่นเป็นแอนิเมชันให้อัตโนมัติ",
	"settings.double_click_select_reference": "เลือกภาพอ้างอิงเมื่อดับเบิลคลิก",
	"settings.double_click_select_reference.desc": "ดับเบิลคลิกมุมมองโมเดลเพื่อเลือกภาพอ้างอิง",
	"settings.default_keyframe_interpolation": "การเปลี่ยนค่าระหว่างคีย์เฟรมเริ่มต้น",
	"settings.default_keyframe_interpolation.desc": "เลือกวิธีเปลี่ยนค่าระหว่างคีย์เฟรมที่จะใช้เป็นค่าเริ่มต้น",
	"settings.color_picker_style": "รูปแบบแผงเลือกสี",
	"settings.color_picker_style.desc": "เลือกรูปแบบแผงเลือกสีในโหมดระบายสี",
	"settings.export_asset_paths": "วิธีบันทึกตำแหน่งไฟล์ที่ใช้ร่วมกัน",
	"settings.export_asset_paths.desc": "เลือกวิธีบันทึกตำแหน่งไฟล์เทกซ์เจอร์และแอนิเมชันที่โปรเจกต์อ้างอิงไว้ในไฟล์ .bbmodel",
	"settings.export_asset_paths.relative": "ตำแหน่งเทียบกับไฟล์โปรเจกต์",
	"settings.export_asset_paths.absolute": "ตำแหน่งไฟล์แบบเต็ม",
	"settings.export_asset_paths.both": "ทั้งแบบเทียบโปรเจกต์และแบบเต็ม (เฉพาะเทกซ์เจอร์)",
	"settings.export_asset_paths.none": "ไม่ส่งออก",
	"action.slider_spline_resolution": "ความละเอียดเส้นโค้ง %0",
	"action.slider_spline_resolution.desc": "ปรับความละเอียดเส้นโค้งตามแกน %0 (%1)",
	"action.slider_spline_resolution.u.desc_precision": "จำนวนด้านรอบท่อ",
	"action.slider_spline_resolution.v.desc_precision": "จำนวนช่วงตามแนวท่อ",
	"action.slider_spline_radius": "รัศมีเส้นโค้ง",
	"action.slider_spline_radius.desc": "ปรับรัศมีของเส้นโค้ง",
	"action.slider_spline_handle_tilt": "มุมเอียงแขนควบคุม",
	"action.slider_spline_handle_tilt.desc": "ปรับมุมเอียงของแขนควบคุมเส้นโค้ง",
	"action.slider_spline_handle_size": "ขนาดแขนควบคุม",
	"action.slider_spline_handle_size.desc": "ปรับขนาดแขนควบคุมเส้นโค้ง",
	"action.blend_mode.lighten": "สีที่สว่างกว่า (Lighten)",
	"action.blend_mode.darken": "สีที่มืดกว่า (Darken)",
	"action.weight_brush": "แปรงน้ำหนักกระดูก",
	"action.weight_brush.desc": "ระบายว่าจุดยอดบนเมชจะขยับตามกระดูกมากแค่ไหน ค่ายิ่งมาก จุดนั้นยิ่งขยับตามกระดูกมาก",
	"action.convert_minecraft_skin_variant": "สลับสกินแขนเล็ก/แขนกว้าง",
	"action.convert_minecraft_skin_variant.desc": "สลับระหว่างสกินแขนกว้างแบบ Steve กับแขนเล็กแบบ Alex และเลือกให้ปรับเทกซ์เจอร์ให้พอดีอัตโนมัติได้",
	"action.custom_skin_poses": "ท่าสกินกำหนดเอง",
	"action.custom_skin_poses.desc": "โหลดพรีเซ็ตท่าสกินกำหนดเอง",
	"action.custom_skin_poses.update": "อัปเดตท่า",
	"action.custom_skin_poses.update.desc": "เขียนทับท่าที่บันทึกด้วยท่าปัจจุบันของโมเดล",
	"action.add_custom_skin_pose": "เพิ่มท่าสกินกำหนดเอง",
	"action.add_custom_skin_pose.desc": "บันทึกท่าปัจจุบันของโมเดลเป็นพรีเซ็ตท่า",
	"action.export_stl": "ส่งออก STL",
	"action.export_stl.desc": "ส่งออกโมเดล STL สำหรับพิมพ์ 3D",
	"action.add_element": "เพิ่มชิ้นงาน",
	"action.add_element.desc": "เพิ่มชิ้นงานใหม่จากรายการประเภทชิ้นงาน",
	"action.add_spline": "เพิ่มเส้นโค้ง",
	"action.add_spline.desc": "เพิ่มเส้นโค้งที่ปรับรูปทรงด้วยจุดและแขนควบคุมได้",
	"action.add_billboard": "เพิ่มแผ่นภาพหันเข้ากล้อง",
	"action.add_billboard.desc": "เพิ่มแผ่นภาพ Billboard ที่ปรับทิศทางให้หันเข้าหากล้อง",
	"action.add_armature": "เพิ่มโครงกระดูก",
	"action.add_armature.desc": "เพิ่มโครงกระดูกสำหรับควบคุมให้เมชขยับและเปลี่ยนรูปตามแอนิเมชัน",
	"action.add_armature_bone": "เพิ่มกระดูกในโครง",
	"action.add_armature_bone.desc": "เพิ่มกระดูกใหม่ในโครงกระดูก",
	"action.search_textures": "ค้นหาเทกซ์เจอร์",
	"action.search_textures.desc": "ค้นหาเทกซ์เจอร์ตามชื่อ",
	"action.search_animations": "ค้นหาแอนิเมชัน",
	"action.search_animations.desc": "ค้นหาแอนิเมชันตามชื่อ",
	"action.spline_selection_mode": "โหมดเลือกเส้นโค้ง",
	"action.spline_selection_mode.object": "ทั้งเส้น",
	"action.spline_selection_mode.handles": "แขนควบคุม",
	"action.spline_render_mode": "รูปทรงที่แสดง",
	"action.spline_render_mode.mesh": "เมช",
	"action.spline_render_mode.path": "เส้นทาง",
	"action.spline_render_mode.desc": "เลือกให้เส้นโค้งแสดงเป็นรูปทรงเมชหรือเป็นเส้น",
	"action.spline_uv_mode": "รูปแบบ UV",
	"action.spline_uv_mode.length_accurate": "ตามความยาวจริง",
	"action.spline_uv_mode.uniform": "กระจายสม่ำเสมอ",
	"action.spline_uv_mode.per_segment": "แยกแต่ละช่วง",
	"action.spline_uv_mode.desc": "เลือกวิธีวาง UV บนรูปทรงท่อที่สร้างจากเส้นโค้ง",
	"action.spline_ring_segments": "จำนวนด้านรอบท่อ",
	"action.spline_ring_segments.desc": "จำนวนด้านที่แบ่งรอบหน้าตัดท่อของเส้นโค้งนี้",
	"action.spline_tube_segments": "จำนวนช่วงตามแนวท่อ",
	"action.spline_tube_segments.desc": "จำนวนช่วงที่แบ่งตามความยาวของเส้นโค้งนี้",
	"action.spline_tube_radius": "รัศมีท่อ",
	"action.spline_tube_radius.desc": "กำหนดรัศมีท่อที่สร้างจากเส้นโค้ง",
	"action.spline_display_space": "แสดงแนวแกนตามเส้นโค้ง",
	"action.spline_display_space.desc": "แสดงเครื่องหมายบอกแนวแกนตามจุดต่าง ๆ บนเส้นโค้ง",
	"action.spline_handle_mode": "โหมดแขนควบคุมเส้นโค้ง",
	"action.spline_handle_mode.desc": "เลือกวิธีที่แขนควบคุมสองด้านจะขยับสัมพันธ์กัน",
	"action.spline_handle_mode.aligned": "อยู่ในแนวเดียวกัน",
	"action.spline_handle_mode.free": "อิสระ",
	"action.spline_handle_mode.mirrored": "สะท้อนเท่ากัน",
	"action.slider_weight_brush_size": "ขนาดแปรงน้ำหนักกระดูก",
	"action.weight_brush_xray": "ระบายน้ำหนักทะลุผิว",
	"action.weight_brush_xray.desc": "ให้แปรงน้ำหนักกระดูกมีผลถึงจุดยอดด้านหลังที่มองไม่เห็นด้วย",
	"action.apply_spline_rotation": "ใช้ทิศทางนี้เป็นค่าหมุนเริ่มต้น",
	"action.apply_spline_rotation.desc": "นำการหมุนไปใช้กับรูปทรงเส้นโค้งโดยตรง แล้วตั้งค่าการหมุนเป็นศูนย์ โดยให้รูปทรงที่เห็นคงเดิม",
	"action.extrude_spline_selection": "ต่อเส้นโค้ง",
	"action.extrude_spline_selection.desc": "ดึงต่อจากส่วนที่เลือกเพื่อเพิ่มช่วงใหม่ให้เส้นโค้ง",
	"action.split_spline": "แยกเส้นโค้ง",
	"action.split_spline.desc": "แบ่งเส้นโค้งเป็นสองเส้นตรงแขนควบคุมที่เลือก",
	"action.divide_spline_curve": "แบ่งช่วงเส้นโค้ง",
	"action.divide_spline_curve.desc": "เพิ่มจุดแบ่งบนช่วงของเส้นโค้ง",
	"action.set_vertex_weights": "กำหนดน้ำหนักกระดูกให้จุดยอด",
	"action.set_vertex_weights.desc": "กำหนดว่าจุดยอดที่เลือกจะขยับตามกระดูกที่ระบุมากแค่ไหน",
	"action.calculate_vertex_weights": "คำนวณน้ำหนักกระดูกอัตโนมัติ",
	"action.calculate_vertex_weights.desc": "กำหนดว่าจุดยอดจะขยับตามกระดูกมากแค่ไหน โดยคำนวณจากตำแหน่งกระดูก",
	"action.shelf_alignment": "ตำแหน่งบนชั้นวาง",
	"action.shelf_alignment.desc": "เลือกการจัดแนวแนวตั้งของไอเทมบนชั้นวาง",
	"action.shelf_alignment.top": "จัดชิดบน",
	"action.shelf_alignment.bottom": "จัดชิดล่าง",
	"action.view_mode.vertex_weight": "น้ำหนักจุดยอด",
	"action.view_mode.weighted_bone_colors": "แสดงสีตามกระดูกที่มีผล",
	"action.create_animation_group": "สร้างกลุ่มแอนิเมชัน",
	"action.create_animation_group.desc": "สร้างกลุ่มของแอนิเมชัน",
	"action.move_graph_keyframes_up": "เลื่อนคีย์เฟรมขึ้นในกราฟ",
	"action.move_graph_keyframes_down": "เลื่อนคีย์เฟรมลงในกราฟ",
	"menu.skin": "สกิน",
	"menu.text_edit.expression_editor": "แก้ไขสูตร",
	"menu.color_picker.picker_type.normal": "แนวผิว (Normal Map)",
	"menu.texture.flipbook_animation": "เทกซ์เจอร์เคลื่อนไหว",
	"menu.panel.attach_to": "แนบกับ",
	"menu.animation.playing": "กำลังเล่น",
	"menu.animation_file.save_as": "บันทึกเป็น",
	"menu.animator.quaternion_interpolation": "เปลี่ยนค่าการหมุนระหว่างคีย์เฟรมแบบ Quaternion",
	"edit.extrude_spline_selection.extend": "ระยะต่อ",
	"edit.divide_spline_curve.position": "ตำแหน่ง",
	"group.bedrock_binding": "กระดูกที่ผูกไว้",
	"group.cem_attach": "แนบโมเดล CEM",
	"group.cem_model": "โมเดล CEM",
	"group.cem_scale": "ขนาดโมเดล CEM",
	"cube.rescale": "ชดเชยขนาดเมื่อหมุน",
	"cube.rescale.desc": "ปรับขนาดคิวบ์เพื่อชดเชยความกว้างที่เปลี่ยนไปเมื่อหมุน",
	"mesh.shading": "การแรเงา",
	"mesh.shading.flat": "เห็นเหลี่ยม",
	"mesh.shading.smooth": "เรียบเนียน",
	"spline_mesh.cyclic": "เชื่อมปลายเป็นวง",
	"spline_mesh.cyclic.desc": "เชื่อมปลายทั้งสองของเส้นโค้งที่เลือกให้เป็นวงปิด",
	"billboard.offset": "ระยะเยื้อง",
	"billboard.facing_mode": "โหมดหันหน้า",
	"billboard.facing_mode.lookat": "หันหาตำแหน่งกล้อง",
	"billboard.facing_mode.lookat_y": "หันหาตำแหน่งกล้องเฉพาะแกน Y",
	"billboard.facing_mode.rotate": "หมุนตามมุมกล้อง",
	"billboard.facing_mode.rotate_y": "หมุนตามมุมกล้องเฉพาะแกน Y",
	"armature_bone.connected": "เชื่อมต่อ",
	"reference_image.blueprint": "ล็อกเป็นภาพแบบร่าง",
	"codec.image.alpha_channel": "ความโปร่งใส (Alpha)",
	"codec.image.animation_fps": "เฟรมต่อวินาทีของแอนิเมชัน",
	"panel.palette": "ชุดสี",
	"panel.keyframe.change_effect_file": "เปลี่ยนไฟล์เอฟเฟกต์",
	"panel.transform": "ย้าย / หมุน / ปรับขนาด",
	"panel.element.spline_dimensions": "ขนาดเส้นโค้ง",
	"display.slot.on_shelf": "ชั้นวาง",
	"display.reference.shelf": "ชั้นวาง (ทุกช่อง)",
	"display.reference.shelf_left": "ชั้นวาง (ช่องซ้าย)",
	"display.reference.shelf_center": "ชั้นวาง (ช่องกลาง)",
	"display.reference.shelf_right": "ชั้นวาง (ช่องขวา)",
	"message.newer_project_format_version.title": "ต้องใช้ Blockbench เวอร์ชันใหม่กว่า",
	"message.newer_project_format_version.message": "ไฟล์นี้บันทึกด้วย Blockbench เวอร์ชันใหม่กว่า โปรดอัปเดตเป็น %0 หรือใหม่กว่าเพื่อเปิดไฟล์ได้ถูกต้อง",
	"message.load_images.add_layer": "เพิ่มเป็นเลเยอร์",
	"message.load_images.category.add_to_project": "เพิ่มในโปรเจกต์",
	"message.load_images.category.new_project": "โปรเจกต์ใหม่",
	"message.load_palette.title": "โหลดชุดสี",
	"message.load_palette.message": "ต้องการโหลดชุดสีนี้หรือไม่? ชุดสีปัจจุบันจะถูกแทนที่",
	"dialog.set_vertex_weights.weight": "น้ำหนักกระดูก",
	"dialog.set_vertex_weights.overwrite": "แทนที่น้ำหนักจากกระดูกอื่น",
	"action.element_render_order.short": "ลำดับการแสดงผล",
	"action.element_render_order.desc": "กำหนดลำดับการแสดงชิ้นงาน เพื่อแก้กรณีที่ชิ้นงานถูกบังผิดตำแหน่งโดยเทกซ์เจอร์โปร่งใส สำหรับชิ้นงานทึบให้ใช้ค่าอัตโนมัติ",
	"spline.shading.flat": "เห็นเหลี่ยม",
	"spline.shading.smooth": "เรียบเนียน",
	"spline.shading": "การแรเงา",
	"spline.shading.desc": "เลือกวิธีแรเงาผิวท่อของเส้นโค้งนี้",
	"action.slider_weight_brush_limit": "น้ำหนักสูงสุดของแปรง",
	"action.slider_weight_brush_limit.desc": "กำหนดน้ำหนักสูงสุดที่แปรงจะระบายให้จุดยอดได้",
	"action.weight_brush_blend_mode": "วิธีปรับน้ำหนักด้วยแปรง",
	"action.weight_brush_blend_mode.set": "ตั้งค่า",
	"action.weight_brush_blend_mode.add": "เพิ่ม",
	"action.apply_texture_to_elements": "ใช้เทกซ์เจอร์กับชิ้นงาน",
	"action.apply_texture_to_elements.desc": "ใช้เทกซ์เจอร์ที่เลือกกับชิ้นงานที่เลือก",
	"menu.panel.reset_size": "รีเซ็ตขนาด",
	"action.import_layer": "นำเข้าเลเยอร์",
	"action.import_layer.desc": "นำเข้าไฟล์รูปภาพเป็นเลเยอร์",
	"menu.collection.open_file": "เปิดไฟล์",
	"layout.version": "เวอร์ชัน",
	"settings.status_bar_transform_sliders": "แสดงช่องปรับชิ้นงานในแถบสถานะ",
	"settings.status_bar_transform_sliders.desc": "แสดงช่องปรับค่าของเครื่องมือปัจจุบันในแถบสถานะ แทนแผงย้าย หมุน และปรับขนาด",
	"settings.default_bedrock_format": "รูปแบบ Bedrock เริ่มต้น",
	"settings.default_bedrock_format.desc": "เลือกรูปแบบที่จะใช้เปิดโมเดล Minecraft Bedrock เมื่อโปรแกรมตรวจหารูปแบบเองไม่ได้",
	"settings.limit_brush_opacity_per_stroke": "จำกัดความทึบต่อการลากแปรง",
	"settings.limit_brush_opacity_per_stroke.desc": "ในการลากแปรงแต่ละครั้ง ให้ความทึบไม่เกินค่าที่ตั้งไว้ การใช้กับแปรงขอบนุ่มอาจทำให้เกิดจุดรบกวนเล็กน้อย",
	"action.merge_splines": "รวมเส้นโค้ง",
	"action.merge_splines.desc": "รวมเส้นโค้งหลายเส้นเป็นเส้นเดียว",
	"settings.default_java_block_version": "เวอร์ชันบล็อก/ไอเทม Java เริ่มต้น",
	"settings.default_java_block_version.desc": "เวอร์ชันรูปแบบเริ่มต้นเมื่อสร้างโมเดลบล็อก/ไอเทม Java ใหม่หรือเปิดไฟล์ที่ไม่มีเวอร์ชันรูปแบบ",
	"data.bounding_box": "กรอบขอบเขต",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "กดเมาส์ซ้ายแล้วลากแนวนอน",
	"keys.slide_lmb_vertical": "กดเมาส์ซ้ายแล้วลากแนวตั้ง",
	"keys.slide_rmb_horizontal": "กดเมาส์ขวาแล้วลากแนวนอน",
	"keys.slide_rmb_vertical": "กดเมาส์ขวาแล้วลากแนวตั้ง",
	"message.recover_backup.unknown_project": "โปรเจกต์ไม่ทราบชื่อ",
	"message.recover_backup.discard_others": "ทิ้งรายการอื่นทั้งหมด",
	"message.unsupported_file_extension.title": "รูปแบบไฟล์ไม่รองรับ",
	"message.unsupported_file_extension.message": "เปิดไฟล์ %0 ไม่ได้ เพราะยังไม่รองรับรูปแบบนี้ อาจต้องติดตั้งปลั๊กอินสำหรับไฟล์ประเภทนี้",
	"message.unsupported_file_extension.open_in_default_program": "เปิดในโปรแกรมเริ่มต้น",
	"dialog.project.uv_size": "ขนาด UV",
	"dialog.collection.offset": "ระยะเยื้อง",
	"dialog.texture.fps": "เฟรมต่อวินาที",
	"dialog.texture.fps.desc": "จำนวนเฟรมต่อวินาทีที่ใช้เล่นเทกซ์เจอร์เคลื่อนไหว",
	"dialog.edit_uv_size.title": "แก้ไขขนาด UV",
	"dialog.edit_uv_size.target": "เป้าหมาย",
	"dialog.edit_uv_size.adjust": "ปรับ",
	"dialog.edit_uv_size.adjust.adjust_uv": "ปรับ UV ชดเชย",
	"dialog.edit_uv_size.adjust.adjust_scale": "ปรับ UV และขนาดชดเชย",
	"dialog.edit_uv_size.adjust.keep": "คง UV เดิม",
	"dialog.edit_uv_size.target_size": "ขนาด UV ใหม่",
	"dialog.edit_uv_size.preset.original": "ต้นฉบับ",
	"dialog.edit_uv_size.preset.match_texture": "เท่ากับขนาดเทกซ์เจอร์",
	"dialog.edit_uv_size.result": "ผลลัพธ์",
	"dialog.edit_uv_size.result.textures": "เทกซ์เจอร์",
	"dialog.adjust_brightness_contrast.brightness": "ความสว่าง",
	"dialog.adjust_brightness_contrast.contrast": "คอนทราสต์",
	"dialog.adjust_saturation_hue.saturation": "ความสดของสี",
	"dialog.adjust_saturation_hue.hue": "เฉดสี",
	"dialog.adjust_opacity.mode": "โหมด",
	"dialog.adjust_opacity.mode.multiply": "คูณ",
	"dialog.adjust_opacity.mode.set": "ตั้งค่า",
	"dialog.bedrock_bounding_box.type": "ประเภท",
	"dialog.bedrock_bounding_box.type.collision_box": "กรอบการชน",
	"dialog.bedrock_bounding_box.type.selection_box": "กรอบเลือก",
	"dialog.bedrock_bounding_box.type.hitbox": "กรอบรับการโจมตี",
	"dialog.bedrock_bounding_box.hitbox_note": "กรอบรับการโจมตีของเอนทิตีใช้ได้เฉพาะขนาดที่รองรับ และในเกมอาจไม่หมุนตามเอนทิตี",
	"dialog.bedrock_bounding_box.collision_note": "กรอบการชนของเอนทิตีรองรับเพียงกรอบเดียวที่วางกึ่งกลาง และเมื่อมองจากด้านบนต้องเป็นสี่เหลี่ยมจัตุรัส",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "ไม่มีกรอบขอบเขตในโปรเจกต์นี้",
	"dialog.install_plugins_from_list.ids": "ID ปลั๊กอิน",
	"dialog.install_plugins_from_list.info": "ติดตั้งปลั๊กอินหลายตัวจากรายการ ID ได้ ก่อนติดตั้งควรตรวจว่าใช้ทุกตัวจริง ๆ เพราะปลั๊กอินที่ไม่จำเป็นอาจทำให้เกิดข้อผิดพลาดหรือมีปัญหากับอัปเดตในอนาคต",
	"dialog.copy_installed_plugins.details": "รวมรายละเอียด",
	"dialog.flip_animation.phase_offset": "เลื่อนจังหวะแอนิเมชัน",
	"dialog.flip_animation.phase_offset.off": "ปิด",
	"dialog.flip_animation.phase_offset.custom": "กำหนดเอง",
	"dialog.flip_animation.clear_opposite": "เขียนทับด้านตรงข้าม",
	"settings.flipbook_textures_in_animation": "เล่นเทกซ์เจอร์เคลื่อนไหวตามแอนิเมชัน",
	"settings.flipbook_textures_in_animation.desc": "เล่นเฟรมของเทกซ์เจอร์เคลื่อนไหวไปพร้อมกับไทม์ไลน์แอนิเมชัน",
	"settings.display_uv": "แสดงหน้า UV",
	"settings.display_uv.desc": "เลือกหน้า UV ที่แสดงในหน้าต่าง UV",
	"settings.display_uv.selected_faces": "เฉพาะหน้าที่เลือก",
	"settings.display_uv.selected_elements": "หน้าทั้งหมดบนชิ้นงานที่เลือก",
	"settings.display_uv.all_elements": "หน้าทั้งหมดบนชิ้นงานทั้งหมด",
	"settings.local_position_values": "แสดงตำแหน่งแบบสัมพัทธ์ (Local)",
	"settings.local_position_values.desc": "แสดงค่าตำแหน่งในแผงย้าย หมุน และปรับขนาดเป็นพิกัดภายใน โดยอ้างอิงจุดกำเนิดของชิ้นงานหรือกลุ่มแม่ตามชนิดชิ้นงาน",
	"settings.transform_cube_from_center": "ใช้จุดกึ่งกลางเป็นตำแหน่งคิวบ์",
	"settings.transform_cube_from_center.desc": "ให้ค่าตำแหน่งคิวบ์อ้างอิงจุดกึ่งกลางแทนมุม",
	"settings.color_picker_tool_switch": "สลับแปรง/ยางลบตามสีที่ดูด",
	"settings.color_picker_tool_switch.desc": "เมื่อดูดพิกเซลโปร่งใส ให้สลับเป็นยางลบ เมื่อดูดสีขณะใช้ยางลบ ให้สลับกลับเป็นแปรง",
	"keybind.preview_scroll_zoom": "ซูมมุมมอง",
	"keybind.uv_editor_scroll_zoom": "ซูม UV/2D",
	"action.blend_mode.alpha_mask": "มาสก์ความโปร่งใส",
	"action.swap_tools.hold": "กดค้างเพื่อใช้หลอดดูดสี",
	"action.import_bedrock_voxel_shape": "นำเข้ารูปทรงวอกเซล Bedrock",
	"action.import_bedrock_voxel_shape.desc": "เพิ่มรูปทรงวอกเซลจากไฟล์ json ในโปรเจกต์ปัจจุบัน",
	"action.export_bedrock_voxel_shape": "ส่งออกรูปทรงวอกเซล Bedrock",
	"action.export_bedrock_voxel_shape.desc": "ส่งออกกรอบขอบเขตในโปรเจกต์เป็นไฟล์รูปทรงวอกเซล Bedrock",
	"action.plugins_window_menu": "เมนู",
	"action.copy_installed_plugins": "คัดลอกรายชื่อปลั๊กอินที่ติดตั้ง",
	"action.copy_installed_plugins.desc": "สร้างและคัดลอกรายการปลั๊กอินที่ติดตั้งอยู่",
	"action.install_plugins_from_list": "ติดตั้งปลั๊กอินจากรายการ",
	"action.install_plugins_from_list.desc": "ติดตั้งปลั๊กอินจากรายการ ID ปลั๊กอิน",
	"action.add_bounding_box": "เพิ่มกรอบขอบเขต",
	"action.add_bounding_box.desc": "เพิ่มกรอบขอบเขตใหม่",
	"action.split_alpha_into_layer": "แยกความโปร่งใสเป็นเลเยอร์",
	"action.split_alpha_into_layer.desc": "แยกข้อมูลความโปร่งใสของเทกซ์เจอร์ออกเป็นเลเยอร์มาสก์",
	"action.generate_bedrock_block_box": "คัดลอกข้อมูลกรอบชน/กรอบเลือก",
	"action.generate_bedrock_block_box.desc": "สร้างข้อมูลคอมโพเนนต์กรอบการชนหรือกรอบเลือกสำหรับบล็อก Minecraft Bedrock Edition",
	"action.generate_bedrock_entity_box": "คัดลอกข้อมูลกรอบชน/กรอบรับการโจมตี",
	"action.generate_bedrock_entity_box.desc": "สร้างข้อมูลคอมโพเนนต์กรอบการชนหรือกรอบรับการโจมตีสำหรับเอนทิตี Minecraft Bedrock Edition",
	"action.refresh_texture": "รีเฟรชเทกซ์เจอร์",
	"action.refresh_texture.desc": "โหลดเทกซ์เจอร์ใหม่จากไฟล์",
	"action.move_uv_to_cursor": "ย้าย UV ไปยังเคอร์เซอร์",
	"action.move_uv_to_cursor.desc": "ย้ายหน้า UV ที่เลือกไปยังตำแหน่งเคอร์เซอร์เมาส์",
	"action.edit_mode_uv_overlay": "แสดง UV ของทุกชิ้นงาน",
	"action.round_keyframe_values": "ปัดค่าคีย์เฟรม",
	"action.round_keyframe_values.desc": "ปัดค่าทั้งหมดของคีย์เฟรมที่เลือก",
	"action.keyframe_column_create.all_channels": "ทุกช่อง",
	"action.keyframe_column_create.all_channels.desc": "เพิ่มคีย์เฟรมให้ทุกช่อง รวมถึงช่องที่ยังไม่มีคีย์เฟรม",
	"action.add_all_to_timeline": "เพิ่มทั้งหมดในไทม์ไลน์",
	"action.mirror_animating": "ทำแอนิเมชันแบบสะท้อน",
	"action.mirror_animating.desc": "สะท้อนการแก้ไขแอนิเมชันไปยังด้านตรงข้าม",
	"action.copy_animation_pose": "คัดลอกท่าแอนิเมชัน",
	"action.copy_animation_pose.desc": "คัดลอกคีย์เฟรมที่ใช้สร้างท่าปัจจุบันของแอนิเมชัน",
	"menu.texture.file_format": "รูปแบบไฟล์",
	"menu.texture.wrap_mode": "การแสดงผลนอกขอบเทกซ์เจอร์",
	"menu.texture.wrap_mode.limited": "จำกัดในขอบภาพ",
	"menu.texture.wrap_mode.repeat": "เรียงภาพซ้ำ",
	"menu.texture.wrap_mode.clamp": "ยืดสีพิกเซลริมภาพ",
	"edit.reparent_selection.adjust_position": "คงตำแหน่งและทิศทางในฉาก",
	"texture_mesh.texture_name": "ชื่อเทกซ์เจอร์",
	"display.slot.embedded": "ฝัง",
	"display.animate_preview": "ตัวอย่างแอนิเมชัน",
	"display.reference.flower_pot": "กระถางดอกไม้",
	"data.generated_item_mesh": "โมเดลไอเทมจากเทกซ์เจอร์",
	"message.generated_item_model.title": "โมเดลไอเทมจากเทกซ์เจอร์",
	"message.generated_item_model.message": "Minecraft สร้างรูปทรงไอเทมนี้จากเทกซ์เจอร์ โมเดลจึงไม่มีชิ้นงานให้แก้ไข สิ่งที่เห็นเป็นเพียงภาพตัวอย่าง และจะไม่ถูกส่งออก\n\nถ้าต้องการเปลี่ยนหน้าตาไอเทมในเกม ให้แก้ไขเทกซ์เจอร์",
	"message.generated_item_model.edit_texture": "แก้ไขเทกซ์เจอร์",
	"message.generated_item_model.convert": "แปลงเป็นโมเดลที่แก้ไขได้",
	"message.convert_generated_item_model.title": "แปลงเป็นโมเดลที่แก้ไขได้",
	"message.convert_generated_item_model.message": "สร้างชิ้นงานจริงโดยเพิ่มความหนาให้รูปภาพเทกซ์เจอร์ จากนั้นคุณจะแก้ไขรูปทรงไอเทมใน 3D ได้\n\nถ้าแค่อยากเปลี่ยนหน้าตาไอเทม ไม่จำเป็นต้องแปลงโมเดล ให้แก้เทกซ์เจอร์ได้เลย แล้ว Minecraft จะสร้างรูปทรงจากภาพให้ต่อไป",
	"message.convert_generated_item_model.confirm": "สร้างรูปทรงจากเทกซ์เจอร์",
	"message.generated_item_model_conflict.title": "โมเดลไอเทมจากเทกซ์เจอร์",
	"message.generated_item_model_conflict.message": "Minecraft ใช้รูปทรงที่สร้างจากเทกซ์เจอร์ร่วมกับชิ้นงานที่เพิ่มเองไม่ได้ ตอนนี้โมเดลมีชิ้นงานแล้ว เกมจึงจะไม่แสดงรูปทรงที่สร้างจากเทกซ์เจอร์",
	"message.generated_item_model_conflict.convert": "แปลงรูปทรงจากเทกซ์เจอร์เป็นคิวบ์",
	"message.generated_item_model_conflict.convert.desc": "สร้างคิวบ์ตามรูปภาพเทกซ์เจอร์ เพื่อเก็บรูปทรงส่วนนี้ไว้ด้วย",
	"message.generated_item_model_conflict.remove": "ลบรูปทรงที่สร้างจากเทกซ์เจอร์",
	"message.generated_item_model_conflict.remove.desc": "ลบตัวอย่างและเริ่มสร้างโมเดลไอเทมใหม่ตั้งแต่ต้น",
	"message.generated_item_model_conflict.keep": "เก็บไว้ดูเป็นตัวอย่าง",
	"message.generated_item_model_conflict.keep.desc": "แสดงเฉพาะใน Blockbench โดยไม่ส่งออก",
	"message.add_reference_image.globally": "เพิ่มสำหรับทุกโปรเจกต์",
	"dialog.extrude.orientation.upright_z": "ตั้งบนระนาบ YZ",
	"dialog.extrude.depth": "ความลึก",
	"dialog.add_primitive.shape.icosphere": "ทรงกลมแบ่งหน้าสามเหลี่ยม (Icosphere)",
	"dialog.add_primitive.shape.octahedron": "ทรงแปดหน้า",
	"dialog.add_primitive.shape.dodecahedron": "ทรงสิบสองหน้า",
	"dialog.add_primitive.detail": "ความละเอียดรูปทรง",
	"dialog.plugins.update": "อัปเดต",
	"dialog.plugins.update_available": "มีอัปเดตพร้อมใช้งาน",
	"dialog.create_variable_placeholder.variable": "ตัวแปร",
	"dialog.create_variable_placeholder.type": "ชนิด",
	"dialog.create_variable_placeholder.type.value": "ค่า",
	"dialog.create_variable_placeholder.type.slider": "แถบเลื่อน",
	"dialog.create_variable_placeholder.type.toggle": "สวิตช์เปิด/ปิด",
	"dialog.create_variable_placeholder.type.impulse": "เปิดชั่วครู่แล้วปิด",
	"dialog.create_variable_placeholder.value": "ค่า",
	"dialog.create_variable_placeholder.duration": "ระยะเวลา",
	"dialog.create_variable_placeholder.step": "ปรับครั้งละ",
	"dialog.create_variable_placeholder.range": "ช่วงค่า",
	"dialog.create_variable_placeholder.output": "ผลลัพธ์",
	"dialog.view_built_in_variables.function": "ต้องระบุพารามิเตอร์",
	"dialog.advanced_screenshot.export": "ส่งออก",
	"dialog.preview_options.show_element_markers": "แสดงเครื่องหมายชิ้นงาน",
	"dialog.preview_options.show_element_markers.desc": "แสดงเครื่องหมายบอกตำแหน่งของกระดูก ออบเจกต์เปล่า และจุดอ้างอิง",
	"settings.maximum_zoom_distance": "ระยะซูมออกสูงสุด",
	"settings.maximum_zoom_distance.desc": "ระยะไกลที่สุดที่กล้องสามารถซูมออกจากโมเดลได้",
	"settings.constant_outlines": "แสดงเส้นขอบเสมอ",
	"settings.constant_outlines.desc": "แสดงเส้นขอบชิ้นงานเสมอ ไม่ว่าจะเลือกอยู่หรือไม่",
	"settings.new_project_dialog": "แสดงหน้าตั้งค่าโปรเจกต์ใหม่",
	"settings.new_project_dialog.desc": "เปิดหน้าตั้งค่าโปรเจกต์เมื่อสร้างโปรเจกต์ใหม่",
	"settings.opacity_range": "ช่วงค่าความทึบ",
	"settings.opacity_range.desc": "เลือกช่วงค่าที่ใช้ควบคุมความทึบของเลเยอร์และแปรง",
	"settings.automatic_plugin_updates": "อัปเดตปลั๊กอินอัตโนมัติ",
	"settings.automatic_plugin_updates.desc": "อัปเดตปลั๊กอินให้เป็นเวอร์ชันล่าสุดโดยอัตโนมัติ",
	"settings.native_window_frame": "กรอบหน้าต่างของระบบ",
	"settings.native_window_frame.desc": "ใช้กรอบหน้าต่างตามรูปแบบของระบบปฏิบัติการ",
	"keybind.preview_scroll_pan": "ใช้การเลื่อนเพื่อเลื่อนมุมมอง",
	"keybind.preview_scroll_pan.desc": "ใช้ล้อเลื่อนหรือสองนิ้วบนแทร็คแพดเลื่อนมุมมอง",
	"action.position_slider_per_element": "ปรับตำแหน่งแยกแต่ละชิ้น",
	"action.position_slider_per_element.desc": "เมื่อเปิด ช่องตำแหน่งจะปรับค่าแยกให้แต่ละชิ้นงาน เมื่อปิด ส่วนที่เลือกจะย้ายไปด้วยกันตามแกนที่กำหนด",
	"action.origin_slider_direct_values": "เปลี่ยนค่าจุดหมุนโดยตรง",
	"action.origin_slider_direct_values.desc": "เมื่อเปิด การย้ายจุดหมุนจะเปลี่ยนตำแหน่งชิ้นงานตามไปด้วย เมื่อปิด โปรแกรมจะชดเชยตำแหน่งให้ชิ้นงานอยู่ที่เดิม",
	"action.brush_lock_mode": "โหมดล็อกแปรง",
	"action.brush_lock_mode.none": "ไม่ล็อก",
	"action.brush_lock_mode.element": "ระบายเฉพาะชิ้นงานนี้",
	"action.brush_lock_mode.face": "ระบายเฉพาะหน้านี้",
	"action.slider_brush_aspect_ratio": "สัดส่วนความกว้าง/สูงของแปรง",
	"action.slider_brush_aspect_ratio.desc": "อัตราส่วนความกว้างต่อความสูงของแปรง",
	"action.screen_space_brush_projection": "ระบายสีตามมุมที่เห็น",
	"action.screen_space_brush_projection.desc": "ฉายรอยแปรงจากมุมมองบนหน้าจอลงบนผิวโมเดล",
	"action.close_other_projects": "ปิดแท็บอื่น",
	"action.close_other_projects.desc": "ปิดทุกโปรเจกต์ยกเว้นแท็บปัจจุบัน",
	"action.close_projects_to_right": "ปิดแท็บทางขวา",
	"action.close_projects_to_right.desc": "ปิดแท็บโปรเจกต์ทั้งหมดที่อยู่ทางขวาของแท็บปัจจุบัน",
	"action.extrude_texture_to_model": "สร้างรูปทรงจากเทกซ์เจอร์",
	"action.extrude_texture_to_model.desc": "สร้างโมเดลโดยเพิ่มความหนาให้รูปภาพเทกซ์เจอร์นี้",
	"action.experimental_settings": "การตั้งค่าทดลอง",
	"action.experimental_settings.desc": "ปรับแต่งการตั้งค่าทดลองสำหรับนักพัฒนา",
	"action.convert_texture_mesh_to_cubes": "แปลงรูปทรงเทกซ์เจอร์เป็นคิวบ์",
	"action.convert_texture_mesh_to_cubes.desc": "แทนเมชเทกซ์เจอร์ด้วยคิวบ์ที่สร้างตามรูปภาพ โดยคงตำแหน่งเดิมไว้",
	"action.flip_in_place": "พลิกอยู่กับที่ %0",
	"action.flip_in_place.desc": "พลิกชิ้นงานที่เลือกตามแกน %0 โดยไม่ย้ายไปตำแหน่งอื่น",
	"action.create_layer_group": "สร้างกลุ่มเลเยอร์",
	"action.resolve_layer_group": "แยกกลุ่มเลเยอร์",
	"action.preview_models": "โมเดลอ้างอิง",
	"action.preview_models.desc": "เลือกและแก้ไขโมเดลอ้างอิง",
	"action.keyframe_select_before_playhead": "เลือกคีย์เฟรมก่อนเวลาปัจจุบัน",
	"action.keyframe_select_before_playhead.desc": "เลือกคีย์เฟรมทั้งหมดที่อยู่ตรงหรือก่อนตำแหน่งเวลาเล่นปัจจุบัน",
	"action.keyframe_select_after_playhead": "เลือกคีย์เฟรมหลังเวลาปัจจุบัน",
	"action.keyframe_select_after_playhead.desc": "เลือกคีย์เฟรมทั้งหมดที่อยู่ตรงหรือหลังตำแหน่งเวลาเล่นปัจจุบัน",
	"action.set_ik_pole": "ตั้งทิศทางข้อพับ IK",
	"action.set_ik_pole.desc": "เลือกจุดที่ใช้กำหนดว่าเข่าหรือข้อศอกจะหันไปทางไหน ขณะขยับชุดกระดูกด้วย IK",
	"action.create_variable_placeholder": "เพิ่มตัวแปรสำหรับดูตัวอย่าง",
	"action.create_variable_placeholder.desc": "เพิ่มตัวแปรและกำหนดค่าเพื่อทดลองดูผลในตัวอย่างแอนิเมชัน",
	"action.view_built_in_variables": "ดูตัวแปรที่โปรแกรมเตรียมให้",
	"action.view_built_in_variables.desc": "ดูตัวแปรและค่าที่ Blockbench กำหนดให้อัตโนมัติระหว่างแสดงตัวอย่างแอนิเมชัน",
	"menu.paint": "ระบายสี",
	"menu.brush_presets.screen_space": "แปรงระบายตามมุมมอง",
	"edit.loop_cut.spacing": "ระยะห่าง",
	"edit.loop_cut.spacing.proportional": "ตามสัดส่วน",
	"edit.loop_cut.spacing.even_start": "ห่างเท่ากัน — นับจากต้น",
	"edit.loop_cut.spacing.even_end": "ห่างเท่ากัน — นับจากท้าย",
	"cube.shade_direction_override": "ใช้ทิศทางแรเงาเดียวกันทุกหน้า",
	"cube.shade_direction_override.desc": "แรเงาทุกหน้าของคิวบ์เหมือนหันไปทางที่เลือก ถ้าไม่กำหนด แต่ละหน้าจะแรเงาตามทิศทางจริง การตั้งค่านี้ไม่เปลี่ยนเงาตามซอกหรือแสงที่ขึ้นกับระดับความสว่าง",
	"null_object.ik_target": "ปลายทางที่ IK ควบคุม",
	"null_object.ik_source": "กระดูกต้นทาง IK",
	"null_object.ik_pole": "จุดควบคุมทิศทางข้อพับ IK",
	"reference_image.layer.scene": "ฉากสามมิติ",
	"reference_image.view_mode": "โหมดการแสดงผล",
	"reference_image.view_mode.flat_image": "ภาพแบน",
	"reference_image.cull_backface": "ซ่อนด้านหลัง",
	"codec.common.merge_armature_mesh": "รวมเมชที่ใช้โครงกระดูกเดียวกัน",
	"preview_model.transform": "ย้าย / หมุน / ปรับขนาด",
	"preview_model.reset_transform": "รีเซ็ตตำแหน่ง การหมุน และขนาด",
	"preview_model.minecraft_player": "ผู้เล่น Minecraft",
	"dialog.generate_pbr_map.channel": "ช่อง PBR",
	"dialog.generate_pbr_map.channel.metalness": "ความเป็นโลหะ",
	"dialog.generate_pbr_map.channel.emissive": "แสงเรือง",
	"dialog.generate_pbr_map.channel.roughness": "ความหยาบ",
	"dialog.generate_pbr_map.method": "แหล่งที่มา",
	"dialog.generate_pbr_map.method.value": "ค่า",
	"dialog.generate_pbr_map.method.brightness": "ความสว่าง",
	"dialog.generate_pbr_map.method.saturation": "ความสดของสี",
	"dialog.generate_pbr_map.method.hue": "เฉดสี",
	"dialog.generate_pbr_map.method.red": "สีแดง",
	"dialog.generate_pbr_map.method.green": "สีเขียว",
	"dialog.generate_pbr_map.method.blue": "สีน้ำเงิน",
	"dialog.generate_pbr_map.method.empty": "ว่างเปล่า",
	"dialog.generate_pbr_map.in_range": "ช่วงค่าต้นทาง",
	"dialog.generate_pbr_map.out_range": "ช่วงค่าผลลัพธ์",
	"dialog.generate_pbr_map.invert": "กลับค่า",
	"dialog.generate_pbr_map.preset": "พรีเซ็ต",
	"dialog.generate_pbr_map.preset.apply_preset": "ใช้พรีเซ็ต",
	"dialog.generate_pbr_map.update_values": "อัปเดตด้วยค่าปัจจุบัน",
	"dialog.generate_pbr_map.preset.new_preset": "พรีเซ็ตใหม่...",
	"action.image_editor_checkerboard": "ลายตารางหมากรุก",
	"action.image_editor_checkerboard.desc": "แสดงหรือซ่อนพื้นหลังตารางหมากรุกในพื้นที่ทำงาน 2D",
	"message.child_model_only.resolve": "จะจัดการโมเดลแม่ยังไง?",
	"message.child_model_only.resolve.desc": "เอาของจาก Parent ทุกตัวมารวมไว้ในไฟล์ที่ผมกำลังเปิดเลย",
	"message.child_model_only.open.desc": "เปิดไฟล์ Parent อีกแท็บหนึ่ง แต่ไม่เอามันมารวมกับไฟล์ปัจจุบัน",
	"action.brush_lock_mode.selected_faces": "ให้แปรงวาดได้เฉพาะ Face ที่เราเลือกไว้",
	"reference_image.view_mode.plane": "3D Plane",
	"preview_model.minecraft_crafting_table": "Minecraft Crafting Table",
	"dialog.extrude.animated": "Animated Texture",
	"dialog.scale.box_uv_warning_required": "Scaling cubes that use Box UV may break the UV mapping. Instead, try to scale your model during implementation, or use Inflate.",
	"menu.color_picker.picker_type.wheel_static": "Wheel (Static)"
}